import {
  EDateFilterOptions,
  EDeliverableStatus,
  ETicketStatus,
  ENotificationType,
  EActivityReportOptions,
  EQuestionReportOptions,
  EExamGroupsType,
  ESectionTrackStatus,
  ERoles,
  ECountry,
  ENationality,
  EYearMonths,
  EQuizMode,
  EActivityAuditStatus,
  EStudyField,
  EVerticalNames,
  ETimePreference,
  EEventWeekdays,
  EActivityType,
  EInternalNoteType,
  ETeacherStatus,
  EExamGroupStatus,
  EExamGroupLinkType,
  EStudentConnectionStatus,
  EOnboardingDiscoverySource,
  EOnboardingChosenReason,
  ELegacyOnboardingChosenReason,
  EStudentSatisfactionStatus,
  EStudentActivationStatus,
  ESalaryRange,
  EGender,
  ELegalIdType,
  EStreetType,
  EProvinceExtension
} from '@constants';
import { EProvince, EAutonomousCommunity, EStudentPaymentStatus } from '@constants';

export const DefaultTranslations = {
  NAME: {
    en: 'Name',
    es: 'Nombre',
    cat: 'Nom',
    eus: 'Izena',
    pt: 'Nome'
  },
  REGION_ES: {
    es: 'España',
    en: 'Spain',
    cat: 'Espanya',
    eus: 'Espainia',
    pt: 'Espanha'
  },
  REGION_PT: {
    es: 'Portugal',
    en: 'Portugal',
    cat: 'Portugal',
    eus: 'Portugal',
    pt: 'Portugal'
  },
  LAST_NAME: {
    en: 'Last name',
    es: 'Apellido',
    cat: 'Cognom',
    eus: 'Abizena',
    pt: 'Apelido'
  },
  EMAIL: {
    es: 'Correo electrónico',
    en: 'Email',
    cat: 'Correu electrònic',
    eus: 'Emaila',
    pt: 'Email electrónico'
  },
  PASSWORD: {
    es: 'Contraseña',
    en: 'Password',
    cat: 'Contrasenya',
    eus: 'Pasahitza',
    pt: 'Palavra-passe'
  },
  LOADING: {
    es: 'Cargando...',
    en: 'Loading...',
    cat: 'Carregant...',
    eus: 'Kargatzen...',
    pt: 'Carregando...'
  },
  SEARCH: {
    en: 'Search',
    es: 'Buscar...',
    cat: 'Cercar...',
    eus: 'Bilatu...',
    pt: 'Pesquisar...'
  },
  REQUIRED_FIELD: {
    es: 'Campo requerido',
    en: 'Required field',
    cat: 'Camp requerit',
    eus: 'Beharrezko eremua',
    pt: 'Campo obrigatório'
  },
  REQUIRED_QUESTION: {
    es: 'Por favor, responde a esta pregunta',
    en: 'Please answer this question  ',
    cat: 'Per favor, respon a aquesta pregunta',
    eus: 'Mesedez, erantzun galdera hau',
    pt: 'Por favor, responda a esta pergunta'
  },
  WRONG_FORMAT_URL: {
    es: 'Formato de URL incorrecto',
    en: 'Wrong URL format',
    cat: 'Format de URL incorrecte',
    eus: 'URL formatu okerra',
    pt: 'Formato de URL incorrecto'
  },
  INVALID_EMAIL_FORMAT: {
    es: 'El email no es válido',
    en: 'The email is not valid',
    cat: "L'email no és vàlid",
    eus: 'Email ez da baliozkoa',
    pt: 'O email não é válido'
  },
  YES: {
    es: 'Sí',
    en: 'Yes',
    cat: 'Sí',
    eus: 'Bai',
    pt: 'Sim'
  },
  NO: {
    es: 'No',
    en: 'No',
    cat: 'No',
    eus: 'Ez',
    pt: 'Não'
  },
  POSITION: {
    es: 'Posición',
    en: 'Position',
    cat: 'Posició',
    eus: 'Posizioa',
    pt: 'Posição'
  },
  SELECT_DATE: {
    es: 'Seleccionar fecha',
    en: 'Select date',
    cat: 'Seleccionar data',
    eus: 'Hautatu data',
    pt: 'Selecionar data'
  },
  SELECT_USER: {
    es: 'Selecciona un usuario',
    en: 'Select a user',
    cat: 'Selecciona un usuari',
    eus: 'Erabiltzaile bat hautatu',
    pt: 'Selecionar um usuário'
  },
  ACCOUNT_STATUS: {
    es: 'Estado',
    en: 'Status',
    cat: 'Estat',
    eus: 'Egoera',
    pt: 'Estado'
  },
  ACTIVE_ACCOUNT: {
    es: 'Cuenta activa',
    en: 'Active account',
    cat: 'Compte actiu',
    eus: 'Kontu aktibo',
    pt: 'Conta ativa'
  },
  INACTIVE_ACCOUNT: {
    es: 'Cuenta inactiva',
    en: 'Inactive account',
    cat: 'Compte inactiu',
    eus: 'Kontu erabiltzen ez dena',
    pt: 'Conta inativa'
  },
  SAVE: {
    es: 'Guardar',
    en: 'Save',
    cat: 'Desar',
    eus: 'Gorde',
    pt: 'Guardar'
  },
  SAVE_CHANGES: {
    es: 'Guardar cambios',
    en: 'Save changes',
    cat: 'Desa els canvis',
    eus: 'Aldaketak Gorde',
    pt: 'Guardar alterações'
  },
  CHANGES_SAVED: {
    es: 'Cambios guardados',
    en: 'Changes saved',
    cat: 'Canvis desats',
    eus: 'Aldaketak gorde',
    pt: 'Alterações salvas'
  },
  CANCEL: {
    es: 'Cancelar',
    en: 'Cancel',
    cat: 'Cancel·lar',
    eus: 'Utzi',
    pt: 'Cancelar'
  },
  CLOSE: {
    es: 'Cerrar',
    en: 'Close',
    cat: 'Tanca',
    eus: 'Itxi',
    pt: 'Fechar'
  },
  PROFILE: {
    es: 'Perfil',
    en: 'Profile',
    cat: 'Perfil',
    eus: 'Profila',
    pt: 'Perfil'
  },
  ACCOUNT: {
    es: 'Cuenta',
    en: 'Account',
    cat: 'Compte',
    eus: 'Kontua',
    pt: 'Conta'
  },
  LOGOUT: {
    es: 'Cerrar sesión',
    en: 'Logout',
    cat: 'Tanca la sessió',
    eus: 'Saioa itxi',
    pt: 'Sair'
  },
  CHANGE_PASSWORD: {
    es: 'Cambiar contraseña',
    en: 'Change password',
    cat: 'Canviar contrasenya',
    eus: 'Aldatu pasahitza',
    pt: 'Alterar palavra-passe'
  },
  PROFILE_UPDATED: {
    es: 'Perfil actualizado 😀',
    en: 'Profile updated 😀',
    cat: 'Perfil actualitzat 😀',
    eus: 'Profila eguneratuta 😀',
    pt: 'Perfil actualizado 😀'
  },
  CURRENT_PASSWORD: {
    es: 'Contraseña actual',
    en: 'Current password',
    cat: 'Contrasenya actual',
    eus: 'Gaurko pasahitza',
    pt: 'Palavra-passe atual'
  },
  NEW_PASSWORD: {
    es: 'Nueva contraseña',
    en: 'New password',
    cat: 'Nova contrasenya',
    eus: 'Pasahitz berria',
    pt: 'Palavra-passe nova'
  },
  CONFIRM_PASSWORD: {
    es: 'Confirmar contraseña',
    en: 'Confirm password',
    cat: 'Confirmar contrasenya',
    eus: 'Pasahitza baieztatu',
    pt: 'Confirmar palavra-passe'
  },
  PASSWORDS_NOT_MATCH: {
    es: 'Las contraseñas no coinciden',
    en: 'Passwords do not match',
    cat: 'Les contrasenyes no coincideixen',
    eus: 'Pasahitzak ez datoz bat',
    pt: 'As palavras-passe não coincidem'
  },
  PASSWORD_UPDATED: {
    es: 'Contraseña actualizada',
    en: 'Password updated',
    cat: 'Contrasenya actualitzada',
    eus: 'Pasahitza eguneratuta',
    pt: 'Palavra-passe atualizada'
  },
  UPDATE_PASSWORD: {
    es: 'Actualizar contraseña',
    en: 'Update password',
    cat: 'Actualitzar contrasenya',
    eus: 'Pasahitza eguneratu',
    pt: 'Atualizar palavra-passe'
  },
  LOG_OUT: {
    es: 'Cerrar sesión',
    en: 'Log out',
    cat: 'Tancar sessió',
    eus: 'Saioa itxi',
    pt: 'Sair'
  },
  LOG_OUT_CONFIRM: {
    es: '¿Estás seguro que deseas cerrar sesión?',
    en: 'Are you sure you want to log out?',
    cat: 'N`estàs segur que vols tancar sessió?',
    eus: 'Ziur zaude saioa itxi nahi duzula?',
    pt: 'Tem certeza que deseja sair?'
  },
  USERNAME: {
    es: 'Nombre de usuario',
    en: 'Username',
    cat: 'Nom d`usuari',
    eus: 'Erabiltzaile izena',
    pt: 'Nome de usuário'
  },
  REGION: {
    es: 'Región',
    en: 'Region',
    cat: 'Regió',
    eus: 'Eremua',
    pt: 'Região'
  },
  AUDIO_CAN_NOT_BE_LOADED: {
    es: 'No se ha podido cargar el archivo de audio',
    en: 'Audio file could not be loaded',
    cat: 'No s`ha pogut carregar l`arxiu d`àudio',
    eus: 'Audio fitxategia ezin izan da kargatu',
    pt: 'O arquivo de áudio não pôde ser carregado'
  },
  SELECT_COURSE: {
    es: 'Seleccionar curso...',
    en: 'Select course...',
    cat: 'Selecciona curs...',
    eus: 'Hautatu ikastaroa...',
    pt: 'Selecione um curso...'
  },
  MY_PROFILE: {
    es: 'Mi perfil',
    en: 'My profile',
    cat: 'El meu perfil',
    eus: 'Nire profila',
    pt: 'O meu perfil'
  },
  EDIT_PROFILE: {
    es: 'Editar perfil',
    en: 'Edit profile',
    cat: 'Editar perfil',
    eus: 'Profila editatu',
    pt: 'Editar perfil'
  },
  DAY_STREAK: {
    es: 'día seguido',
    en: 'day in a row',
    cat: 'dia seguit',
    eus: 'egun segidan',
    pt: 'dia seguido'
  },
  DAYS_STREAK: {
    es: 'días seguidos',
    en: 'days in a row',
    cat: 'dies seguits',
    eus: 'egun segidan',
    pt: 'dias seguidos'
  },
  DASHBOARD: {
    es: 'Dashboard',
    en: 'Dashboard',
    cat: 'Tauler',
    eus: 'Kontroletxe',
    pt: 'Painel de controle'
  },
  MY_FORMATION: {
    es: 'Mi formación',
    en: 'My formation',
    cat: 'La meva formació',
    eus: 'Nire formakuntza',
    pt: 'A minha formação'
  },
  EXPLORE: {
    es: 'Explorar',
    en: 'Explore',
    cat: 'Explorar',
    eus: 'Bilatu',
    pt: 'Explorar'
  },
  TAGS: {
    es: 'Formaciones',
    en: 'Tags',
    cat: 'Formacions',
    eus: 'Formakuntzak',
    pt: 'Formaturas'
  },
  OTHER: {
    es: 'Otro',
    en: 'Other',
    cat: 'Altres',
    eus: 'Besteak',
    pt: 'Outros'
  },
  [ETicketStatus.NEW]: {
    es: 'Nueva',
    en: 'Open',
    cat: 'Nova',
    eus: 'Irekita',
    pt: 'Aberto'
  },
  [ETicketStatus.IN_PROGRESS]: {
    es: 'En curso',
    en: 'In progress',
    cat: 'En curs',
    eus: 'Hasiera bidean',
    pt: 'Em curso'
  },
  [ETicketStatus.CLOSED_NOT_RESOLVED]: {
    es: 'No resuelta',
    en: 'Not resolved',
    cat: 'No resolta',
    eus: 'Ez da konpondu',
    pt: 'Não resolvido'
  },
  [ETicketStatus.CLOSED_RESOLVED]: {
    es: 'Resuelta',
    en: 'Resolved',
    cat: 'Resolta',
    eus: 'Ebaztuta',
    pt: 'Resolvido'
  },
  YOU_HAVE_NOT_CREATED_DOUBT_TICKETS: {
    es: 'No hay dudas abiertas',
    en: 'There are no open doubts',
    cat: 'No hi ha dubtes oberts',
    eus: 'Ez dago zalantzarik ireki',
    pt: 'Não há dúvidas abertas'
  },
  SOMETHING_WENT_WRONG: {
    es: 'Algo salió mal',
    en: 'Something went wrong',
    cat: 'Alguna cosa ha anat malament',
    eus: 'Zerbait gaizki joan da',
    pt: 'Algo saiu mal'
  },
  UNKNOW_ERROR: {
    es: 'Error desconocido',
    en: 'Unknown error',
    cat: 'Error desconegut',
    eus: 'Errore ezezaguna',
    pt: 'Erro desconhecido'
  },
  RELOAD_COMPONENT: {
    es: 'Recargar componente',
    en: 'Reload component',
    cat: 'Recarregar component',
    eus: 'Komponentea berriz kargatu',
    pt: 'Recarregar componente'
  },
  DATE: {
    es: 'Fecha',
    en: 'Date',
    cat: 'Data',
    eus: 'Data',
    pt: 'Data'
  },
  TIME: {
    es: 'Hora',
    en: 'Time',
    cat: 'Hora',
    eus: 'Ordua',
    pt: 'Hora'
  },
  SPANISH: {
    es: 'Español',
    en: 'Spanish',
    cat: 'Espanyol',
    eus: 'Espainiera',
    pt: 'Português'
  },
  ENGLISH: {
    es: 'Inglés',
    en: 'English',
    cat: 'Anglès',
    eus: 'Ingelesa',
    pt: 'Inglês'
  },
  CATALAN: {
    es: 'Catalán',
    en: 'Catalan',
    cat: 'Català',
    eus: 'Katalana',
    pt: 'Catalão'
  },
  EUSKERA: {
    es: 'Euskera',
    en: 'Basque',
    cat: 'Euskera',
    eus: 'Euskara',
    pt: 'Basco'
  },
  ASK_FOR_HELP: {
    es: 'Pedir ayuda',
    en: 'Ask for help',
    cat: 'Demanar ajuda',
    eus: 'Laguntza eskatu',
    pt: 'Pedir ajuda'
  },
  HELP_CENTER: {
    es: 'Centro de ayuda',
    en: 'Help center',
    cat: 'Centre d`ajuda',
    eus: 'Laguntza zentroa',
    pt: 'Centro de ajuda'
  },
  SORRY_WE_ARE_WORKING_WE_WILL_BE_BACK_SOON: {
    es: 'Estamos trabajando en una actualización del campus virtual que te va a ENCANTAR. Necesitamos unas horas para subirlo ¡Acabamos cuánto antes!',
    en: 'We are working on an update of the virtual campus that you will LOVE. We need a few hours to upload it. We will finish as soon as possible!',
    cat: 'Estem treballant en una actualització del campus virtual que t`ENCANTARÀ. Necessitem unes hores per pujar-ho. Acabem aviat!',
    eus: 'Campus birtualaren eguneratze baten lan egiten ari gara, zure gustukoa izango dena. Ordu gutxi behar ditugu igo dezagun. Aurrera!',
    pt: 'Estamos a trabalhar numa actualização do campus virtual que vai encantar-te. Precisamos de algumas horas para o subir. Terminamos o mais rapidamente possível!'
  },
  MAINTENANCE_MODE: {
    es: 'Modo mantenimiento',
    en: 'Maintenance mode',
    cat: 'Mode de manteniment',
    eus: 'Mantentze modua',
    pt: 'Modo de manutenção'
  },
  SECTION: {
    es: 'Sección',
    en: 'Section',
    cat: 'Secció',
    eus: 'Atala',
    pt: 'Secção'
  },
  COURSE: {
    es: 'Curso',
    en: 'Course',
    cat: 'Curs',
    eus: 'Ikastaroa',
    pt: 'Curso'
  },
  ACTIVITY: {
    es: 'Actividad',
    en: 'Activity',
    cat: 'Activitat',
    eus: 'Jarduerak',
    pt: 'Atividade'
  },
  SELECT_RELATED_CONTENT: {
    es: 'Seleccionar contenido relacionado',
    en: 'Select related content',
    cat: 'Selecciona contingut relacionat',
    eus: 'Hautatu eduki lotura',
    pt: 'Selecionar conteúdo relacionado'
  },
  [EDeliverableStatus.DELIVERED]: {
    es: 'Entregado',
    en: 'Delivered',
    cat: 'Lliurat',
    eus: 'Entregatua',
    pt: 'Entregado'
  },
  [EDeliverableStatus.IN_REVIEW]: {
    es: 'En revisión',
    en: 'In review',
    cat: 'En revisió',
    eus: 'Berrikuspenetan',
    pt: 'Em revisão'
  },
  [EDeliverableStatus.COMPLETED]: {
    es: 'Completado',
    en: 'Completed',
    cat: 'Completat',
    eus: 'Osatu',
    pt: 'Completo'
  },
  SELECT_COURSE_OR_TAG: {
    es: 'Selecciona un curso o una etiqueta',
    en: 'Select a course or a tag',
    cat: 'Selecciona un curs o una etiqueta',
    eus: 'Hautatu ikastaro bat edo etiketa bat',
    pt: 'Selecione um curso ou uma etiqueta'
  },
  ASSIGN_COURSE: {
    es: 'Asignar curso',
    en: 'Assign course',
    cat: 'Assignar curs',
    eus: 'Ikastaroa asignatu',
    pt: 'Atribuir curso'
  },
  COURSES_ASSOCIATED_TO_TAG_SUCCESSFULLY: {
    es: 'Cursos asociados a la etiqueta "{{tag}}" asignados correctamente.',
    en: 'Courses associated to the tag "{{tag}}" assigned successfully.',
    cat: 'Cursos associats a l`etiqueta "{{tag}}" assignats correctament.',
    eus: 'Tag-arekin elkargatutako ikastaroak ongi asignatu dira "{{tag}}" erabiliz.',
    pt: 'Cursos associados à etiqueta "{{tag}}" atribuídos com sucesso.'
  },
  SEARCH_PLACEHOLDER: {
    es: 'Buscar',
    en: 'Search',
    cat: 'Cercar',
    eus: 'Bilatu',
    pt: 'Pesquisar'
  },
  NAME_AND_LASTNAME: {
    es: 'Nombre y apellido',
    en: 'Name and lastname',
    cat: 'Nom i cognom',
    eus: 'Izena eta abizena',
    pt: 'Nome e apelido'
  },
  LASTNAME: {
    es: 'Apellido',
    en: 'Lastname',
    cat: 'Cognom',
    eus: 'Abizena',
    pt: 'Apelido'
  },
  SECOND_LASTNAME: {
    es: 'Segundo apellido',
    en: 'Second lastname',
    cat: 'Segon cognom',
    eus: 'Bigarren abizena',
    pt: 'Segundo apelido'
  },
  NO_SECOND_LASTNAME: {
    es: 'No tengo segundo apellido',
    en: "I don't have a second lastname",
    cat: 'No tinc segon cognom',
    eus: 'Ez dut bigarren abizenik',
    pt: 'Não tenho segundo apelido'
  },
  IT_HAS_NO_SECOND_LASTNAME: {
    es: 'No tiene segundo apellido',
    en: 'It has no second lastname',
    cat: 'No té segon cognom',
    eus: 'Ez du bigarren abizenik',
    pt: 'Não tem segundo apelido'
  },
  REQUIRED_SECOND_LASTNAME: {
    es: 'Por favor, completa el campo Segundo apellido',
    en: 'Please complete the Second lastname field',
    cat: 'Si us plau, completa el camp Segon cognom',
    eus: 'Mesedez, bete Bigarren abizena eremua',
    pt: 'Por favor, complete o campo Segundo apelido'
  },
  INSCRIPTION_DATE: {
    es: 'Fecha de inscripción',
    en: 'Inscription date',
    cat: 'Data d`inscripció',
    eus: 'Izena eman den data',
    pt: 'Data de inscrição'
  },
  THERE_ARE_NOT_COURSES_ASOCIATED_TO_THIS_USER: {
    es: 'No hay cursos asociados a este usuario',
    en: 'There are no courses asociated to this user',
    cat: 'No hi ha cursos associats a aquest usuari',
    eus: 'Ez dago erabiltzaile honi atxikitako ikastaroik',
    pt: 'Não há cursos associados a este usuário'
  },
  NEW_STUDENT: {
    es: 'Nuevo estudiante',
    en: 'New student',
    cat: 'Nou estudiant',
    eus: 'Ikasle berria',
    pt: 'Novo aluno'
  },
  AUTO_GENERATED_USERNAME: {
    es: 'Nombre de usuario autogenerado, es posible que no sea único',
    en: 'Auto generated username, it is possible that it is not unique',
    cat: 'Nom d`usuari autogenerat, potser no és únic',
    eus: 'Erabiltzaile izen autogeneratua, posible da ez izatea bakarra',
    pt: 'Nome de usuário gerado automaticamente, é possível que não seja único'
  },
  CREATE_STUDENT: {
    es: 'Crear estudiante',
    en: 'Create student',
    cat: 'Crear estudiant',
    eus: 'Ikasle berria sortu',
    pt: 'Criar aluno'
  },
  NEW_STUDENT_ADDED: {
    es: 'Nuevo estudiante agregado a la academia',
    en: 'New student added to the academy',
    cat: 'Nou estudiant afegit a l`acadèmia',
    eus: 'Ikasle berria akademian gehitu da',
    pt: 'Novo aluno adicionado à academia'
  },
  USER_ALREADY_EXISTS: {
    es: 'Ups! Este email ya está en uso.',
    en: 'Ups! This email is already in use.',
    cat: 'Ups! Aquest email ja està en ús.',
    eus: 'Ups! Posta hau jadanik erabiltzen ari da.',
    pt: 'Ups! Este email já está em uso.'
  },
  STUDENTS_TOTAL_COUNT: {
    es: '{{total}} alumnos',
    en: '{{total}} students',
    cat: '{{total}} estudiants',
    eus: '{{total}} ikasleak',
    pt: '{{total}} alunos'
  },
  DELIVERABLES_TOTAL_COUNT: {
    es: '{{total}} entregables',
    en: '{{total}} deliverables',
    cat: '{{total}} lliurables',
    eus: '{{total}} entregagarriak',
    pt: '{{total}} entregáveis'
  },
  COURSES: {
    es: 'Cursos',
    en: 'Courses',
    cat: 'Cursos',
    eus: 'Ikastaroak',
    pt: 'Cursos'
  },
  STUDY_PROGRESS: {
    es: 'Progreso en el estudio',
    en: 'Study progress',
    cat: 'Progrés en l`estudi',
    eus: 'Ikasketetan aurrera egitea',
    pt: 'Progresso no estudo'
  },
  EDIT_STUDENT: {
    es: 'Editar alumno',
    en: 'Edit student',
    cat: 'Editar alumne',
    eus: 'Ikaslearen editatu',
    pt: 'Editar aluno'
  },
  ARE_YOU_SURE_TO_DELETE_USER: {
    es: '¿Estás seguro que deseas eliminar al usuario?',
    en: 'Are you sure you want to delete the user?',
    cat: 'N`estàs segur que vols eliminar l`usuari?',
    eus: 'Ziur zaude erabiltzailea ezabatu nahi duzula?',
    pt: 'Tem certeza que deseja eliminar o usuário?'
  },
  USER_DELETED_SUCCESSFULLY: {
    es: 'Usuario eliminado correctamente',
    en: 'User deleted successfully',
    cat: 'Usuari eliminat correctament',
    eus: 'Erabiltzailea ongi ezabatu da',
    pt: 'Usuário eliminado com sucesso'
  },
  REMOVE_STUDENT: {
    es: 'Eliminar alumno',
    en: 'Remove student',
    cat: 'Eliminar alumne',
    eus: 'Ikaslearen ezabatu',
    pt: 'Eliminar aluno'
  },
  REMOVE: {
    es: 'Eliminar',
    en: 'Remove',
    cat: 'Eliminar',
    eus: 'Kendu',
    pt: 'Eliminar'
  },
  PASSWORD_RESET_SUCCESS: {
    es: 'Contraseña reiniciada correctamente, el usuario recibirá un correo con la nueva contraseña',
    en: 'Password reset successfully, the user will receive an email with the new password',
    cat: 'Contrasenya reiniciada correctament, l`usuari rebrà un correu amb la nova contrasenya',
    eus: 'Pasahitza ongi berrezarri da, erabiltzaileak posta bat jasoko du pasahitz berriarekin',
    pt: 'Senha reiniciada com sucesso, o usuário receberá um email com a nova senha'
  },
  STUDENT_UPDATED_SUCCESSFULLY: {
    es: 'Estudiante actualizado correctamente',
    en: 'Student updated successfully',
    cat: 'Estudiant actualitzat correctament',
    eus: 'Ikaslea ongi eguneratuta',
    pt: 'Aluno atualizado com sucesso'
  },
  USER_PREVIEW_COULD_NOT_BE_LOADED: {
    es: 'No se pudo cargar la vista previa del usuario',
    en: 'User preview could not be loaded',
    cat: 'No s`ha pogut carregar la vista prèvia de l`usuari',
    eus: 'Ezin izan da erabiltzailearen aurrebista kargatu',
    pt: 'Não foi possível carregar a vista prévia do usuário'
  },
  RESET_STUDENT_PASSWORD: {
    es: 'Reiniciar contraseña',
    en: 'Reset student password',
    cat: 'Reiniciar contrasenya',
    eus: 'Ikaslearen pasahitza berrezarri',
    pt: 'Reiniciar senha do aluno'
  },
  ARE_YOU_SURE_TO_RESET_PASSWORD: {
    es: '¿Estás seguro que deseas reiniciar la contraseña?',
    en: 'Are you sure to reset password?',
    cat: 'N`estàs segur que vols reiniciar la contrasenya?',
    eus: 'Ziur zaude pasahitza berrezarri nahi duzula?',
    pt: 'Tem certeza que deseja reiniciar a senha?'
  },
  CONNECTION: {
    es: 'Conexión',
    en: 'Connection',
    cat: 'Connexió',
    eus: 'Konexioa',
    pt: 'Conexão'
  },
  ARE_YOU_SURE_YOU_REMOVE_SUBSCRIPTION: {
    es: '¿Estás seguro que deseas eliminar la suscripción?',
    en: 'Are you sure you remove subscription?',
    cat: 'N`estàs segur que vols eliminar la subscripció?',
    eus: 'Ziur zaude harpidetza kendu nahi duzula?',
    pt: 'Tem certeza que deseja eliminar a subscrição?'
  },
  ACCEPT: {
    es: 'Aceptar',
    en: 'Accept',
    cat: 'Accepta',
    eus: 'Onartu',
    pt: 'Aceitar'
  },
  [EDateFilterOptions.TODAY]: {
    es: 'Hoy',
    en: 'Today',
    cat: 'Avui',
    eus: 'Gaur',
    pt: 'Hoje'
  },
  [EDateFilterOptions.SEVEN_DAYS]: {
    es: '7 días',
    en: '7 days',
    cat: '7 dies',
    eus: '7 egun',
    pt: '7 dias'
  },
  [EDateFilterOptions.THIRTY_DAYS]: {
    es: '30 días',
    en: '30 days',
    cat: '30 dies',
    eus: '30 egun',
    pt: '30 dias'
  },
  [EDateFilterOptions.ONE_YEAR]: {
    es: '1 año',
    en: '1 year',
    cat: '1 any',
    eus: '1 urte',
    pt: '1 ano'
  },
  [EDateFilterOptions.PERSONALIZED]: {
    es: 'Personalizado',
    en: 'Personalized',
    cat: 'Personalitzat',
    eus: 'Pertsonalizatua',
    pt: 'Personalizado'
  },
  RESOLUTION_TIME: {
    es: 'Tiempo de resolución:',
    en: 'Resolution time:',
    cat: 'Temps de resolució:',
    eus: 'Ebazpen denbora:',
    pt: 'Tempo de resolução:'
  },
  FIRST_RESPONSE_TIME: {
    es: 'Tiempo de 1ª respuesta:',
    en: 'First response time:',
    cat: 'Temps de 1ª resposta:',
    eus: 'Lehenengo erantzun denbora:',
    pt: 'Tempo de resposta inicial:'
  },
  RESOLUTION_TIME_YEARS: {
    es: '{{years}} a',
    en: '{{years}} y',
    cat: '{{years}} anys',
    eus: '{{years}} urte',
    pt: '{{years}} anos'
  },
  RESOLUTION_TIME_MONTHS: {
    es: '{{months}} m',
    en: '{{months}} m',
    cat: '{{months}} mesos',
    eus: '{{months}} hilabete',
    pt: '{{months}} meses'
  },
  RESOLUTION_TIME_DAYS: {
    es: '{{days}} d',
    en: '{{days}} d',
    cat: '{{days}} dies',
    eus: '{{days}} egun',
    pt: '{{days}} dias'
  },
  RESOLUTION_TIME_HOURS: {
    es: '{{hours}} h',
    en: '{{hours}} h',
    cat: '{{hours}} hores',
    eus: '{{hours}} ordu',
    pt: '{{hours}} horas'
  },
  RESOLUTION_TIME_MINUTES: {
    es: '{{minutes}} min',
    en: '{{minutes}} min',
    cat: '{{minutes}} minuts',
    eus: '{{minutes}} minutu',
    pt: '{{minutes}} minutos'
  },
  TOTAL: {
    es: 'Total {{total}}',
    en: 'Total {{total}}',
    cat: 'Total {{total}}',
    eus: 'Guztira {{total}}',
    pt: 'Total {{total}}'
  },
  STATE: {
    es: 'Estatal',
    en: 'State',
    cat: 'Estat',
    eus: 'Estatu',
    pt: 'Estado'
  },
  SEND: {
    es: 'Enviar',
    en: 'Send',
    cat: 'Enviar',
    eus: 'Bidali',
    pt: 'Enviar'
  },
  SEND_DOCUMENT: {
    es: 'Enviar documento',
    en: 'Send document',
    cat: 'Enviar document',
    eus: 'Bidali dokumentua',
    pt: 'Enviar documento'
  },
  CONFIRM_UPLOAD_TITLE: {
    es: 'Confirmar envío',
    en: 'Confirm upload',
    cat: 'Confirmar enví',
    eus: 'Bidalera onartu',
    pt: 'Confirmar envio'
  },
  CONFIRM_UPLOAD_DESCRIPTION: {
    es: 'Vas a enviar {{filename}}. Una vez enviado, no será posible editarlo. Para realizar cambios, deberás contactar a nuestro equipo académico para que lo eliminen o reemplacen.',
    en: 'You are about to send {{filename}}. Once sent, it will not be possible to edit it. To make changes, you need to contact our academic team to delete or replace it.',
    cat: 'Estàs a punt d`enviar {{filename}}. Una vegada enviat, no podràs editar-lo. Per fer canvis, has de contactar amb el nostre equip acadèmic per eliminar-lo o reemplaçar-lo.',
    eus: '{{filename}} bidali dituzu. Bidalita, ezin da editatu. Aldaketak egiteko, gure ikastarako taldea kontaktuan jarri behar duzu itzaltzeko edo ordezkatzeko.',
    pt: 'Está prestes a enviar {{filename}}. Uma vez enviado, não será possível editá-lo. Para fazer alterações, você precisa contactar o nosso time acadêmico para excluí-lo ou substituí-lo.'
  },
  DONT_SHOW_AGAIN: {
    es: 'No volver a mostrar este mensaje',
    en: "Don't show this message again",
    cat: 'No tornar a mostrar aquest missatge',
    eus: 'Ez erakutsi mezu hau berriro',
    pt: 'Não mostrar esta mensagem novamente'
  },
  NOTIFICATIONS: {
    es: 'Notificaciones',
    en: 'Notifications',
    cat: 'Notificacions',
    eus: 'Jakinarazpenak',
    pt: 'Notificações'
  },
  RECEIVED: {
    es: 'Recibidas',
    en: 'Received',
    cat: 'Rebudes',
    eus: 'Jasoak',
    pt: 'Recebidas'
  },
  UNREAD: {
    es: 'No leídas',
    en: 'Unread',
    cat: 'No llegides',
    eus: 'Irkuskatugabeak',
    pt: 'Não lidas'
  },
  ARCHIVED: {
    es: 'Archivadas',
    en: 'Archived',
    cat: 'Arxivades',
    eus: 'Arkatuak',
    pt: 'Arquivadas'
  },
  NO_NOTIFICATIONS: {
    es: '¡Todo limpio! No tienes notificaciones. 😀',
    en: 'All clean! You have no notifications. 😀',
    cat: 'Tot net! No tens notificacions. 😀',
    eus: 'Guztia garbia! Ez duzu jakinarik. 😀',
    pt: 'Tudo limpo! Você não tem notificações. 😀'
  },
  NEWS: {
    es: '¡Nuestras novedades!',
    en: 'Our news!',
    cat: 'Les nostres novetats!',
    eus: 'Gure berriak!',
    pt: 'As nossas notícias!'
  },
  WHATS_NEXT: {
    es: '¿Qué es lo siguiente?',
    en: "What's next?",
    cat: 'Què és el següent?',
    eus: 'Zer dator gero?',
    pt: 'O que é o próximo?'
  },
  CONFIRM: {
    es: 'Confirmar',
    en: 'Confirm',
    cat: 'Confirmar',
    eus: 'Baieztatu',
    pt: 'Confirmar'
  },
  TICKET_TITLE: {
    es: 'Asunto',
    en: 'Subject',
    cat: 'Assumpte',
    eus: 'Gaia',
    pt: 'Assunto'
  },
  ACTIVITY_TITLE: {
    es: 'Actividad',
    en: 'Activity',
    cat: 'Activitat',
    eus: 'Jarduera',
    pt: 'Atividade'
  },
  USER: {
    es: 'Usuario',
    en: 'User',
    cat: 'Usuari',
    eus: 'Erabiltzaile',
    pt: 'Usuário'
  },
  CSAT: {
    es: 'Valoración',
    en: 'Rating',
    cat: 'Avaluació',
    eus: 'Balorazioa',
    pt: 'Avaliação'
  },
  ACTIONS: {
    es: 'Acciones',
    en: 'Actions',
    cat: 'Accions',
    eus: 'Ekintzak',
    pt: 'Ações'
  },
  CONTACT_INFO: {
    es: 'Para cualquier consulta o aclaración, no dudes en contactarnos en el teléfono (+34)<1>919 01 95 15</1>.',
    en: 'For any questions or clarifications, please do not hesitate to contact us at (+34)<1>919 01 95 15</1>.',
    cat: 'Per a qualsevol consulta o aclariment, no dubtis en contactar-nos al telèfon (+34)<1>919 01 95 15</1>.',
    eus: 'Kontsultarik edo argibide gehiagorako, ez ezazu ez zaudenetik kontaktatu gurekin (+34)<1>919 01 95 15</1> telefonoan.',
    pt: 'Para qualquer consulta ou esclarecimento, não hesite em nos contatar pelo telefone (+34)<1>919 01 95 15</1>.'
  },
  CERTIFICATES: {
    es: 'Certificados',
    en: 'Certificates',
    cat: 'Certificats',
    eus: 'Zirriborroak',
    pt: 'Certificados'
  },
  YOU_HAVE_NOT_CERTIFICATES: {
    es: 'No tienes certificados.',
    en: 'You have no certificates.',
    cat: 'No tens certificats.',
    eus: 'Ez duzu ziurtagiriak.',
    pt: 'Você não tem certificados.'
  },
  GENERAL_INFORMATION: {
    es: 'Información general',
    en: 'General information',
    cat: 'Informació general',
    eus: 'Informazio orokorra',
    pt: 'Informação geral'
  },
  SPECIFIC_INFORMATION: {
    es: 'Datos específicos',
    en: 'Specific information',
    cat: 'Dades específiques',
    eus: 'Datu espezifikoak',
    pt: 'Informação específica'
  },
  BIRTHDAY: {
    es: 'Fecha de nacimiento',
    en: 'Birthday',
    cat: 'Data de naixement',
    eus: 'Jaiotze data',
    pt: 'Data de nascimento'
  },
  MY_INFORMATION: {
    es: 'Mi información',
    en: 'My information',
    cat: 'La meva informació',
    eus: 'Nire informazioa',
    pt: 'A minha informação'
  },
  REVIEW_REQUESTS: {
    es: 'Revisar mis solicitudes',
    en: 'Review my requests',
    cat: 'Revisar les meves sol·licituds',
    eus: 'Nire eskaerak berrikusi',
    pt: 'Revisar as minhas solicitações'
  },
  PAY_NOW: {
    es: 'Pagar ya',
    en: 'Pay now',
    cat: 'Paga ara',
    eus: 'Ordaindu orain',
    pt: 'Pagar agora'
  },
  START_NOW: {
    es: 'Empezar ya',
    en: 'Start now',
    cat: 'Comença ara',
    eus: 'Hasi orain',
    pt: 'Começar agora'
  },
  SCORE: {
    es: 'Calificación',
    en: 'Score',
    cat: 'Puntuació',
    eus: 'Kalifikazioa',
    pt: 'Pontuação'
  },
  CREATED_AT: {
    es: 'Fecha de creación',
    en: 'Creation date',
    cat: 'Data de creació',
    eus: 'Sortze data',
    pt: 'Data de criação'
  },
  STUDENT: {
    es: 'Alumno',
    en: 'Student',
    cat: 'Alumne',
    eus: 'Ikasle',
    pt: 'Estudante'
  },
  ACCEPT_TERMS_AND_CONDITIONS: {
    es: 'He leído y acepto los <a>Términos y Condiciones</a> y <b>la Política de Privacidad</b>',
    en: 'I have read and accept the <a>Terms and Conditions</a> and <b>the Privacy Policy</b>',
    cat: 'He llegit i accepto els <a>Termes i Condicions</a> i <b>la Política de Privacitat</b>',
    eus: 'Irakurri eta onartu dut <a>Erabilera baldintzak</a> eta <b>Pribatutasun politika</b>',
    pt: 'Li leu e aceitei os <a>Termos e Condições</a> e <b>Política de Privacidade</b>'
  },
  TERMS_AND_CONDITIONS_INFO: {
    es: 'En UCADEMY, S.L. (en adelante, “UCADEMY”) tratamos tus datos para poder prestarte los servicios de UCADEMY y enviarte información sobre nuestros productos y/o servicios. Estos datos son necesarios para llevar a cabo la prestación de los servicios que se hayan solicitado a través del Sitio Web, así como el consentimiento que nos hayas otorgado conforme a nuestra Política de Privacidad. Tus datos no podrán cederse a terceras empresas. El interesado tiene derecho a ejercitar su derecho de: acceso, rectificación, supresión, oposición, portabilidad de los Datos, limitación del Tratamiento, no ser objeto de decisiones automatizadas individualizadas. Tanto si tienes alguna duda o sugerencia como si quieres darte de baja ponte en contacto con nosotros enviando un email a la siguiente dirección: info@ucademy.com',
    en: 'In UCADEMY, S.L. (hereinafter, "UCADEMY") we process your data in order to provide you with the services of UCADEMY and send you information about our products and / or services. This data is necessary to carry out the provision of the services that have been requested through the Website, as well as the consent you have given us in accordance with our Privacy Policy. Your data cannot be transferred to third companies. The interested party has the right to exercise their right of: access, rectification, deletion, opposition, portability of the Data, limitation of the Treatment, not to be subject to individualized automated decisions. If you have any questions or suggestions or if you want to unsubscribe, please contact us by sending an email to the following address:',
    cat: 'A UCADEMY, S.L. (d’ara endavant, "UCADEMY") tractem les teves dades per poder prestar-te els serveis d’UCADEMY i enviar-te informació sobre els nostres productes i / o serveis. Aquestes dades són necessàries per dur a terme la prestació dels serveis que s’hagin sol·licitat a través del Lloc Web, així com el consentiment que ens hagis atorgat conforme a la nostra Política de Privacitat. Les teves dades no podran cedir-se a tercers. L’interessat té dret a exercir el seu dret de: accés, rectificació, supressió, oposició, portabilitat de les Dades, limitació del Tractament, no ser objecte de decisions automatitzades individualitzades. Tant si tens algun dubte o suggeriment com si vols donar-te de baixa posa’t en contacte amb nosaltres enviant un email a la següent adreça: info@ucademy.com',
    eus: 'UCADEMY, S.L. (hemen ondoren, "UCADEMY")-n zure datuak prozesatzen ditugu UCADEMY-rena diren zerbitzuak hornitzeko eta gure produktuen eta/edo zerbitzuen informazioa bidaltzeko. Datu hauek zerbitzuak eskatzeko gune bidez eskatu diren zerbitzuak hornitzeko beharrezkoak dira, eta ere zu egindako baimenaren arabera gure Pribatutasun Politikaren arabera emandako baimena. Zure datuak ezin dira hirugarren enpresetara eraman. Interesdunak bere datuen gaineko berdintasun, zuzenketaren, ezabaketaren, aurkakoaren, Datuen Portabilitatearen, Tratamenduaren Murrizketaren, erabakia automatizatu pertsonalizatuak jasotzen ez izateko eskubidea du. Galdera edo iradokizunik baduzu edo erregistratzea nahi baduzu, jarri gurekin harremanetan helbide honetara bidali email bat: info@ucademy.com',
    pt: 'À UCADEMY, S.L. (para endavant, "UCADEMY") fornecemos informações para lhe fornecer os serviços da UCADEMY e enviar-lhe informações sobre os nossos produtos e/ou serviços. Estes dados são necessários durante a prestação dos serviços solicitados através do Lloc Web, juntamente com o consentimento que concedeu de acordo com a nossa Política de Privacidade. Estes dados não podem ser transferidos para terceiros. O interesse é exercer o direito de: acesso, retificação, eliminação, oposição, portabilidade de dados, limitação do Tratado, não estar sujeito a decisões automatizadas individualizadas. Se tiver alguma dúvida ou sugestão ou se quiser doar abaixo, por favor contacte-nos enviando um email para o seguinte endereço: info@ucademy.com'
  },
  STUDENT_INFO_TITLE: {
    es: 'Vamos al lío.<br /> Confirma tu ficha de <a>estudiante:</a>',
    en: "Let's get down to business.<br /> Confirm your student <a>info:</a>",
    cat: 'Anem al gra.<br /> Confirma la teva ficha <a>d’estudiant:</a>',
    eus: 'Aldi honetan geratu gara.<br /> Egiaztatu zure <a>ikasle informazioa:</a>',
    pt: 'Vamos ao assunto.<br /> Confirme a sua ficha de <a>estudante:</a>'
  },
  FUN_FACT: {
    es: 'Dato curioso: <a>¿Sabías que el primer examen formal documentado se atribuye a China en el siglo II a.C. y era para opositar al servicio civil?</a>',
    en: 'Fun fact: <a>Did you know that the first documented formal exam is attributed to China in the 2nd century BC and was for civil service exams?</a>',
    cat: 'Dada curiosa: <a>Sabies que el primer examen formal documentat es atribueix a la Xina en el segle II aC i era per oposar al servei civil?</a>',
    eus: 'Datu kurioso: <a>Zer diozu lehenengo egiaztapen dokumentatuari? Txinak II. mendea a.C. atribuitzen du eta zerbitzu zibila oposatzeko zen.</a>',
    pt: 'Dado curioso: <a>Sabia que o primeiro exame formal documentado foi atribuído à China no século II a.C. e foi para oposições ao serviço público?</a>'
  },
  MARK_AS_READ: {
    es: 'Marcar todo como leído',
    en: 'Mark all as read',
    cat: 'Marca tot com a llegit',
    eus: 'Markatu dena irakurri gisa',
    pt: 'Marcar tudo como lido'
  },
  ALL_NOTIFICATIONS_FILTER: {
    es: 'Todas las notificaciones',
    en: 'All notifications',
    cat: 'Totes les notificacions',
    eus: 'Jakinarazpen guztiak',
    pt: 'Todas as notificações'
  },
  [`${ENotificationType.NEW_EVENT}_FILTER`]: {
    es: 'Eventos',
    en: 'Events',
    cat: 'Esdeveniments',
    eus: 'Ekitaldiak',
    pt: 'Eventos'
  },
  [`${ENotificationType.NEW_RECURRING_EVENT}_FILTER`]: {
    es: 'Eventos recurrentes',
    en: 'Recurring events',
    cat: 'Esdeveniments recurrents',
    eus: 'Ekitaldi errepikatuak',
    pt: 'Eventos recorrentes'
  },
  [`${ENotificationType.NEW_POST}_FILTER`]: {
    es: 'Posts',
    en: 'Posts',
    cat: 'Posts',
    eus: 'Posts',
    pt: 'Posts'
  },
  [`${ENotificationType.NEW_TICKET}_FILTER`]: {
    es: 'Dudas',
    en: 'Tickets',
    cat: 'Dubtes',
    eus: 'Zalantzak',
    pt: 'Dúvidas'
  },
  [ENotificationType.NEW_TUTOR]: {
    es: 'Tutor asignado',
    en: 'Tutor assigned',
    cat: 'Tutor assignat',
    eus: 'Tutorea esleituta',
    pt: 'Tutora atribuída'
  },
  [ENotificationType.NEW_TEACHER_ACTIVITY]: {
    es: 'Nueva actividad subida',
    en: 'New activity uploaded',
    cat: 'Nova activitat pujada',
    eus: 'Jarduera berria igo da',
    pt: 'Atividade nova subida'
  },
  [ENotificationType.NEW_TEACHER_QUIZ]: {
    es: 'Nuevo test subido',
    en: 'New quiz uploaded',
    cat: 'Nou test pujat',
    eus: 'Test berria igo da',
    pt: 'Teste novo subido'
  },
  [ENotificationType.NEW_TUTORING_GROUP_MEMBER]: {
    es: 'Nuevo alumno',
    en: 'New student',
    cat: 'Nou alumne',
    eus: 'Ikasle berria',
    pt: 'Aluno novo'
  },
  [ENotificationType.NEW_EVENT]: {
    es: 'Nuevo evento disponible',
    en: 'New event published',
    cat: 'Nou esdeveniment disponible',
    eus: 'Ekitaldi berria argitaratu da',
    pt: 'Evento novo publicado'
  },
  [ENotificationType.NEW_RECURRING_EVENT]: {
    es: 'Nuevo evento recurrente disponible',
    en: 'New recurring event published',
    cat: 'Nou esdeveniment recurrent disponible',
    eus: 'Ekitaldi berria errepikatua argitaratu da',
    pt: 'Evento recorrente novo publicado'
  },
  [ENotificationType.EVENT_UPDATE]: {
    es: 'Evento actualizado',
    en: 'Event updated',
    cat: 'Esdeveniment actualitzat',
    eus: 'Ekitaldia eguneratua',
    pt: 'Evento atualizado'
  },
  [ENotificationType.NEW_POST]: {
    es: 'Nueva noticia publicada',
    en: 'New post published',
    cat: 'Nova notícia publicada',
    eus: 'Albiste berria argitaratu da',
    pt: 'Artigo novo publicado'
  },
  [ENotificationType.NEW_TICKET]: {
    es: 'Nueva duda',
    en: 'New ticket',
    cat: 'Nou dubte',
    eus: 'Zalantza berria',
    pt: 'Dúvida nova'
  },
  [ENotificationType.TICKET_UPDATE]: {
    es: 'Duda actualizada',
    en: 'Ticket updated',
    cat: 'Dubte actualitzat',
    eus: 'Zalantza eguneratua',
    pt: 'Dúvida atualizada'
  },
  [ENotificationType.NEW_DELIVERABLE]: {
    es: 'Nuevo entregable',
    en: 'New deliverable',
    cat: 'Nou lliurament',
    eus: 'Entrega berria',
    pt: 'Entrega nova'
  },
  [ENotificationType.DELIVERABLE_MESSAGE_CREATED]: {
    es: 'Entregable actualizado',
    en: 'Deliverable updated',
    cat: 'Lliurament actualitzat',
    eus: 'Entrega eguneratua',
    pt: 'Entrega atualizada'
  },
  [ENotificationType.DELIVERABLE_CORRECTED]: {
    es: 'Entregable corregido',
    en: 'Deliverable corrected',
    cat: 'Lliurament corregit',
    eus: 'Entregatu zuzendua',
    pt: 'Entrega corrigida'
  },
  [ENotificationType.NEW_EXAM_GROUP]: {
    es: 'Nueva convocatoria publicada',
    en: 'New exam group published',
    cat: 'Nova convocatòria publicada',
    eus: 'Deialdi berria argitaratu da',
    pt: 'Convocatória nova publicada'
  },
  [ENotificationType.NEW_EXAM_GROUP_EXAM]: {
    es: 'Nuevo examen para tu convocatoria publicado',
    en: 'New exam for your exam group published',
    cat: 'Nou examen per a la teva convocatòria publicat',
    eus: 'Proba berria zure deialdiko argitaratu da',
    pt: 'Prova nova publicada na sua convocatória'
  },
  [ENotificationType.NEW_LIVERECORD]: {
    es: 'Nueva grabación disponible',
    en: 'New recording available',
    cat: 'Nova gravació disponible',
    eus: 'Grabazio berria eskuragarri',
    pt: 'Gravação nova disponível'
  },
  [ENotificationType.TASK_RESOURCE_UPLOADED]: {
    es: 'Tarea pasada a revisión',
    en: 'Task passed to review',
    cat: 'Tasca passada a revisió',
    eus: 'Lan bat berrikuspenetara pasatu da',
    pt: 'Tarefa passada para revisão'
  },
  [ENotificationType.TASK_REJECTED]: {
    es: 'Actividad rechazada',
    en: 'Activity rejected',
    cat: 'Activitat rebutjada',
    eus: 'Jarduera baztertua',
    pt: 'Atividade rejeitada'
  },
  [ENotificationType.TASK_APPROVED]: {
    es: 'Actividad aprobada',
    en: 'Activity approved',
    cat: 'Activitat aprovada',
    eus: 'Jarduera onartua',
    pt: 'Atividade aprovada'
  },
  [ENotificationType.NEW_STUDENT_VOTE]: {
    es: 'Valora tu experiencia',
    en: 'Rate your experience',
    cat: 'Valora la teva experiència',
    eus: 'Eskubidearen ziurgabetasuna',
    pt: 'Avalie sua experiência'
  },
  [ENotificationType.EXAM_GROUP_REGISTRATION_PERIOD_DEADLINE_3_DAYS]: {
    es: 'Convocatoria',
    en: 'Exam group',
    cat: 'Convocatoria',
    eus: 'Deialdi',
    pt: 'Convocatória'
  },
  [ENotificationType.EXAM_GROUP_PROVISIONAL_LIST_PUBLISHED]: {
    es: 'Convocatoria',
    en: 'Exam group',
    cat: 'Convocatoria',
    eus: 'Deialdi',
    pt: 'Convocatória'
  },
  [ENotificationType.EXAM_GROUP_FINAL_LIST_PUBLISHED]: {
    es: 'Convocatoria',
    en: 'Exam group',
    cat: 'Convocatoria',
    eus: 'Deialdi',
    pt: 'Convocatória'
  },
  [ENotificationType.EXAM_GROUP_EXAM_DATE_PUBLISHED]: {
    es: 'Convocatoria',
    en: 'Exam group',
    cat: 'Convocatoria',
    eus: 'Deialdi',
    pt: 'Convocatória'
  },
  [ENotificationType.EXAM_GROUP_EXAM_IN_PROGRESS]: {
    es: 'Convocatoria',
    en: 'Exam group',
    cat: 'Convocatoria',
    eus: 'Deialdi',
    pt: 'Convocatória'
  },
  [ENotificationType.EXAM_GROUP_PUBLISH_NOTES]: {
    es: 'Convocatoria',
    en: 'Exam group',
    cat: 'Convocatoria',
    eus: 'Deialdi',
    pt: 'Convocatória'
  },
  [ENotificationType.EXAM_GROUP_IN_COMPETITION_PHASE]: {
    es: 'Convocatoria',
    en: 'Exam group',
    cat: 'Convocatoria',
    eus: 'Deialdi',
    pt: 'Convocatória'
  },
  TEACHERS_CREATE_QUIZ_LINK: {
    es: 'Selecciona un test de la lista. Si no está creado, por favor, <a>ve a Test</a> y crea uno.',
    en: 'Select a test from the list. If it is not already created, please <a>go to Test</a> and create one.',
    cat: 'Selecciona un test de la llista. Si no està creat, si us plau, <a>vés a Test</a> i crea un.',
    eus: 'Aukeratu test bat zerrendatik. Ez badago sortuta, mesedez, <a>joan Testera</a> eta sortu bat.',
    pt: 'Selecione um teste da lista. Se não estiver criado, por favor, <a>vá para Test</a> e crie um.'
  },
  [EQuestionReportOptions.GRAMMAR]: {
    es: 'Errores ortográficos en la pregunta',
    en: 'Spelling errors in the question',
    cat: 'Errors ortogràfics a la pregunta',
    eus: 'Galderan ortografia akatsak',
    pt: 'Erros de ortografia na pergunta'
  },
  [EQuestionReportOptions.QUESTION_INCOMPLETE]: {
    es: 'Pregunta o respuesta incompleta',
    en: 'Incomplete question or answer',
    cat: 'Pregunta o resposta incompleta',
    eus: 'Galdera edo erantzun oso inkompletua',
    pt: 'Pergunta ou resposta incompleta'
  },
  [EQuestionReportOptions.WRONG_ANSWER]: {
    es: 'La respuesta marcada como correcta es errónea',
    en: 'The answer marked as correct is wrong',
    cat: 'La resposta marcada com a correcta és errònia',
    eus: 'Zuzen moduan markatutako erantzuna okerra da',
    pt: 'A resposta marcada como correta está errada'
  },
  [EQuestionReportOptions.WRONG_RELATED_COMTENT]: {
    es: 'La pregunta no corresponde al tema',
    en: 'The question does not correspond to the topic',
    cat: 'La pregunta no correspon al tema',
    eus: 'Galderak gaia ez du',
    pt: 'A pergunta não corresponde ao tema'
  },
  [EQuestionReportOptions.OTHER_QUESTION_REPORT]: {
    es: 'Otro',
    en: 'Other',
    cat: 'Altres',
    eus: 'Besteak',
    pt: 'Outro'
  },
  [EActivityReportOptions.OTHER_ACTIVITY_REPORT]: {
    es: 'Otro',
    en: 'Other',
    cat: 'Altres',
    eus: 'Besteak',
    pt: 'Outro'
  },
  [EActivityReportOptions.AUDIO_OR_VIDEO]: {
    es: 'Problemas técnicos con el audio o el vídeo',
    en: 'Technical problems with the audio or video',
    cat: "Problemes tècnics amb l'àudio o el vídeo",
    eus: 'Zalantza teknikoak audioa edo bideoa baliatzeko',
    pt: 'Problemas técnicos com o áudio ou vídeo'
  },
  [EActivityReportOptions.LESSON_CONTENT]: {
    es: 'El contenido no corresponde con la lección',
    en: 'The information (texts, images, diagrams...) is not clear.',
    cat: 'El contingut no correspon amb la lliçó',
    eus: 'Edukiak (testuak, irudiak, diagramak...) argiak ez dira.',
    pt: 'O conteúdo não corresponde à lição'
  },
  [EActivityReportOptions.INCOMPLETE_CONTENT]: {
    es: 'El contenido está incompleto',
    en: 'The content is incomplete',
    cat: 'El contingut està incomplet',
    eus: 'Edukiak osatuak ez dira',
    pt: 'O conteúdo está incompleto'
  },
  [EActivityReportOptions.TEACHER_EXPLANATION]: {
    es: 'La explicación del profesor no es clara',
    en: "The teacher's explanation is not clear",
    cat: "L'explicació del professor no és clara",
    eus: 'Irakaslearen azalpena ez da argia',
    pt: 'A explicação do professor não é clara'
  },
  [EActivityReportOptions.REPEATED_VIDEO]: {
    es: 'Este video está repetido en otro tema',
    en: 'This video is repeated in another topic',
    cat: 'Aquest vídeo està repetit en un altre tema',
    eus: 'Bideo hau beste gaian berriz ere errepikatua dago',
    pt: 'Este vídeo está repetido em outro tema'
  },
  [EActivityReportOptions.WRONG_INFORMATION]: {
    es: 'La información (textos, imágenes, esquemas...) no es clara',
    en: 'The information (texts, images, diagrams...) is not clear.',
    cat: 'La informació (texts, imatges, esquemes...) no és clara',
    eus: 'Informazioa (testuak, irudiak, diagramak...) ez da argia.',
    pt: 'A informação (testes, imagens, diagramas...) não é clara.'
  },
  [EActivityReportOptions.TECHNICAL_PROBLEM]: {
    es: 'Problema técnico / Algo no funciona',
    en: 'Technical problem / Something is not working',
    cat: 'Problema tècnic / Alguna cosa no funciona',
    eus: 'Zalantza teknikoa / Zerbait ez dago funtzionatzen',
    pt: 'Problema técnico / Alguma coisa não está funcionando'
  },
  VISIBILITY: {
    es: 'Visibilidad',
    en: 'Visibility',
    cat: 'Visibilitat',
    eus: 'Ikusgarritasuna',
    pt: 'Visibilidade'
  },
  VOTES: {
    es: 'Votos',
    en: 'Votes',
    cat: 'Vots',
    eus: 'Botoak',
    pt: 'Votos'
  },
  PUBLIC: {
    es: 'Pública',
    en: 'Public',
    cat: 'Pública',
    eus: 'Publikoa',
    pt: 'Pública'
  },
  PRIVATE: {
    es: 'Privada',
    en: 'Private',
    cat: 'Privada',
    eus: 'Pribatua',
    pt: 'Privada'
  },
  CHANGE_VISIBILITY_CONFIRMATION: {
    es: '¿Estás seguro de que quieres hacer pública esta duda? <a>Todos los usuarios podrán verla de ahora en adelante.</a>',
    en: 'Are you sure you want to make this question public? <a>All users will be able to see it from now on.</a>',
    cat: "Estàs segur que vols fer pública aquesta pregunta? <a>Tots els usuaris la podran veure d'ara endavant.</a>",
    eus: 'Zihur zaude zalantza hau publikoa egin nahi duzula? <a>Erabiltzaile guztiak ikus dezakete geroztik.</a>',
    pt: 'Tem certeza que deseja tornar pública esta dúvida? <a>Todos os usuários poderão ver a partir de agora.</a>'
  },
  [EExamGroupsType.OPPOSITION]: {
    es: 'Oposición',
    en: 'Opposition',
    cat: 'Oposició',
    eus: 'Oposizioa',
    pt: 'Oposição'
  },
  [EExamGroupsType.CONTEST]: {
    es: 'Concurso',
    en: 'Contest',
    cat: 'Concurs',
    eus: 'Lehiaketa',
    pt: 'Concurso'
  },
  [EExamGroupsType.CONTEST_OPPOSITION]: {
    es: 'Concurso-oposición',
    en: 'Contest-opposition',
    cat: 'Concurs-oposició',
    eus: 'Lehiaketa-oposizioa',
    pt: 'Concurso-oposição'
  },
  [EExamGroupsType.ORDINARY]: {
    es: 'Ordinaria',
    en: 'Ordinary',
    cat: 'Ordinària',
    eus: 'Ohiko',
    pt: 'Ordinária'
  },
  [EExamGroupsType.EXTRAORDINARY]: {
    es: 'Extraordinaria',
    en: 'Extraordinary',
    cat: 'Extraordinària',
    eus: 'Berezi',
    pt: 'Extraordinária'
  },
  [EExamGroupsType.JOB_BOARD]: {
    es: 'Bolsa de trabajo',
    en: 'Job board',
    cat: 'Bolsa de treball',
    eus: 'Lan-poltsa',
    pt: 'Bolsa de emprego'
  },
  FILES_AND_LINKS: {
    es: 'Archivos y enlaces',
    en: 'Files and links',
    cat: 'Arxius i enllaços',
    eus: 'Fitxategiak eta estekak',
    pt: 'Ficheiros e links'
  },
  COMMUNITY: {
    es: 'Comunidad',
    en: 'Community',
    cat: 'Comunitat',
    eus: 'Komunitatea',
    pt: 'Comunidade'
  },
  AUTONOMOUS_COMMUNITY: {
    es: 'Comunidad Autónoma',
    en: 'Autonomous Community',
    cat: 'Comunitat Autònoma',
    eus: 'Autonomia Erkidegoa',
    pt: 'Comunidade Autónoma'
  },
  PROVINCE: {
    es: 'Provincia',
    en: 'Province',
    cat: 'Província',
    eus: 'Probintzia',
    pt: 'Província'
  },
  [EAutonomousCommunity.ANDALUCIA]: {
    es: 'Andalucía',
    en: 'Andalucía',
    cat: 'Andalucía',
    eus: 'Andalucía',
    pt: 'Andaluzia'
  },
  [EAutonomousCommunity.PAIS_VASCO]: {
    es: 'País Vasco',
    en: 'País Vasco',
    cat: 'País Vasco',
    eus: 'País Vasco',
    pt: 'País Vasco'
  },
  [EAutonomousCommunity.CANARIAS]: {
    es: 'Islas Canarias',
    en: 'Islas Canarias',
    cat: 'Isles Canàries',
    eus: 'Islas Canarias',
    pt: 'Ilhas Canárias'
  },
  [EAutonomousCommunity.VALENCIA]: {
    es: 'Comunidad Valenciana',
    en: 'Comunidad Valenciana',
    cat: 'Comunitat Valenciana',
    eus: 'Comunitat Valenciana',
    pt: 'Comunidade Valenciana'
  },
  [EAutonomousCommunity.CATALUNYA]: {
    es: 'Cataluña',
    en: 'Cataluña',
    cat: 'Cataluña',
    eus: 'Cataluña',
    pt: 'Catalunha'
  },
  [EAutonomousCommunity.MADRID]: {
    es: 'Madrid',
    en: 'Madrid',
    cat: 'Madrid',
    eus: 'Madrid',
    pt: 'Madrid'
  },
  [EAutonomousCommunity.ARAGON]: {
    es: 'Aragón',
    en: 'Aragón',
    cat: 'Aragón',
    eus: 'Aragón',
    pt: 'Aragónia'
  },
  [EAutonomousCommunity.GALICIA]: {
    es: 'Galicia',
    en: 'Galicia',
    cat: 'Galicia',
    eus: 'Galicia',
    pt: 'Galiza'
  },
  [EAutonomousCommunity.EXTREMADURA]: {
    es: 'Extremadura',
    en: 'Extremadura',
    cat: 'Extremadura',
    eus: 'Extremadura',
    pt: 'Extremadura'
  },
  [EAutonomousCommunity.CASTILLA_LEON]: {
    es: 'Castilla y León',
    en: 'Castilla y León',
    cat: 'Castilla y León',
    eus: 'Castilla y León',
    pt: 'Castela e Leão'
  },
  [EAutonomousCommunity.CASTILLA_LA_MANCHA]: {
    es: 'Castilla-La Mancha',
    en: 'Castilla-La Mancha',
    cat: 'Castilla-La Mancha',
    eus: 'Castilla-La Mancha',
    pt: 'Castela-La Mancha'
  },
  [EAutonomousCommunity.ASTURIAS]: {
    es: 'Asturias',
    en: 'Asturias',
    cat: 'Asturias',
    eus: 'Asturias',
    pt: 'Astúrias'
  },
  [EAutonomousCommunity.BALEARES]: {
    es: 'Islas Baleares',
    en: 'Islas Baleares',
    cat: 'Isles Balears',
    eus: 'Islas Baleares',
    pt: 'Ilhas Baleares'
  },
  [EAutonomousCommunity.MELILLA]: {
    es: 'Melilla',
    en: 'Melilla',
    cat: 'Melilla',
    eus: 'Melilla',
    pt: 'Melilha'
  },
  [EAutonomousCommunity.CANTABRIA]: {
    es: 'Cantabria',
    en: 'Cantabria',
    cat: 'Cantabria',
    eus: 'Cantabria',
    pt: 'Cantábria'
  },
  [EAutonomousCommunity.LA_RIOJA]: {
    es: 'La Rioja',
    en: 'La Rioja',
    cat: 'La Rioja',
    eus: 'La Rioja',
    pt: 'La Rioja'
  },
  [EAutonomousCommunity.MURCIA]: {
    es: 'Murcia',
    en: 'Murcia',
    cat: 'Murcia',
    eus: 'Murcia',
    pt: 'Murcia'
  },
  [EAutonomousCommunity.CEUTA]: {
    es: 'Ceuta',
    en: 'Ceuta',
    cat: 'Ceuta',
    eus: 'Ceuta',
    pt: 'Ceuta'
  },
  [EAutonomousCommunity.NAVARRA]: {
    es: 'Navarra',
    en: 'Navarra',
    cat: 'Navarra',
    eus: 'Navarra',
    pt: 'Navarra'
  },
  [EProvince.ALMERIA]: {
    es: 'Almería',
    en: 'Almería',
    cat: 'Almería',
    eus: 'Almería',
    pt: 'Almeria'
  },
  [EProvince.CADIZ]: {
    es: 'Cádiz',
    en: 'Cádiz',
    cat: 'Cádiz',
    eus: 'Cádiz',
    pt: 'Cádiz'
  },
  [EProvince.CORDOBA]: {
    es: 'Córdoba',
    en: 'Córdoba',
    cat: 'Córdoba',
    eus: 'Córdoba',
    pt: 'Córdoba'
  },
  [EProvince.GRANADA]: {
    es: 'Granada',
    en: 'Granada',
    cat: 'Granada',
    eus: 'Granada',
    pt: 'Granada'
  },
  [EProvince.HUELVA]: {
    es: 'Huelva',
    en: 'Huelva',
    cat: 'Huelva',
    eus: 'Huelva',
    pt: 'Huelva'
  },
  [EProvince.JAEN]: {
    es: 'Jaén',
    en: 'Jaén',
    cat: 'Jaén',
    eus: 'Jaén',
    pt: 'Jaén'
  },
  [EProvince.MALAGA]: {
    es: 'Málaga',
    en: 'Málaga',
    cat: 'Málaga',
    eus: 'Málaga',
    pt: 'Málaga'
  },
  [EProvince.SEVILLA]: {
    es: 'Sevilla',
    en: 'Sevilla',
    cat: 'Sevilla',
    eus: 'Sevilla',
    pt: 'Sevilha'
  },
  [EProvince.ALAVA]: {
    es: 'Álava',
    en: 'Álava',
    cat: 'Álava',
    eus: 'Álava',
    pt: 'Álava'
  },
  [EProvince.GUIPUZCOA]: {
    es: 'Guipúzcoa',
    en: 'Gipuzkoa',
    cat: 'Gipuzkoa',
    eus: 'Gipuzkoa',
    pt: 'Gipuzkoa'
  },
  [EProvince.VIZCAYA]: {
    es: 'Vizcaya',
    en: 'Bizkaia',
    cat: 'Bizkaia',
    eus: 'Bizkaia',
    pt: 'Bizkaia'
  },
  [EProvince.LAS_PALMAS]: {
    es: 'Las Palmas',
    en: 'Las Palmas',
    cat: 'Las Palmas',
    eus: 'Las Palmas',
    pt: 'Las Palmas'
  },
  [EProvince.SANTA_CRUZ_DE_TENERIFE]: {
    es: 'Santa Cruz de Tenerife',
    en: 'Santa Cruz de Tenerife',
    cat: 'Santa Cruz de Tenerife',
    eus: 'Santa Cruz de Tenerife',
    pt: 'Santa Cruz de Tenerife'
  },
  [EProvince.VALENCIA]: {
    es: 'Valencia',
    en: 'Valencia',
    cat: 'Valencia',
    eus: 'Valencia',
    pt: 'Valência'
  },
  [EProvince.CASTELLON]: {
    es: 'Castellón',
    en: 'Castellón',
    cat: 'Castellón',
    eus: 'Castellón',
    pt: 'Castellón'
  },
  [EProvince.ALICANTE]: {
    es: 'Alicante',
    en: 'Alicante',
    cat: 'Alicante',
    eus: 'Alicante',
    pt: 'Alicante'
  },
  [EProvince.BARCELONA]: {
    es: 'Barcelona',
    en: 'Barcelona',
    cat: 'Barcelona',
    eus: 'Barcelona',
    pt: 'Barcelona'
  },
  [EProvince.GERONA]: {
    es: 'Gerona',
    en: 'Girona',
    cat: 'Girona',
    eus: 'Girona',
    pt: 'Girona'
  },
  [EProvince.LERIDA]: {
    es: 'Lérida',
    en: 'Lérida',
    cat: 'Lérida',
    eus: 'Lérida',
    pt: 'Lérida'
  },
  [EProvince.TARRAGONA]: {
    es: 'Tarragona',
    en: 'Tarragona',
    cat: 'Tarragona',
    eus: 'Tarragona',
    pt: 'Tarragona'
  },
  [EProvince.MADRID]: {
    es: 'Madrid',
    en: 'Madrid',
    cat: 'Madrid',
    eus: 'Madrid',
    pt: 'Madrid'
  },
  [EProvince.HUESCA]: {
    es: 'Huesca',
    en: 'Huesca',
    cat: 'Huesca',
    eus: 'Huesca',
    pt: 'Huesca'
  },
  [EProvince.TERUEL]: {
    es: 'Teruel',
    en: 'Teruel',
    cat: 'Teruel',
    eus: 'Teruel',
    pt: 'Teruel'
  },
  [EProvince.ZARAGOZA]: {
    es: 'Zaragoza',
    en: 'Zaragoza',
    cat: 'Zaragoza',
    eus: 'Zaragoza',
    pt: 'Zaragoza'
  },
  [EProvince.A_CORUNA]: {
    es: 'A Coruña',
    en: 'A Coruña',
    cat: 'A Coruña',
    eus: 'A Coruña',
    pt: 'A Coruña'
  },
  [EProvince.LUGO]: {
    es: 'Lugo',
    en: 'Lugo',
    cat: 'Lugo',
    eus: 'Lugo',
    pt: 'Lugo'
  },
  [EProvince.OURENSE]: {
    es: 'Ourense',
    en: 'Ourense',
    cat: 'Ourense',
    eus: 'Ourense',
    pt: 'Ourense'
  },
  [EProvince.PONTEVEDRA]: {
    es: 'Pontevedra',
    en: 'Pontevedra',
    cat: 'Pontevedra',
    eus: 'Pontevedra',
    pt: 'Pontevedra'
  },
  [EProvince.BADAJOZ]: {
    es: 'Badajoz',
    en: 'Badajoz',
    cat: 'Badajoz',
    eus: 'Badajoz',
    pt: 'Badajoz'
  },
  [EProvince.CACERES]: {
    es: 'Cáceres',
    en: 'Cáceres',
    cat: 'Cáceres',
    eus: 'Cáceres',
    pt: 'Cáceres'
  },
  [EProvince.AVILA]: {
    es: 'Ávila',
    en: 'Ávila',
    cat: 'Ávila',
    eus: 'Ávila',
    pt: 'Ávila'
  },
  [EProvince.BURGOS]: {
    es: 'Burgos',
    en: 'Burgos',
    cat: 'Burgos',
    eus: 'Burgos',
    pt: 'Burgos'
  },
  [EProvince.LEON]: {
    es: 'León',
    en: 'León',
    cat: 'León',
    eus: 'León',
    pt: 'Leão'
  },
  [EProvince.PALENCIA]: {
    es: 'Palencia',
    en: 'Palencia',
    cat: 'Palencia',
    eus: 'Palencia',
    pt: 'Palência'
  },
  [EProvince.SALAMANCA]: {
    es: 'Salamanca',
    en: 'Salamanca',
    cat: 'Salamanca',
    eus: 'Salamanca',
    pt: 'Salamanca'
  },
  [EProvince.SEGOVIA]: {
    es: 'Segovia',
    en: 'Segovia',
    cat: 'Segovia',
    eus: 'Segovia',
    pt: 'Segovia'
  },
  [EProvince.SORIA]: {
    es: 'Soria',
    en: 'Soria',
    cat: 'Soria',
    eus: 'Soria',
    pt: 'Soria'
  },
  [EProvince.VALLADOLID]: {
    es: 'Valladolid',
    en: 'Valladolid',
    cat: 'Valladolid',
    eus: 'Valladolid',
    pt: 'Valladolid'
  },
  [EProvince.ZAMORA]: {
    es: 'Zamora',
    en: 'Zamora',
    cat: 'Zamora',
    eus: 'Zamora',
    pt: 'Zamora'
  },
  [EProvince.ALBACETE]: {
    es: 'Albacete',
    en: 'Albacete',
    cat: 'Albacete',
    eus: 'Albacete',
    pt: 'Albacete'
  },
  [EProvince.CIUDAD_REAL]: {
    es: 'Ciudad Real',
    en: 'Ciudad Real',
    cat: 'Ciudad Real',
    eus: 'Ciudad Real',
    pt: 'Cidade Real'
  },
  [EProvince.CUENCA]: {
    es: 'Cuenca',
    en: 'Cuenca',
    cat: 'Cuenca',
    eus: 'Cuenca',
    pt: 'Cuenca'
  },
  [EProvince.GUADALAJARA]: {
    es: 'Guadalajara',
    en: 'Guadalajara',
    cat: 'Guadalajara',
    eus: 'Guadalajara',
    pt: 'Guadalajara'
  },
  [EProvince.TOLEDO]: {
    es: 'Toledo',
    en: 'Toledo',
    cat: 'Toledo',
    eus: 'Toledo',
    pt: 'Toledo'
  },
  [EProvince.ASTURIAS]: {
    es: 'Asturias',
    en: 'Asturias',
    cat: 'Asturias',
    eus: 'Asturias',
    pt: 'Astúrias'
  },
  [EProvince.BALEARES]: {
    es: 'Islas Baleares',
    en: 'Islas Baleares',
    cat: 'Isles Balears',
    eus: 'Islas Baleares',
    pt: 'Ilhas Baleares'
  },
  [EProvince.MELILLA]: {
    es: 'Melilla',
    en: 'Melilla',
    cat: 'Melilla',
    eus: 'Melilla',
    pt: 'Melilha'
  },
  [EProvince.CANTABRIA]: {
    es: 'Cantabria',
    en: 'Cantabria',
    cat: 'Cantabria',
    eus: 'Cantabria',
    pt: 'Cantábria'
  },
  [EProvince.LA_RIOJA]: {
    es: 'La Rioja',
    en: 'La Rioja',
    cat: 'La Rioja',
    eus: 'La Rioja',
    pt: 'La Rioja'
  },
  [EProvince.MURCIA]: {
    es: 'Murcia',
    en: 'Murcia',
    cat: 'Murcia',
    eus: 'Murcia',
    pt: 'Murcia'
  },
  [EProvince.CEUTA]: {
    es: 'Ceuta',
    en: 'Ceuta',
    cat: 'Ceuta',
    eus: 'Ceuta',
    pt: 'Ceuta'
  },
  [EProvince.NAVARRA]: {
    es: 'Navarra',
    en: 'Navarra',
    cat: 'Navarra',
    eus: 'Navarra',
    pt: 'Navarra'
  },
  [ESectionTrackStatus.NOT_STARTED]: {
    es: 'Pendiente',
    en: 'Pending',
    cat: 'Pendent',
    eus: 'Pendiente',
    pt: 'Pendente'
  },
  [ESectionTrackStatus.SEEN]: {
    es: 'Visto',
    en: 'Seen',
    cat: 'Vist',
    eus: 'Ikusita',
    pt: 'Visto'
  },
  [ESectionTrackStatus.SUMMARISED]: {
    es: 'Resumido',
    en: 'Summarised',
    cat: 'Resumit',
    eus: 'Laburtuta',
    pt: 'Resumido'
  },
  [ESectionTrackStatus.STUDIED]: {
    es: 'Estudiado',
    en: 'Studied',
    cat: 'Estudiat',
    eus: 'Ikasketak eginak',
    pt: 'Estudado'
  },
  [ESectionTrackStatus.REVISED]: {
    es: 'Falta repaso',
    en: 'Missing review',
    cat: 'Repas faltant',
    eus: 'Berrikusitako falta',
    pt: 'Reparo pendente'
  },
  [ESectionTrackStatus.KNOWN]: {
    es: 'Me lo sé',
    en: 'I know it',
    cat: 'Me lo sé',
    eus: 'Dakit',
    pt: 'Sei'
  },
  CONTRACT: {
    es: 'Contrato',
    en: 'Contract',
    cat: 'Contracte',
    eus: 'Kontratua',
    pt: 'Contrato'
  },
  DOWNLOAD_CONTRACT: {
    es: 'Descargar contrato',
    en: 'Download contract',
    cat: 'Descarregar contracte',
    eus: 'Kontratuaren deskargatzea',
    pt: 'Descarregar contrato'
  },
  DOES_HE_WORK: {
    es: '¿Trabaja?',
    en: 'Does he work?',
    cat: 'Treballa?',
    eus: 'Lan egiten du?',
    pt: 'Trabalha?'
  },
  AVAILABLE_TIME: {
    es: 'Tiempo disponible para estudiar',
    en: 'Available time to study',
    cat: 'Temps disponible per estudiar',
    eus: 'Ikastea daitekeen denbora',
    pt: 'Tempo disponível para estudar'
  },
  HOURS_PER_WEEK: {
    es: '{{ investTime }} h/semana',
    en: '{{ investTime }} h/week',
    cat: '{{ investTime }} h/setmana',
    eus: '{{ investTime }} h/aste',
    pt: '{{ investTime }} h/semana'
  },
  HISTORY: {
    es: 'Históricos',
    en: 'History',
    cat: 'Històrics',
    eus: 'Historikoak',
    pt: 'Histórico'
  },
  STATUS_HISTORY: {
    es: 'Histórico de estados',
    en: 'Status history',
    cat: "Històric d'estats",
    eus: 'Egoera historikoa',
    pt: 'Histórico de estados'
  },
  PAYMENT_HISTORY: {
    es: 'Histórico de pagos',
    en: 'Payment history',
    cat: 'Històric de pagaments',
    eus: 'Ordainketa historikoa',
    pt: 'Histórico de pagamentos'
  },
  ACCESS_HISTORY: {
    es: 'Accesos',
    en: 'Access',
    cat: 'Accessos',
    eus: 'Sarbidea',
    pt: 'Acesso'
  },
  ACCESS_LABEL: {
    es: 'Acceso',
    en: 'Access',
    cat: 'Accés',
    eus: 'Sarbidea',
    pt: 'Acesso'
  },
  ACCESS_HISTORY_COUNT_one: {
    es: '1 acceso',
    en: '1 access',
    cat: '1 accés',
    eus: '1 sarbidea',
    pt: '1 acesso'
  },
  ACCESS_HISTORY_COUNT_other: {
    es: '{{count}} accesos',
    en: '{{count}} accesses',
    cat: '{{count}} accés',
    eus: '{{count}} sarbidea',
    pt: '{{count}} acessos'
  },
  QUIZ_NUMBER: {
    es: 'Nº test realizados',
    en: 'Nº tests done',
    cat: 'Nº test realitzat',
    eus: 'Egindako test kopurua',
    pt: 'Nº de testes realizados'
  },
  AVG_SCORE: {
    es: 'Nota media',
    en: 'Avg score',
    cat: 'Nota mitjana',
    eus: 'Batazbesteko puntuazioa',
    pt: 'Média das notas'
  },
  TICKETS_NUMBER: {
    es: 'Nº dudas',
    en: 'Nº doubts',
    cat: 'Nº dubtes',
    eus: 'Zalantz kopurua',
    pt: 'Nº de dúvidas'
  },
  CSAT_TITLE: {
    es: 'CSAT',
    en: 'CSAT',
    cat: 'CSAT',
    eus: 'CSAT',
    pt: 'CSAT'
  },
  APP_TIME: {
    es: 'Tiempo total',
    en: 'Total time',
    cat: 'Temps total',
    eus: 'Denbora guztira',
    pt: 'Tempo total'
  },
  [EStudentConnectionStatus.WITHOUT_CONNECTION]: {
    es: 'Sin conexión',
    en: 'Without connection',
    cat: 'Sense connexió',
    eus: 'Konexio gabe',
    pt: 'Sem conexão'
  },
  [EStudentConnectionStatus.SUPER_USER]: {
    es: 'Super usuario',
    en: 'Super user',
    cat: 'Super usuari',
    eus: 'Super erabiltzailea',
    pt: 'Super usuário'
  },
  [EStudentConnectionStatus.ACTIVE]: {
    es: 'Activo',
    en: 'Active',
    cat: 'Actiu',
    eus: 'Aktibo',
    pt: 'Inativo'
  },
  [EStudentConnectionStatus.SLEEP]: {
    es: 'Dormido',
    en: 'Sleep',
    cat: 'Dormit',
    eus: 'Lozorroan',
    pt: 'Em repouso'
  },
  [EStudentConnectionStatus.NOT_ACTIVE]: {
    es: 'No activo',
    en: 'Not active',
    cat: 'No actiu',
    eus: 'Ez da aktibatu',
    pt: 'Não ativo'
  },
  [EStudentConnectionStatus.DISCONNECTED]: {
    es: 'Desconectado',
    en: 'Disconnected',
    cat: 'Desconnectat',
    eus: 'Deskonektatuta',
    pt: 'Desconectado'
  },
  [EStudentPaymentStatus.PAID]: {
    es: 'Pago correcto',
    en: 'Paid',
    cat: 'Pagament correcte',
    eus: 'Ordainketa egokia',
    pt: 'Pagamento correto'
  },
  [EStudentPaymentStatus.DOWNTURN]: {
    es: 'Baja',
    en: 'Downturn',
    cat: 'Baixa',
    eus: 'Baxua',
    pt: 'Baixo'
  },
  [EStudentPaymentStatus.NON_PAYMENT]: {
    es: 'Impago',
    en: 'Non payment',
    cat: 'Impagament',
    eus: 'Ordainketa ezezaguna',
    pt: 'Pagamento não realizado'
  },
  [EStudentPaymentStatus.FORMER_STUDENT]: {
    es: 'Antiguo',
    en: 'Former student',
    cat: 'Antic',
    eus: 'Ohiko ikaslea',
    pt: 'Antigo aluno'
  },
  [EStudentSatisfactionStatus.PROMOTOR]: {
    es: 'Promotor',
    en: 'Promotor',
    cat: 'Promotor',
    eus: 'Promotor',
    pt: 'Promotor'
  },
  [EStudentSatisfactionStatus.NEUTRAL]: {
    es: 'Neutral',
    en: 'Neutral',
    cat: 'Neutral',
    eus: 'Neutral',
    pt: 'Neutral'
  },
  [EStudentSatisfactionStatus.DETRACTOR]: {
    es: 'Detractor',
    en: 'Detractor',
    cat: 'Detractor',
    eus: 'Detractor',
    pt: 'Detractor'
  },
  [EStudentActivationStatus.ACTIVATED]: {
    es: 'Activado',
    en: 'Activated',
    cat: 'Activat',
    eus: 'Aktibatuta',
    pt: 'Ativado'
  },
  [EStudentActivationStatus.NOT_ACTIVATED]: {
    es: 'No activado',
    en: 'Not activated',
    cat: 'No activat',
    eus: 'Ez da aktibatu',
    pt: 'Não ativado'
  },
  ACTIVITY_STATUS: {
    es: 'Actividad',
    en: 'Activity',
    cat: 'Activitat',
    eus: 'Ekintza',
    pt: 'Atividade'
  },
  APP_TIME_TOOLTIP: {
    es: 'Tiempo total que ha pasado el alumno en la plataforma',
    en: 'Total time the student has spent in the platform',
    cat: "Temps total que ha passat l'alumne a la plataforma",
    eus: 'Ikasleak plataforma guztian igaro duen denbora guztira',
    pt: 'Tempo total que o aluno passou na plataforma'
  },
  SELECT_VISIBILITY: {
    es: 'Seleccionar visibilidad',
    en: 'Select visibility',
    cat: 'Seleccionar visibilitat',
    eus: 'Ikusgarritasuna aukeratu',
    pt: 'Selecionar visibilidade'
  },
  PUBLIC_VISIBILITY: {
    es: 'Pública',
    en: 'Public',
    cat: 'Pública',
    eus: 'Publikoa',
    pt: 'Pública'
  },
  PRIVATE_VISIBILITY: {
    es: 'Privada',
    en: 'Private',
    cat: 'Privada',
    eus: 'Pribatua',
    pt: 'Privada'
  },
  CLAIMED: {
    es: 'Reclamado',
    en: 'Claimed',
    cat: 'Reclamat',
    eus: 'Erreklamatuta',
    pt: 'Reclamado'
  },
  NEW_USER_ADDED: {
    es: 'Nuevo usuario agregado a la academia',
    en: 'New user added to the academy',
    cat: "Nou usuari afegit a l'acadèmia",
    eus: 'Erabiltzaile berria akademiara gehitu da',
    pt: 'Novo usuário adicionado à academia'
  },
  USER_UPDATED_SUCCESSFULLY: {
    es: 'Usuario actualizado correctamente',
    en: 'User updated successfully',
    cat: 'Usuari actualitzat correctament',
    eus: 'Erabiltzailea ongi eguneratu da',
    pt: 'Usuário atualizado com sucesso'
  },
  [ERoles.MANAGER]: {
    es: 'Manager',
    en: 'Manager',
    cat: 'Manager',
    eus: 'Kudeatzailea',
    pt: 'Gestor'
  },
  [ERoles.TEACHER]: {
    es: 'Profesor',
    en: 'Teacher',
    cat: 'Professor',
    eus: 'Irakaslea',
    pt: 'Professor'
  },
  [ERoles.SALES]: {
    es: 'Ventas',
    en: 'Sales',
    cat: 'Vendes',
    eus: 'Saltzak',
    pt: 'Vendas'
  },
  [ERoles.SUPPORT]: {
    es: 'Soporte',
    en: 'Support',
    cat: 'Suport',
    eus: 'Laguntza',
    pt: 'Suporte'
  },
  [ERoles.INSPECTOR]: {
    es: 'Inspector',
    en: 'Inspector',
    cat: 'Inspector',
    eus: 'Azterketa',
    pt: 'Inspetor'
  },
  [ERoles.AI_TEACHER]: {
    es: 'Profesor IA',
    en: 'AI Teacher',
    cat: 'Professor IA',
    eus: 'IA irakaslea',
    pt: 'Professor IA'
  },
  [ERoles.ADMIN]: {
    es: 'Administrador',
    en: 'Admin',
    cat: 'Administrador',
    eus: 'Administratzailea',
    pt: 'Administrador'
  },
  ARE_YOU_SURE_TO_IMPERSONATE: {
    es: '¿Estás seguro de que quieres impersonar a {{ name }}?',
    en: 'Are you sure you want to impersonate {{ name }}?',
    cat: 'Estàs segur que vols impersonar a {{ name }}?',
    eus: 'Zihur zaude {{ name }} impersonatu nahi duzula?',
    pt: 'Tem certeza que deseja imitar {{ name }}?'
  },
  TEST_WIDGET_TOTAL_QUESTIONS: {
    es: 'Preguntas realizadas',
    en: 'Questions asked',
    cat: 'Preguntes realitzades',
    eus: 'Galderei egin zaien galderak',
    pt: 'Questões realizadas'
  },
  TEST_WIDGET_CORRECT_QUESTIONS: {
    es: 'Preguntas acertadas',
    en: 'Successful questions',
    cat: 'Preguntes encertades',
    eus: 'Ondo erantzun diren galderak',
    pt: 'Questões acertadas'
  },
  TEST_WIDGET_WRONG_QUESTIONS: {
    es: 'Preguntas falladas',
    en: 'Failed questions',
    cat: 'Preguntes fallades',
    eus: 'Gaizki erantzun diren galderak',
    pt: 'Questões erradas'
  },
  TEST_WIDGET_BLANK_QUESTIONS: {
    es: 'Preguntas sin contestar',
    en: 'Unanswered questions',
    cat: 'Preguntes sense contestar',
    eus: 'Erantzunik gabeko galderak',
    pt: 'Questões não respondidas'
  },
  TEST_WIDGET_AVG_TIME: {
    es: 'Tiempo medio por pregunta',
    en: 'Average time per question',
    cat: 'Temps mitjà per pregunta',
    eus: 'Galdera bakoitzeko batazbesteko denbora',
    pt: 'Tempo médio por questão'
  },
  FILTERS: {
    es: 'Filtros',
    en: 'Filters',
    cat: 'Filtres',
    eus: 'Iragazkiak',
    pt: 'Filtros'
  },
  TEST_WIDGET_TITLE: {
    es: 'Test',
    en: 'Test',
    cat: 'Prova',
    eus: 'Proba',
    pt: 'Prova'
  },
  TEST_WIDGET_SUBTITLE: {
    es: 'Estadísticas de los test realizados',
    en: 'Statistics of the tests performed',
    cat: 'Estadístiques de les proves realitzades',
    eus: 'Egin diren proben estatistikak',
    pt: 'Estatísticas das provas realizadas'
  },
  TEST_WIDGET_AVG_SCORE: {
    es: 'Nota media',
    en: 'Average score',
    cat: 'Nota mitjana',
    eus: 'Batazbesteko puntuazioa',
    pt: 'Média das notas'
  },
  ACTIVITY_NAME: {
    es: 'Nombre de actividad',
    en: 'Activity name',
    cat: 'Nom de l`activitat',
    eus: 'Jarduera izena',
    pt: 'Nome da atividade'
  },
  UPLOAD_DATE: {
    es: 'Fecha de subida',
    en: 'Upload date',
    cat: 'Data de pujada',
    eus: 'Igoera data',
    pt: 'Data de upload'
  },
  NUMBER_OF_PAGES: {
    es: 'Número de páginas',
    en: 'Number of pages',
    cat: 'Nombre de pàgines',
    eus: 'Orrialde kopurua',
    pt: 'Número de páginas'
  },
  NUMBER_OF_QUESTIONS: {
    es: 'Número de preguntas',
    en: 'Number of questions',
    cat: 'Nombre de preguntes',
    eus: 'Galdera kopurua',
    pt: 'Número de questões'
  },
  LAYOUT: {
    es: 'Maquetado',
    en: 'Layout',
    cat: 'Maquetació',
    eus: 'Diseinua',
    pt: 'Layout'
  },
  PUBLISHED: {
    es: 'Publicado',
    en: 'Published',
    cat: 'Publicat',
    eus: 'Argitaratua',
    pt: 'Publicado'
  },
  FINAL_REVISION: {
    es: 'Revisión final',
    en: 'Final revision',
    cat: 'Revisió final',
    eus: 'Azken errepaso',
    pt: 'Revisão final'
  },
  TEST: {
    es: 'Test',
    en: 'Test',
    cat: 'Prova',
    eus: 'Proba',
    pt: 'Prova'
  },
  VIDEOS: {
    es: 'Vídeos',
    en: 'Videos',
    cat: 'Vídeos',
    eus: 'Bideoak',
    pt: 'Vídeos'
  },
  DOCUMENTS: {
    es: 'Apuntes',
    en: 'Documents',
    cat: 'Apunts',
    eus: 'Dokumentuak',
    pt: 'Documentos'
  },
  REVIEWED: {
    es: 'Revisada',
    en: 'Reviewed',
    cat: 'Revisada',
    eus: 'Errebisatua',
    pt: 'Revisado'
  },
  NOT_REVIEWED: {
    es: 'En revisión',
    en: 'In review',
    cat: 'En revisió',
    eus: 'Aztertzen',
    pt: 'Em revisão'
  },
  QUESTIONS: {
    es: 'Nº de Preguntas',
    en: 'Nº of Questions',
    cat: 'Núm. de Preguntes',
    eus: 'Galdera zenbakia',
    pt: 'Número de questões'
  },
  SOUND: {
    es: 'Sonido',
    en: 'Sound',
    cat: 'So',
    eus: 'Soinua',
    pt: 'Sons'
  },
  IMAGE: {
    es: 'Imagen',
    en: 'Image',
    cat: 'Imatge',
    eus: 'Irudia',
    pt: 'Imagem'
  },
  SETTINGS: {
    es: 'Ajustes',
    en: 'Settings',
    cat: 'Configuració',
    eus: 'Ezarpenak',
    pt: 'Configurações'
  },
  SORT: {
    es: 'Clase',
    en: 'Class',
    cat: 'Classe',
    eus: 'Klase',
    pt: 'Classe'
  },
  HISTORIC: {
    es: 'Tabla de gestión',
    en: 'Management table',
    cat: 'Taula de gestió',
    eus: 'Kudeaketa taula',
    pt: 'Tabela de gestão'
  },
  DOWNLOAD_ALL: {
    es: 'Exportar todo',
    en: 'Export all',
    cat: 'Exportar tot',
    eus: 'Denak esportatu',
    pt: 'Exportar todos'
  },
  DOWNLOAD: {
    es: 'Descargar',
    en: 'Download',
    cat: 'Descarregar',
    eus: 'Deskargatu',
    pt: 'Descarregar'
  },
  PROCESSING_DATA: {
    es: 'Procesando los datos...',
    en: 'Processing data...',
    cat: 'Processant les dades...',
    eus: 'Datuak prozesatzen...',
    pt: 'Processando os dados...'
  },
  DOWNLOAD_SELECTED: {
    es: 'Descargar seleccionados',
    en: 'Download selected',
    cat: 'Descarregar seleccionats',
    eus: 'Hautatutakoak deskargatu',
    pt: 'Descarregar selecionados'
  },
  TEACHER_EMAIL: {
    es: 'Profesor',
    en: 'Teacher',
    cat: 'Professor',
    eus: 'Irakaslea',
    pt: 'Professor'
  },
  VERTICAL: {
    es: 'Vertical',
    en: 'Vertical',
    cat: 'Vertical',
    eus: 'Bertikala',
    pt: 'Vertical'
  },
  STATS: {
    es: 'Estadísticas',
    en: 'Stats',
    cat: 'Estadístiques',
    eus: 'Estatistikak',
    pt: 'Estatísticas'
  },
  STUDENT_TIME_WIDGET_TITLE: {
    es: 'Tiempo',
    en: 'Time',
    cat: 'Temps',
    eus: 'Denbora',
    pt: 'Tempo'
  },
  STUDENT_TIME_WIDGET_SUBTITLE: {
    es: 'De uso en la plataforma',
    en: 'Using the platform',
    cat: 'D`ús a la plataforma',
    eus: 'Plataforman erabiliz',
    pt: 'Usando a plataforma'
  },
  TOTAL_TICKETS: {
    es: 'total',
    en: 'total',
    cat: 'total',
    eus: 'guztiak',
    pt: 'total'
  },
  SELECT_SECTION: {
    es: 'Seleccionar sección',
    en: 'Select section',
    cat: 'Seleccionar secció',
    eus: 'Aukeratu atala',
    pt: 'Selecionar secção'
  },
  WELCOME_SUBTITLE_1: {
    es: 'Soy <a>Umy</a>, tu compi en esta lucha hacia tus objetivos. ⚡⚡️<br>Espero que traigas muchos sandwiches de queso 🤤<br>porque te necesitamos con muuucha energía.<br>¡Vamos a por todas! 😎',
    en: "I am <a>Umy</a>, your partner in this fight towards your goals. ⚡⚡️<br>I hope you bring many cheese sandwiches 🤤<br>because we need you with a lot of energy.<br>Let's go for it! 😎",
    cat: 'Sóc <a>Umy</a>, el teu company en aquesta lluita cap als teus objectius. ⚡⚡️<br>Espero que portis molts entrepans de formatge 🤤<br>perquè et necessitem amb muuucha energia.<br>Anem a per totes! 😎',
    eus: 'Nire izena <a>Umy</a> da, zure laguna helburu horietara heltzen. ⚡⚡️<br>Espero dutela gazta-odolostu asko 🤤<br>zure energia behar dugu.<br>¡Hemen gaude! 😎',
    pt: 'Sou <a>Umy</a>, seu parceiro nesta luta para alcançar seus objetivos. ⚡⚡️<br>Espero que traga muitos sanduíches de queijo 🤤<br>porque precisamos de você com muita energia.<br>Vamos lutar! 😎'
  },

  ADD_POINTS: {
    es: '+ {{ points }} puntos',
    en: '+ {{ points }} points',
    cat: '+ {{ points }} punts',
    eus: '+ {{ points }} puntu',
    pt: '+ {{ points }} pontos'
  },

  SUBSTRACT_POINTS: {
    es: '- {{ points }} puntos',
    en: '- {{ points }} points',
    cat: '- {{ points }} punts',
    eus: '- {{ points }} puntu',
    pt: '- {{ points }} pontos'
  },

  CLAIM_POINTS: {
    es: 'Recibir mis puntos',
    en: 'Claim my points',
    cat: 'Rebre els meus punts',
    eus: 'Nire puntuak jaso',
    pt: 'Reclamar meus pontos'
  },
  CLAIM_NUMBER_OF_POINTS: {
    es: 'RECLAMAR {{ points }} PUNTOS',
    en: 'CLAIM {{ points }} POINTS',
    cat: 'RECLAMAR {{ points }} PUNTS',
    eus: '{{ points }} PUNTU JASO',
    pt: 'RECLAMAR {{ points }} PONTOS'
  },
  QUESTIONS_TOTAL: {
    es: '<a>Total:</a> {{total}} preguntas',
    en: '<a>Total:</a> {{total}} questions',
    cat: '<a>Total:</a> {{total}} preguntes',
    eus: '<a>Totala:</a> {{total}} galdera',
    pt: '<a>Total:</a> {{total}} questões'
  },
  QUIZ_RESULTS: {
    es: 'Has acertado <a>{{correctAnswers}} de {{totalQuestions}}</a> preguntas',
    en: 'You got <a>{{correctAnswers}} out of {{totalQuestions}}</a> questions right',
    cat: 'Has encertat <a> {{correctAnswers}} de {{totalQuestions}}</a> preguntes',
    eus: '<a>{{correctAnswers}} galdera zuzen {{totalQuestions}}</a> galderetatik',
    pt: 'Você acertou <a>{{correctAnswers}} de {{totalQuestions}}</a> perguntas'
  },
  ANSWERS_TOTAL: {
    es: '<a>{{answer}}:</a> <b>{{total}}</b>',
    en: '<a>{{answer}}:</a> <b>{{total}}</b>',
    cat: '<a>{{answer}}:</a> <b>{{total}}</b>',
    eus: '<a>{{answer}}:</a> <b>{{total}}</b>',
    pt: '<a>{{answer}}:</a> <b>{{total}}</b>'
  },
  QUIZ_MODE: {
    es: 'Tipo de test',
    en: 'Quiz mode',
    cat: 'Tipus de prova',
    eus: 'Proba mota',
    pt: 'Modo de prova'
  },
  [EQuizMode.QUIZ]: {
    es: 'Quiz',
    en: 'Quiz',
    cat: 'Quiz',
    eus: 'Quiz',
    pt: 'Quiz'
  },
  [EQuizMode.TRUE_FALSE]: {
    es: 'Verdadero/Falso',
    en: 'True/False',
    cat: 'Veritat/Fals',
    eus: 'Egiazko/Derrigorrezkoa',
    pt: 'Verdadeiro/Falso'
  },
  [EQuizMode.PRACTICE]: {
    es: 'Simulacro',
    en: 'Practice',
    cat: 'Simulacre',
    eus: 'Simulakro',
    pt: 'Simulação'
  },
  [EQuizMode.PRACTICAL_CASE]: {
    es: 'Caso Práctico',
    en: 'Practical Case',
    cat: 'Cas Pràctic',
    eus: 'Praktike kasua',
    pt: 'Caso Prático'
  },
  [EQuizMode.LIGHTNING]: {
    es: 'Relámpago',
    en: 'Lightning',
    cat: 'Llampada',
    eus: 'Ikasti',
    pt: 'Relâmpago'
  },
  SELECTED_QUESTIONS_TO_ADD: {
    es: '<a>{{total}} preguntas</a> seleccionadas',
    en: '<a>{{total}} questions</a> selected',
    cat: '<a>{{total}} preguntes</a> seleccionades',
    eus: '<a>{{total}} galdera</a> hautatuak',
    pt: '<a>{{total}} questões</a> selecionadas'
  },
  [ECountry.AD]: {
    es: 'Andorra',
    en: 'Andorra',
    cat: 'Andorra',
    eus: 'Andorra',
    pt: 'Andorra'
  },
  [ECountry.AR]: {
    es: 'Argentina',
    en: 'Argentina',
    cat: 'Argentina',
    eus: 'Argentina',
    pt: 'Argentina'
  },
  [ECountry.BO]: {
    es: 'Bolivia',
    en: 'Bolivia',
    cat: 'Bolívia',
    eus: 'Bolivia',
    pt: 'Bolívia'
  },
  [ECountry.BR]: {
    es: 'Brasil',
    en: 'Brazil',
    cat: 'Brasil',
    eus: 'Brasil',
    pt: 'Brasil'
  },
  [ECountry.CL]: {
    es: 'Chile',
    en: 'Chile',
    cat: 'Xile',
    eus: 'Txile',
    pt: 'Chile'
  },
  [ECountry.CO]: {
    es: 'Colombia',
    en: 'Colombia',
    cat: 'Colòmbia',
    eus: 'Kolonbia',
    pt: 'Colômbia'
  },
  [ECountry.CR]: {
    es: 'Costa Rica',
    en: 'Costa Rica',
    cat: 'Costa Rica',
    eus: 'Costa Rica',
    pt: 'Costa Rica'
  },
  [ECountry.CU]: {
    es: 'Cuba',
    en: 'Cuba',
    cat: 'Cuba',
    eus: 'Kuba',
    pt: 'Cuba'
  },
  [ECountry.DO]: {
    es: 'República Dominicana',
    en: 'Dominican Republic',
    cat: 'República Dominicana',
    eus: 'Dominikar Errepublika',
    pt: 'República Dominicana'
  },
  [ECountry.EC]: {
    es: 'Ecuador',
    en: 'Ecuador',
    cat: 'Equador',
    eus: 'Ekuador',
    pt: 'Equador'
  },
  [ECountry.ES]: {
    es: 'España',
    en: 'Spain',
    cat: 'Espanya',
    eus: 'Espainia',
    pt: 'Espanha'
  },
  [ECountry.US]: {
    es: 'Estados Unidos',
    en: 'United States',
    cat: 'Estats Units',
    eus: 'Estatu Batuak',
    pt: 'Estados Unidos'
  },
  [ECountry.FR]: {
    es: 'Francia',
    en: 'France',
    cat: 'França',
    eus: 'Frantzia',
    pt: 'França'
  },
  [ECountry.GF]: {
    es: 'Guayana Francesa',
    en: 'French Guiana',
    cat: 'Guaiana Francesa',
    eus: 'Guyana Frantsesa',
    pt: 'Guiana Francesa'
  },
  [ECountry.MA]: {
    es: 'Marruecos',
    en: 'Morocco',
    cat: 'Marroc',
    eus: 'Maroko',
    pt: 'Marrocos'
  },

  [ECountry.GT]: {
    es: 'Guatemala',
    en: 'Guatemala',
    cat: 'Guatemala',
    eus: 'Guatemala',
    pt: 'Guatemala'
  },
  [ECountry.HT]: {
    es: 'Haiti',
    en: 'Haiti',
    cat: 'Haití',
    eus: 'Haiti',
    pt: 'Haiti'
  },
  [ECountry.HN]: {
    es: 'Honduras',
    en: 'Honduras',
    cat: 'Hondures',
    eus: 'Honduras',
    pt: 'Honduras'
  },
  [ECountry.IN]: {
    es: 'India',
    en: 'India',
    cat: 'Índia',
    eus: 'India',
    pt: 'Índia'
  },
  [ECountry.JM]: {
    es: 'Jamaica',
    en: 'Jamaica',
    cat: 'Jamaica',
    eus: 'Jamaika',
    pt: 'Jamaica'
  },
  [ECountry.MX]: {
    es: 'México',
    en: 'Mexico',
    cat: 'Mèxic',
    eus: 'Mexiko',
    pt: 'México'
  },
  [ECountry.NI]: {
    es: 'Nicaragua',
    en: 'Nicaragua',
    cat: 'Nicaragua',
    eus: 'Nikaragua',
    pt: 'Nicarágua'
  },
  [ECountry.PA]: {
    es: 'Panamá',
    en: 'Panama',
    cat: 'Panamà',
    eus: 'Panama',
    pt: 'Panamá'
  },
  [ECountry.PY]: {
    es: 'Paraguay',
    en: 'Paraguay',
    cat: 'Paraguai',
    eus: 'Paraguai',
    pt: 'Paraguai'
  },
  [ECountry.PE]: {
    es: 'Perú',
    en: 'Peru',
    cat: 'Perú',
    eus: 'Peru',
    pt: 'Peru'
  },
  [ECountry.PR]: {
    es: 'Puerto Rico',
    en: 'Puerto Rico',
    cat: 'Puerto Rico',
    eus: 'Puerto Rico',
    pt: 'Porto Rico'
  },
  [ECountry.PT]: {
    es: 'Portugal',
    en: 'Portugal',
    cat: 'Portugal',
    eus: 'Portugal',
    pt: 'Portugal'
  },
  [ECountry.RU]: {
    es: 'Rusia',
    en: 'Russia',
    cat: 'Rússia',
    eus: 'Errusia',
    pt: 'Rússia'
  },
  [ECountry.SR]: {
    es: 'Surinam',
    en: 'Suriname',
    cat: 'Surinam',
    eus: 'Surinam',
    pt: 'Suriname'
  },
  [ECountry.SV]: {
    es: 'El Salvador',
    en: 'El Salvador',
    cat: 'El Salvador',
    eus: 'El Salvador',
    pt: 'El Salvador'
  },
  [ECountry.UY]: {
    es: 'Uruguay',
    en: 'Uruguay',
    cat: 'Uruguai',
    eus: 'Uruguai',
    pt: 'Uruguai'
  },
  [ECountry.VE]: {
    es: 'Venezuela',
    en: 'Venezuela',
    cat: 'Veneçuela',
    eus: 'Venezuela',
    pt: 'Venezuela'
  },
  [ECountry.GB]: {
    es: 'Reino Unido',
    en: 'United Kingdom',
    cat: 'Regne Unit',
    eus: 'Erresuma Batua',
    pt: 'Reino Unido'
  },
  [EYearMonths.JANUARY]: {
    es: 'Enero',
    en: 'January',
    cat: 'Gener',
    eus: 'Urtarrila',
    pt: 'Janeiro'
  },
  [EYearMonths.FEBRUARY]: {
    es: 'Febrero',
    en: 'February',
    cat: 'Febrer',
    eus: 'Otsaila',
    pt: 'Fevereiro'
  },
  [EYearMonths.MARCH]: {
    es: 'Marzo',
    en: 'March',
    cat: 'Març',
    eus: 'Martxoa',
    pt: 'Março'
  },
  [EYearMonths.APRIL]: {
    es: 'Abril',
    en: 'April',
    cat: 'Abril',
    eus: 'Apirila',
    pt: 'Abril'
  },
  [EYearMonths.MAY]: {
    es: 'Mayo',
    en: 'May',
    cat: 'Maig',
    eus: 'Maiatza',
    pt: 'Maio'
  },
  [EYearMonths.JUNE]: {
    es: 'Junio',
    en: 'June',
    cat: 'Juny',
    eus: 'Ekaina',
    pt: 'Junho'
  },
  [EYearMonths.JULY]: {
    es: 'Julio',
    en: 'July',
    cat: 'Juliol',
    eus: 'Uztaila',
    pt: 'Julho'
  },
  [EYearMonths.AUGUST]: {
    es: 'Agosto',
    en: 'August',
    cat: 'Agost',
    eus: 'Abuztua',
    pt: 'Agosto'
  },
  [EYearMonths.SEPTEMBER]: {
    es: 'Septiembre',
    en: 'September',
    cat: 'Setembre',
    eus: 'Iraila',
    pt: 'Setembro'
  },
  [EYearMonths.OCTOBER]: {
    es: 'Octubre',
    en: 'October',
    cat: 'Octubre',
    eus: 'Urria',
    pt: 'Outubro'
  },
  [EYearMonths.NOVEMBER]: {
    es: 'Noviembre',
    en: 'November',
    cat: 'Novembre',
    eus: 'Azaroa',
    pt: 'Novembro'
  },
  [EYearMonths.DECEMBER]: {
    es: 'Diciembre',
    en: 'December',
    cat: 'Desembre',
    eus: 'Abendua',
    pt: 'Dezembro'
  },
  YOUR_EXAM_GROUPS_EMPTY: {
    es: 'No estás apuntado a ninguna convocatoria',
    en: 'You are not registered for any exam group',
    cat: 'No estàs apuntat a cap convocatòria',
    eus: 'Ez zaude inor ere apuntatu',
    pt: 'Não está inscrito em nenhuma convocatória'
  },
  JOIN_EXAM_GROUP: {
    es: 'Unirme a una convocatoria',
    en: 'Join exam group',
    cat: 'Unir-me a convocatòria',
    eus: 'Taldean apuntatu',
    pt: 'Inscreva-se em uma convocatória'
  },
  NEW_CHAT_MESSAGE: {
    es: 'Nuevo mensaje',
    en: 'New message',
    cat: 'Nou missatge',
    eus: 'Mezua berria',
    pt: 'Nova mensagem'
  },
  HUBSPOT_CONTACT: {
    es: 'Contacto de Hubspot',
    en: 'Hubspot contact',
    cat: 'Contacte de Hubspot',
    eus: 'Hubspot kontaktua',
    pt: 'Contacto de Hubspot'
  },
  HUBSPOT_ID: {
    es: 'ID de Hubspot',
    en: 'Hubspot ID',
    cat: 'ID de Hubspot',
    eus: 'Hubspot IDa',
    pt: 'ID de Hubspot'
  },
  SELECT_HUBSPOT_CONTACT: {
    es: 'Seleccionar contacto de Hubspot',
    en: 'Select Hubspot contact',
    cat: 'Seleccionar contacte de Hubspot',
    eus: 'Hubspot kontaktua hautatu',
    pt: 'Selecionar contacto de Hubspot'
  },
  GO_TO_HUBSPOT_CONTACT: {
    es: 'Ir al contacto asociado de hubspot',
    en: 'Go to the associated hubspot contact',
    cat: 'Anar al contacte associat de hubspot',
    eus: 'Joan hubspot kontaktu batera',
    pt: 'Ir para o contacto associado de Hubspot'
  },
  [EActivityAuditStatus.CORRECT]: {
    es: 'Correcto',
    en: 'Correct',
    cat: 'Correcte',
    eus: 'Zuzena',
    pt: 'Correto'
  },
  [EActivityAuditStatus.OBSOLETE]: {
    es: 'Obsoleto',
    en: 'Obsolete',
    cat: 'Obsolet',
    eus: 'Zaharkitua',
    pt: 'Obsoleto'
  },
  [EActivityAuditStatus.NON_COMPLIANT_STANDARDS]: {
    es: 'No cumple estándares',
    en: 'Does not meet standards',
    cat: 'No compleix estàndards',
    eus: 'Estandariek ez ditu betetzen',
    pt: 'Não cumpre os padrões'
  },
  [EActivityAuditStatus.OLD_FORMAT]: {
    es: 'Formato antiguo',
    en: 'Old format',
    cat: 'Format antic',
    eus: 'Formatu zaharra',
    pt: 'Formato antigo'
  },
  STUDENT_INFO: {
    es: 'Información del alumno',
    en: 'Student info',
    cat: 'Informació de l`alumne',
    eus: 'Ikaslearen informazioa',
    pt: 'Informação do aluno'
  },
  STUDENT_FIRST_PAYMENT: {
    es: 'Fecha de inscripción (primer pago)',
    en: 'Registration date (first payment)',
    cat: 'Data d`inscripció (primer pagament)',
    eus: 'Izen-emate data (lehenengo ordaina)',
    pt: 'Data de inscrição (primeiro pagamento)'
  },
  TAG_ASSOCIATED: {
    es: 'Categoría (tag) asociada',
    en: 'Associated category (tag)',
    cat: 'Categoria (tag) associada',
    eus: 'Kategoria (tag) lotura',
    pt: 'Categoria (tag) associada'
  },
  RESEND_KEYS: {
    es: 'Regenerar y enviar claves de acceso',
    en: 'Regenerate and send access keys',
    cat: 'Regenerar i enviar claus d`accés',
    eus: 'Berriz sortu eta bidali sarbide gakoak',
    pt: 'Regenerar e enviar chaves de acesso'
  },
  IMPERSONATE_STUDENT: {
    es: 'Impersonar al alumno',
    en: 'Impersonate student',
    cat: 'Impersonar a l`alumne',
    eus: 'Ikaslearen pertsona batu',
    pt: 'Simular aluno'
  },
  HUBSPOT_CONTACT_NOT_FOUND: {
    es: 'No se ha asociado este alumno con ningún contacto de Hubspot',
    en: 'No se ha asociado este alumno con ningún contacto de Hubspot',
    cat: 'No se ha asociado aquest alumne amb cap contacte de Hubspot',
    eus: 'Ikaslearen hubspot kontaktua ez da aurkitu',
    pt: 'Não foi associado este aluno a nenhum contacto de Hubspot'
  },
  SUMMARY: {
    es: 'Perfil',
    en: 'Profile',
    cat: 'Perfil',
    eus: 'Profila',
    pt: 'Perfil'
  },
  MY_CALIFICATIONS: {
    es: 'Mis calificaciones',
    en: 'My califications',
    cat: 'Les meves qualificacions',
    eus: 'Nire kalifikazioak',
    pt: 'Minhas calificações'
  },
  RECOMMEND_FRIENDS: {
    es: 'Refiere y gana',
    en: 'Recommend and win',
    cat: 'Recomana i guanya',
    eus: 'Gomendatu eta irabazi',
    pt: 'Recomendar e ganhar'
  },
  TRAINING_INFO: {
    es: 'Datos de tu formación',
    en: 'Your training data',
    cat: 'Dades de la teva formació',
    eus: 'Zure prestakuntzaren datuak',
    pt: 'Dados da sua formação'
  },
  ALL_EXAM_GROUPS: {
    es: 'Todas las convocatorias',
    en: 'All exam groups',
    cat: 'Totes les convocatòries',
    eus: 'Azterketa talde guztiak',
    pt: 'Todas as convocatórias'
  },
  NOTIFICATION_SETTINGS: {
    es: 'Configuración de notificaciones',
    en: 'Notification settings',
    cat: 'Configuració de notificacions',
    eus: 'Jakinarazpenen ezarpenak',
    pt: 'Configurações de notificações'
  },
  UCADEMY_COMMUNITY: {
    es: 'Comunidad de Ucademy',
    en: 'Ucademy community',
    cat: 'Comunitat de Ucademy',
    eus: 'Ucademy komunitatea',
    pt: 'Comunidade de Ucademy'
  },
  PUBLISHED_AT: {
    es: 'Publicada el: {{ date }}',
    en: 'Published at: {{ date }}',
    cat: 'Publicada el: {{ date }}',
    eus: 'Argitaratua: {{ date }}',
    pt: 'Publicado em: {{ date }}'
  },
  VIEW_MORE_EXAM_GROUPS: {
    es: 'Ver más convocatorias',
    en: 'View more exam groups',
    cat: 'Veure més convocatòries',
    eus: 'Ikusi gehiago azterketak',
    pt: 'Ver mais convocatórias'
  },
  STREAK_DAYS: {
    es: 'Días seguidos accediendo',
    en: 'Consecutive days accessing',
    cat: 'Dies seguits accedint',
    eus: 'Egun jarraituak sartzen',
    pt: 'Dias consecutivos acessando'
  },
  DAYS_one: {
    es: '1 día',
    en: '1 day',
    cat: '1 dia',
    eus: '1 egun',
    pt: '1 dia'
  },
  DAYS_other: {
    es: '{{count}} días',
    en: '{{count}} days',
    cat: '{{count}} dies',
    eus: '{{count}} egun',
    pt: '{{count}} dias'
  },
  CHOOSE_AN_OPTION: {
    es: 'Elige una opción',
    en: 'Choose an option',
    cat: 'Tria una opció',
    eus: 'Aukeratu aukera bat',
    pt: 'Escolher uma opção'
  },
  [EStudyField.SCIENCES]: {
    es: 'Ciencias',
    en: 'Sciences',
    cat: 'Ciències',
    eus: 'Zientziak',
    pt: 'Ciências'
  },
  [EStudyField.SOCIALS]: {
    es: 'Sociales',
    en: 'Socials',
    cat: 'Socials',
    eus: 'Sozialak',
    pt: 'Socials'
  },
  [EStudyField.HUMANITIES]: {
    es: 'Humanidades',
    en: 'Humanities',
    cat: 'Humanitats',
    eus: 'Gizarte zientziak',
    pt: 'Humanidades'
  },
  [EStudyField.ARTS]: {
    es: 'Artes',
    en: 'Arts',
    cat: 'Arts',
    eus: 'Arteak',
    pt: 'Artes'
  },
  THIS_DATA_IS_PRIVATE: {
    es: 'Este dato es completamente privado y lo usaremos solo con fines estadísticos',
    en: 'This data is completely private and we will use it only for statistical purposes',
    cat: 'Aquesta dada és completament privada i la farem servir només amb finalitats estadístiques',
    eus: 'Datu hau erabat pribatua da eta estatistika helburuetarako erabiliko dugu soilik',
    pt: 'Este dado é completamente privado e usaremos apenas para fins estatísticos'
  },
  [EVerticalNames.UNI]: {
    es: 'Acceso a la Universidad',
    en: 'University access',
    cat: 'Accés a la Universitat',
    eus: 'Unibertsitatean sartzeko',
    pt: 'Acesso à Universidade'
  },
  [EVerticalNames.OPOS]: {
    es: 'Oposiciones',
    en: 'Oppositions',
    cat: 'Oposicions',
    eus: 'Oposizioak',
    pt: 'Oposições'
  },
  [EVerticalNames.FP]: {
    es: 'Formación Profesional',
    en: 'Professional training',
    cat: 'Formació Professional',
    eus: 'Lanbide Heziketa',
    pt: 'Formação Profissional'
  },
  [EVerticalNames.WKC]: {
    es: 'Workcamps',
    en: 'Workcamps',
    cat: 'Workcamps',
    eus: 'Workcamps',
    pt: 'Workcamps'
  },
  [ETimePreference.MORNING]: {
    es: 'Por la mañana',
    en: 'In the morning',
    cat: 'Al matí',
    eus: 'Goizean',
    pt: 'Pela manhã'
  },
  [ETimePreference.NOON]: {
    es: 'Al mediodía',
    en: 'At noon',
    cat: 'Al migdia',
    eus: 'Egunerako',
    pt: 'À meio-dia'
  },
  [ETimePreference.AFTERNOON]: {
    es: 'Por la tarde',
    en: 'In the afternoon',
    cat: 'A la tarda',
    eus: 'Arratsaldean',
    pt: 'À tarde'
  },
  [ETimePreference.EVENING]: {
    es: 'A última hora',
    en: 'At the last minute',
    cat: 'A última hora',
    eus: 'Gauan',
    pt: 'À noite'
  },
  HOW_DID_YOU_DISCOVER_US: {
    es: 'Ficha confirmada. Dinos {{name}}: ¿Cómo nos conociste por <a>primera vez?</a>',
    en: 'Confirmed tab. Tell us {{name}}: How did you find us for the <a>first time?</a>',
    cat: 'Fitxa confirmada. Digues-nos {{name}}: Com ens vas conèixer per <a>primera vegada?</a>',
    eus: 'Fitxa baieztatua. Esan {{name}}: Nola ezagutu zaitugu <a>lehenengo aldiz?</a>',
    pt: 'Ficha confirmada. Diz-nos {{name}}: Como nos conheceu pela <a>primeira vez?</a>'
  },
  STUDENT_SPECIFIC_INFORMATION: {
    es: 'Datos específicos',
    en: 'Specific data',
    cat: 'Dades específiques',
    eus: 'Berezko datuak',
    pt: 'Dados específicos'
  },
  LAST_14_DAYS: {
    es: 'Últimos 14 días',
    en: 'Last 14 days',
    cat: 'Últims 14 dies',
    eus: 'Azken 14 egunak',
    pt: 'Últimos 14 dias'
  },
  NUMBER_OF_ACTIVITIES: {
    es: '{{count}} actividades',
    en: '{{count}} activities',
    cat: '{{count}} activitats',
    eus: '{{count}} eskubideak',
    pt: '{{count}} atividades'
  },
  COMPLETED_PREVIEW: {
    es: 'completadas',
    en: 'completed',
    cat: 'completades',
    eus: 'betetzen',
    pt: 'completados'
  },
  NUMBER_OF_HOURS: {
    es: '{{count}} horas',
    en: '{{count}} hours',
    cat: '{{count}} hores',
    eus: '{{count}} ordu',
    pt: '{{count}} horas'
  },
  IN_APP: {
    es: 'en la plataforma',
    en: 'in the app',
    cat: 'en la plataforma',
    eus: 'plataforman',
    pt: 'na plataforma'
  },
  NUMBER_OF_TESTS: {
    es: '{{count}} tests',
    en: '{{count}} tests',
    cat: '{{count}} tests',
    eus: '{{count}} testak',
    pt: '{{count}} testes'
  },
  DONE: {
    es: 'realizados',
    en: 'done',
    cat: 'realitzats',
    eus: 'egindakoak',
    pt: 'realizados'
  },
  ACTIVITIES_COMPLETED_IN_LAST_14_DAYS: {
    es: 'Actividades completadas en los últimos 14 días',
    en: 'Activities completed in the last 14 days',
    cat: 'Activitats completades en els darrers 14 dies',
    eus: 'Eskubideak azken 14 egunetan betetzen',
    pt: 'Atividades completadas nos últimos 14 dias'
  },
  DONE_ON: {
    es: 'Realizada el',
    en: 'Done on',
    cat: 'Realitzada el',
    eus: 'Eskubidearen eguna',
    pt: 'Realizada em'
  },
  PLANIFICATION_RESULT_CONTENT_UNDER_TIME: {
    es: 'Tendrías que estudiar <a>{{minutes}} minutos al día.</a>',
    en: 'You would have to study <a>{{minutes}} minutes a day.</a>',
    cat: 'Tindries d`estudiar <a>{{minutes}} minuts al dia.</a>',
    eus: 'Egunero <a>{{minutes}} minutu</a> ikasi beharko zenituzke.',
    pt: 'Teria que estudar <a>{{minutes}} minutos por dia.</a>'
  },
  PLANIFICATION_RESULT_CONTENT_OVER_TIME: {
    es: 'Tendrías que estudiar <a>{{hours}} horas y {{minutes}} minutos al día.</a>',
    en: 'You would have to study <a>{{hours}} hours and {{minutes}} minutes a day.</a>',
    cat: 'Tindries d`estudiar <a>{{hours}} hores i {{minutes}} minuts al dia.</a>',
    eus: 'Egunero <a>{{hours}} ordu eta {{minutes}} minutu</a> ikasi beharko zenituzke.',
    pt: 'Teria que estudar <a>{{hours}} horas e {{minutes}} minutos por dia.</a>'
  },
  TUTOR: {
    es: 'Tutor',
    en: 'Tutor',
    cat: 'Tutor',
    eus: 'Tutorea',
    pt: 'Tutora'
  },
  TUTOR_NOT_ASSIGNED: {
    es: 'Tutor no asignado',
    en: 'Tutor not assigned',
    cat: 'Tutor no assignat',
    eus: 'Tutorea esleitua',
    pt: 'Tutora não atribuída'
  },
  SELECT_TUTOR: {
    es: 'Seleccionar tutor',
    en: 'Select tutor',
    cat: 'Seleccionar tutor',
    eus: 'Aukeratu tutorea',
    pt: 'Selecionar tutora'
  },
  ROLE: {
    es: 'Rol',
    en: 'Role',
    cat: 'Rol',
    eus: 'Rol',
    pt: 'Rol'
  },
  ONLINE_USERS: {
    es: 'Usuarios online',
    en: 'Online users',
    cat: 'Usuaris online',
    eus: 'Online erabiltzaileak',
    pt: 'Usuários online'
  },
  ONLINE_TOOLTIP: {
    es: 'Online/Offline',
    en: 'Online/Offline',
    cat: 'Online/Offline',
    eus: 'Online/Offline',
    pt: 'Online/Offline'
  },
  DOWNLOAD_APP: {
    es: 'Descarga la app',
    en: 'Download the app',
    cat: "Descarrega l'app",
    eus: 'Deskargatu aplikazioa',
    pt: 'Descarregar a aplicação'
  },
  ALL_TESTS: {
    es: 'Todos los tests',
    en: 'All tests',
    cat: 'Tots els tests',
    eus: 'Guztiak testak',
    pt: 'Todos os testes'
  },
  REVIEW_FAILURES: {
    es: 'Repaso de fallos',
    en: 'Review failures',
    cat: 'Revisió de falles',
    eus: 'Hutsak berrikustea',
    pt: 'Revisão de erros'
  },
  STATISTICS: {
    es: 'Estadísticas',
    en: 'Statistics',
    cat: 'Estadístiques',
    eus: 'Estatistikak',
    pt: 'Estatísticas'
  },
  NEW_APP: {
    es: '¡Tenemos nueva app!',
    en: 'We have a new app!',
    cat: 'Tenim una nova app!',
    eus: 'Aplikazio berria daukagu!',
    pt: 'Temos uma nova aplicação!'
  },
  DOWNLOAD_APP_NOW: {
    es: 'Descárgala ahora:',
    en: 'Download it now:',
    cat: 'Descarrega-la ara:',
    eus: 'Deskargatu orain:',
    pt: 'Descarregue-a agora:'
  },
  GET_IT_ON_GOOGLE_PLAY: {
    es: '¡Consíguela en Google Play!',
    en: 'Get it on Google Play!',
    cat: 'Aconsegueix-la a Google Play!',
    eus: 'Lortu Google Play-en!',
    pt: 'Obtenha-a no Google Play!'
  },
  DOWNLOAD_ON_THE_APP_STORE: {
    es: '¡Descárgala en la App Store!',
    en: 'Download it on the App Store!',
    cat: "Descarrega-la a l'App Store!",
    eus: 'Deskargatu App Storean!',
    pt: 'Descarregue-a na App Store!'
  },
  CHANGE_STATUS: {
    es: 'Cambiar estado',
    en: 'Change status',
    cat: 'Canviar estat',
    eus: 'Egoera aldatu',
    pt: 'Alterar estado'
  },
  CHANGE_STATUS_CONFIRMATION: {
    es: '¿Estás seguro de que deseas cambiar el estado de {{count}} estudiantes?',
    en: 'Are you sure you want to change the status of {{count}} students?',
    cat: 'Estàs segur que vols canviar l`estat d`aquests {{count}} alumnes?',
    eus: 'Ziur {{count}} ikasleen egoera aldatu nahi duzula?',
    pt: 'Tem certeza que deseja alterar o estado de {{count}} alunos?'
  },
  PLANIFICATION_EMPTY: {
    es: 'Crea tu planificación del estudio para saber qué tienes que hacer cada día',
    en: 'Create your study plan to know what you have to do each day',
    cat: 'Crea la teva planificació del estudi per saber què has de fer cada dia',
    eus: 'Eskubide-planifikazioa sortu zure eguneroko egin beharko duzun gauzak ikusteko',
    pt: 'Crie o seu plano de estudo para saber o que tem de fazer cada dia'
  },
  PLANIFICATION_SHOW: {
    es: 'Mostrar planificación',
    en: 'Show planification',
    cat: 'Mostrar planificació',
    eus: 'Erakutsi planifikazioa',
    pt: 'Mostrar planificação'
  },
  PLANIFICATION_HIDE: {
    es: 'Ocultar planificación',
    en: 'Hide planification',
    cat: 'Ocultar planificació',
    eus: 'Ez erakutsi planifikazioa',
    pt: 'Esconder planificação'
  },
  PLANIFICATION_NEW: {
    es: 'Planificar mi estudio',
    en: 'Plan my study',
    cat: 'Planificar el meu estudi',
    eus: 'Eskubide-planifikazioa sortu',
    pt: 'Criar plano de estudo'
  },
  PLANIFICATION_CURRENT_WEEK_INFO: {
    es: 'Semana {{week}}, día {{day}}',
    en: 'Week {{week}}, day {{day}}',
    cat: 'Setmana {{week}}, dia {{day}}',
    eus: 'Aste {{week}}, egun {{day}}',
    pt: 'Semana {{week}}, dia {{day}}'
  },
  PLANIFICATION_VIEW_ALL: {
    es: 'Ver planificación',
    en: 'View planification',
    cat: 'Veure planificació',
    eus: 'Erakutsi planifikazioa',
    pt: 'Ver planificação'
  },
  PLANIFICATION_HOW_GOING: {
    es: '¿Cómo voy?',
    en: 'How am I going?',
    cat: 'Com vaig?',
    eus: 'Nola egongo?',
    pt: 'Como estou indo?'
  },
  PLANIFICATION_THIS_WEEK_STUDY: {
    es: 'Esta semana estudias:',
    en: 'This week you study:',
    cat: 'Aquesta setmana estudies:',
    eus: 'Aste hau zuk egiten duzula:',
    pt: 'Esta semana você estuda:'
  },
  PLANIFICATION_REST_DAY: {
    es: 'Vacaciones',
    en: 'Holidays',
    cat: 'Vacances',
    eus: 'Urtebeteak',
    pt: 'Férias'
  },
  PLANIFICATION_ACTIVITIES_one: {
    es: '{{count}} actividad por completar',
    en: '{{count}} activity to complete',
    cat: '{{count}} activitat per completar',
    eus: '{{count}} eskubide betetu behar',
    pt: '{{count}} atividade por completar'
  },
  PLANIFICATION_ACTIVITIES_other: {
    es: '{{count}} actividades por completar',
    en: '{{count}} activities to complete',
    cat: '{{count}} activitats per completar',
    eus: '{{count}} eskubide betetu behar',
    pt: '{{count}} atividades por completar'
  },
  PLANIFICATION_MORE_SECTIONS: {
    es: '+ {{count}} temas más',
    en: '+ {{count}} more sections',
    cat: '+ {{count}} temes més',
    eus: '+ {{count}} gehiago temak',
    pt: '+ {{count}} temas mais'
  },
  PLANIFICATION_ALL_DAY_COMPLETED: {
    es: 'Todas las actividades completadas',
    en: 'All activities completed',
    cat: 'Totes les activitats completades',
    eus: 'Eskubide guztiak betetzen',
    pt: 'Todas as atividades completadas'
  },
  PLANIFICATION_CAROUSEL_ITEM_MODAL_DESCRIPTION: {
    es: 'Te decimos lo que deberías hacer este día para cumplir con tu planificación. No olvides repasar después haciendo tests.',
    en: 'We tell you what you should do today to comply with your plan. Don`t forget to review after doing tests.',
    cat: 'Te decimos lo que deberías hacer este día para cumplir con tu planificación. No olvides repasar después haciendo tests.',
    eus: 'Egunero zuk egin beharko duzun gauza eta planifikazioa betetzea. Ez ahaztu gauzak egin eta testak egitea gero.',
    pt: 'Te dizemos o que deveria fazer hoje para cumprir com o seu plano. Não se esqueça de rever depois de fazer os testes.'
  },
  PROMOTION_CREATED_SUCCESSFULLY: {
    es: 'Promoción creada correctamente',
    en: 'Promotion created successfully',
    cat: 'Promoció creada correctament',
    eus: 'Promozioa ongi sortu',
    pt: 'Promoção criada com sucesso'
  },
  PROMOTION_UPDATED_SUCCESSFULLY: {
    es: 'Promoción actualizada correctamente',
    en: 'Promotion updated successfully',
    cat: 'Promoció actualitzada correctament',
    eus: 'Promozioa ongi eguneratua',
    pt: 'Promoção atualizada com sucesso'
  },
  PROMOTION_DELETED_SUCCESSFULLY: {
    es: 'Promoción eliminada correctamente',
    en: 'Promotion deleted successfully',
    cat: 'Promoció eliminada correctament',
    eus: 'Promozioa ongi ezabatua',
    pt: 'Promoção eliminada com sucesso'
  },
  EXAMS_SCORES: {
    es: 'Notas de examen',
    en: 'Exam scores',
    cat: "Notes d'examen",
    eus: 'Ikasle-notak',
    pt: 'Notas de exame'
  },
  SELECT_PROMOTION: {
    es: 'Selecciona promoción',
    en: 'Select promotion',
    cat: 'Selecciona promoció',
    eus: 'Aukeratu promozioa',
    pt: 'Selecionar promoção'
  },
  SELECT_TEST: {
    es: 'Selecciona test',
    en: 'Select test',
    cat: 'Selecciona test',
    eus: 'Aukeratu testua',
    pt: 'Selecionar teste'
  },
  EXAM_CREATED_SUCCESSFULLY: {
    es: 'Examen creado correctamente',
    en: 'Exam created successfully',
    cat: 'Examen creat correctament',
    eus: 'Ekzamen ongi sortu',
    pt: 'Exame criado com sucesso'
  },
  EXAM_UPDATED_SUCCESSFULLY: {
    es: 'Examen actualizado correctamente',
    en: 'Exam updated successfully',
    cat: 'Examen actualitzat correctament',
    eus: 'Ekzamen ongi eguneratua',
    pt: 'Exame atualizado com sucesso'
  },
  EXAM_DELETED_SUCCESSFULLY: {
    es: 'Examen eliminado correctamente',
    en: 'Exam deleted successfully',
    cat: 'Examen eliminat correctament',
    eus: 'Ekzamen ongi ezabatua',
    pt: 'Exame eliminado com sucesso'
  },
  TEACHER_SCORE: {
    es: 'Nota del profesor',
    en: 'Teacher score',
    cat: 'Nota del professor',
    eus: 'Ikasle-notak',
    pt: 'Nota do professor'
  },
  DESCRIPTION: {
    es: 'Descripción',
    en: 'Description',
    cat: 'Descripció',
    eus: 'Deskribapena',
    pt: 'Descrição'
  },
  EXAM_DATE: {
    es: 'Día del examen',
    en: 'Exam day',
    cat: 'Data de l`examen',
    eus: 'Ikasle-notak',
    pt: 'Dia do exame'
  },
  SEE_INFORMATION: {
    es: 'Ver información',
    en: 'See information',
    cat: 'Veure informació',
    eus: 'Ikusi informazioa',
    pt: 'Ver informação'
  },
  NOT_SCORED: {
    es: 'No puntuado',
    en: 'Not scored',
    cat: 'No puntuado',
    eus: 'Ez da puntuatua',
    pt: 'Não pontuado'
  },
  DELIVERABLE: {
    es: 'Documento entregable',
    en: 'Deliverable document',
    cat: 'Document entregable',
    eus: 'Entregatutako dokumentua',
    pt: 'Documento entregável'
  },
  ONSITE: {
    es: 'Examen presencial',
    en: 'Onsite exam',
    cat: 'Examen presencial',
    eus: 'Preskribatutako ikasle-notak',
    pt: 'Exame presencial'
  },
  ONLINE: {
    es: 'Examen online',
    en: 'Online exam',
    cat: 'Examen online',
    eus: 'Online ikasle-notak',
    pt: 'Exame online'
  },
  LAST_UPDATE: {
    es: 'Última actualización',
    en: 'Last update',
    cat: 'Última actualització',
    eus: 'Azken eguneraketa',
    pt: 'Última atualização'
  },
  FILE: {
    es: 'Archivo',
    en: 'File',
    cat: 'Fitxer',
    eus: 'Fitxategia',
    pt: 'Ficheiro'
  },
  EXAM_DAY: {
    es: '<a>Día del examen:</a> <b>{{date}}</b>',
    en: '<a>Exam day:</a> <b>{{date}}</b>',
    cat: "<a>Dia de l'examen:</a> <b>{{date}}</b>",
    eus: '<a>Ezamenaren eguna:</a> <b>{{date}}</b>',
    pt: '<a>Dia do exame:</a> <b>{{date}}</b>'
  },
  SCORE_CREATED_SUCCESSFULLY: {
    es: 'Nota puesta correctamente',
    en: 'Score created successfully',
    cat: 'Nota creada correctament',
    eus: 'Ikasle-notak ongi sortu',
    pt: 'Nota criada com sucesso'
  },
  SCORE_UPDATED_SUCCESSFULLY: {
    es: 'Nota actualizada correctamente',
    en: 'Score updated successfully',
    cat: 'Nota actualitzada correctament',
    eus: 'Ikasle-notak ongi eguneratua',
    pt: 'Nota atualizada com sucesso'
  },
  CONTENT: {
    es: 'Contenido',
    en: 'Content',
    cat: 'Contingut',
    eus: 'Edukia',
    pt: 'Conteúdo'
  },
  TAG: {
    es: 'Formación',
    en: 'Tag',
    cat: 'Formació',
    eus: 'Formakuntza',
    pt: 'Formação'
  },
  HOW_IS_GOING_STATUS_GOOD_TITLE: {
    es: '¡Vas súper bien!',
    en: '¡You are doing great!',
    cat: '¡Estàs fent molt bé!',
    eus: '¡Eskubide guztiak betetzen!',
    pt: '¡Estás a fazer um excelente trabalho!'
  },
  HOW_IS_GOING_STATUS_GOOD_SUMMARY: {
    es: 'Prácticamente vas al día según tu planificación.',
    en: 'You are almost on track with your plan.',
    cat: 'Estàs gairebé en ruta amb la teva planificació.',
    eus: 'Planifikazioz zuzentzen zara.',
    pt: 'Está quase no caminho com o seu plano.'
  },
  HOW_IS_GOING_STATUS_GOOD_FOOTER: {
    es: '¡Sigue así y lo conseguirás!',
    en: '¡Keep it up and you will get it!',
    cat: '¡Mantente així i ho aconseguiràs!',
    eus: 'Jarraitu eta lortuko duzu!',
    pt: 'Continue assim e você vai conseguir!'
  },
  HOW_IS_GOING_STATUS_NORMAL_TITLE: {
    es: '¡No vas mal!',
    en: '¡You are not doing bad!',
    cat: '¡No vas mal!',
    eus: 'Ez da okerra!',
    pt: 'Não está mal!'
  },
  HOW_IS_GOING_STATUS_NORMAL_SUMMARY: {
    es: 'Pero tienes que meterle un poco de chicha al asunto porque vas un pelín retrasado.',
    en: 'But you have to put a little more effort into it because you are a bit behind.',
    cat: "Però has de posar-hi un poquet d'esforç perquè vas un pelín retingut.",
    eus: 'Baina zuk ez duzu gauza hori betetzen, ezta? Zuk ez duzu gauza hori betetzen, ezta?',
    pt: 'Mas você tem que se esforçar um pouco mais porque está um pouco atrasado.'
  },
  HOW_IS_GOING_STATUS_NORMAL_FOOTER: {
    es: '¡Sigue dándole!',
    en: '¡Keep it up and you will get it!',
    cat: '¡Mantente així i ho aconseguiràs!',
    eus: 'Jarraitu eta lortuko duzu!',
    pt: 'Continue assim e você vai conseguir!'
  },
  HOW_IS_GOING_STATUS_BAD_TITLE: {
    es: '¡Repámpanos y centellas!',
    en: '¡Repámpanos y centellas!',
    cat: '¡Repàmpanos i centelles!',
    eus: '¡Errepamoa eta zentilak!',
    pt: '¡Repámpanos e centelhas!'
  },
  HOW_IS_GOING_STATUS_BAD_SUMMARY: {
    es: 'Creo que alguien, y no te digo quién, ha estado haciendo pellas.',
    en: 'I think someone, and I don`t tell you who, has been making trouble.',
    cat: 'Crec que algún, i no et digués quién, ha estat fent problemes.',
    eus: 'Ez dakit ziuruenik, ezta? Ez dakit ziuruenik, ezta? Zer moduz gauza hori betetzen duzula?',
    pt: 'Acho que alguém, e não te digo quem, tem estado fazendo bagaço.'
  },
  HOW_IS_GOING_STATUS_BAD_FOOTER: {
    es: '¡Tu puedes! ¡A estudiar!',
    en: '¡You can do it! ¡Study!',
    cat: '¡Ho pots fer! ¡Estudia!',
    eus: 'Egin dezakezu! ¡Eskubide-egitea!',
    pt: 'Você pode! Estude!'
  },
  HOW_IS_GOING_AVERAGE_DAILY_HOURS_one: {
    es: '{{count}} hora',
    en: '{{count}} hour',
    cat: '{{count}} hora',
    eus: '{{count}} ordua',
    pt: '{{count}} hora'
  },
  HOW_IS_GOING_AVERAGE_DAILY_HOURS_other: {
    es: '{{count}} horas',
    en: '{{count}} hours',
    cat: '{{count}} hores',
    eus: '{{count}} ordu',
    pt: '{{count}} hora'
  },
  HOW_IS_GOING_AVERAGE_DAILY_HOURS_DESCRIPTION: {
    es: 'Tu estudio medio/día',
    en: 'Your average daily study',
    cat: 'El teu estudi mitjà/dia',
    eus: 'Zure eguneroko batez besteko eskubide-egitea',
    pt: 'O seu estudo médio/dia'
  },
  HOW_IS_GOING_AVERAGE_DAILY_HOURS_ESTIMATION_DESCRIPTION: {
    es: 'tu estimación diaria',
    en: 'your daily estimation',
    cat: 'la teva estimació diària',
    eus: 'zure eguneroko estimazioa',
    pt: 'a sua estimativa diária'
  },
  HOW_IS_GOING_TOTAL_CONTENT: {
    es: 'del contenido total',
    en: 'of total content',
    cat: 'del contingut total',
    eus: 'guztira duen edukia',
    pt: 'o conteúdo total'
  },
  HOW_IS_GOING_ACTIVITIES_one: {
    es: '{{count}} actividad',
    en: '{{count}} activity',
    cat: '{{count}} activitat',
    eus: '{{count}} eskubide',
    pt: '{{count}} atividade'
  },
  HOW_IS_GOING_ACTIVITIES_other: {
    es: '{{count}} actividades',
    en: '{{count}} activities',
    cat: '{{count}} activitats',
    eus: '{{count}} eskubide',
    pt: '{{count}} atividade'
  },
  HOW_IS_GOING_ACTIVITIES_COMPLETED_one: {
    es: 'Completada por ahora',
    en: 'Completed so far',
    cat: 'Completades fins ara',
    eus: 'Betetzen diren',
    pt: 'Completadas até agora'
  },
  HOW_IS_GOING_ACTIVITIES_COMPLETED_other: {
    es: 'Completadas por ahora',
    en: 'Completed so far',
    cat: 'Completades fins ara',
    eus: 'Betetzen diren',
    pt: 'Completadas até agora'
  },
  HOW_IS_GOING_ACTIVITIES_ACCUMULATED_one: {
    es: 'Acumulada por ahora',
    en: 'Accumulated so far',
    cat: 'Acumulada fins ara',
    eus: 'Betetzen diren',
    pt: 'Acumuladas até agora'
  },
  HOW_IS_GOING_ACTIVITIES_ACCUMULATED_other: {
    es: 'Acumuladas por ahora',
    en: 'Accumulated so far',
    cat: 'Acumulades fins ara',
    eus: 'Betetzen diren',
    pt: 'Acumuladas até agora'
  },
  HOW_IS_GOING_VIEW_PLANIFICATION: {
    es: 'Ver planificación',
    en: 'View planification',
    cat: 'Veure planificació',
    eus: 'Ikusi planifikazioa',
    pt: 'Ver planificação'
  },
  HOW_IS_GOING_REPLANIFY: {
    es: 'Replanificar',
    en: 'Replanify',
    cat: 'Replanificar',
    eus: 'Planifikazioa eguneratu',
    pt: 'Replanificar'
  },
  DO_YOU_WANT_TO_PLAN_YOUR_STUDIES: {
    es: '¡Listo! ¿Quieres que hagamos ahora la planificación de tu estudio?',
    en: 'Ready! Do you want us to plan your study now?',
    cat: 'Fet! Vols que ara fem la planificació del teu estudi?',
    eus: 'Egina! Nahi duzu gurekin zure ikasketen planifikazioa egin?',
    pt: 'Pronto! Quer que agora façamos a planificação do seu estudo?'
  },
  IT_WILL_ONLY_TAKE_A_MINUTE: {
    es: 'Aunque no te lo creas ahora, no vamos a tardar más de UN MINUTO en planificar absolutamente TODO tu estudio. Vas a flipar, palabra.',
    en: "Even if you don't believe it now, we are not going to take more than ONE MINUTE to plan absolutely EVERYTHING about your study. You are going to be amazed, word of honor.",
    cat: 'Encara que no t`ho creguis ara, no triguem més d`UN MINUT a planificar absolutament TOT el teu estudi. Vas a flipar, paraula.',
    eus: 'Zeruan ez baduzu sinesten, ez dugu gehiago behar UN MINUTU baino zure ikasketen guztiaren planifikazioa egiteko. Harrituko zara, hitza emanez.',
    pt: 'Mesmo que não acredite agora, não vamos levar mais de UM MINUTO para planificar absolutamente TODO o seu estudo. Você vai ficar impressionado, prometo.'
  },
  YOU_CAN_LEAVE_IT_FOR_LATER: {
    es: 'Pero bueno, si lo quieres dejar para más tarde no pasa nada.',
    en: 'But hey, if you want to leave it for later, it’s okay.',
    cat: 'Però bé, si ho vols deixar per més tard no passa res.',
    eus: 'Baina oso ondo, atzeratu nahi baduzu ez da inolako arazorik.',
    pt: 'Mas o que é, se quiser deixar para mais tarde, tudo bem.'
  },
  STUDY_PLAN: {
    es: 'Planificación de tu estudio',
    en: 'Your study plan',
    cat: 'Planificació del teu estudi',
    eus: 'Zure ikasketen planifikazioa',
    pt: 'O seu plano de estudo'
  },
  DO_YOU_HAVE_AN_EXAM_DATE: {
    es: '¿Tienes una fecha de examen o en la que quieras haber acabado de estudiar?',
    en: 'Do you have an exam date or a date in which you want to finish studying?',
    cat: 'Tens una data d`examen o una data en la que vulguis acabar d`estudiar?',
    eus: 'Ba al duzu azterketa data edo noiz amaitu nahi duzun ikasketak?',
    pt: 'Tem uma data de exame ou uma data em que você quer terminar de estudar?'
  },
  I_HAVE_A_DATE: {
    es: 'Ya tengo una fecha tope en la que me tengo que saber todo',
    en: 'I already have a deadline by which I have to know everything',
    cat: 'Ja tinc una data límit en la que m`he de saber tot',
    eus: 'Dagoeneko nireganako data bat daukat non dena jakin behar dut',
    pt: 'Já tenho uma data limite em que tenho de saber tudo'
  },
  I_DONT_HAVE_A_DATE: {
    es: 'De momento puedo estudiar al ritmo que me apetezca',
    en: 'For now I can study at the pace I want',
    cat: 'De moment puc estudiar al ritme que em vingui de gust',
    eus: 'Une honetan nahi duen erritmoan ikasi dezaket',
    pt: 'Por agora posso estudar ao ritmo que quero'
  },
  CAN_YOU_TELL_US_WHEN: {
    es: 'Genial. ¿Nos puedes decir cuando?',
    en: 'Great. Can you tell us when?',
    cat: 'Genial. Ens pots dir quan?',
    eus: 'Zoragarria. Esan dezakezu noiz?',
    pt: 'Ótimo. Pode nos dizer quando?'
  },
  CAN_YOU_TELL_US_WHEN_SUBTITLE: {
    es: 'Así sabremos como distribuir todo lo que tienes que estudiar.',
    en: 'This way we will know how to distribute everything you have to study.',
    cat: 'Així sabrem com distribuir tot el que has d`estudiar.',
    eus: 'Hala, jakin dezakegu nola banatu behar duzun ikasteko.',
    pt: 'Assim saberemos como distribuir tudo o que tem de estudar.'
  },
  HOW_LONG_WILL_YOU_STUDY: {
    es: 'Genial. ¿Y cuánto tienes pensado estudiar al día?',
    en: 'Great. And how much do you plan to study per day?',
    cat: 'Genial. I quant tens pensat estudiar al dia?',
    eus: 'Zoragarria. Eta zenbat planifikatzen duzu egunero ikasteko?',
    pt: 'Ótimo. E quanto você planeja estudar por dia?'
  },
  HOW_LONG_WILL_YOU_STUDY_SUBTITLE: {
    es: 'Así sabremos como distribuirte todo el contenido en el calendario. Lo podrás cambiar en cualquier momento.',
    en: 'This way we will know how to distribute all the content in the calendar. You can change it at any time.',
    cat: 'Així sabrem com distribuir tot el contingut al calendari. El podràs canviar en qualsevol moment.',
    eus: 'Hala, jakin dezakegu nola banatu behar duzun ikasteko.',
    pt: 'Assim saberemos como distribuir tudo o que tem de estudar.'
  },
  SELECT_A_DATE: {
    es: 'Selecciona una fecha',
    en: 'Select a date',
    cat: 'Selecciona una data',
    eus: 'Hautatu data bat',
    pt: 'Selecione uma data'
  },
  HOURS: {
    es: '* Horas',
    en: '* Hours',
    cat: '* Hores',
    eus: '* Orduak',
    pt: '* Horas'
  },
  MINUTES: {
    es: '* Minutos',
    en: '* Minutes',
    cat: '* Minuts',
    eus: '* Minutuak',
    pt: '* Minutos'
  },
  REST_DAYS_TITLE: {
    es: '¿Qué días vas a descansar?',
    en: 'What days are you going to rest?',
    cat: 'Quins dies descansaràs?',
    eus: 'Zein egun oporretan egongo zara?',
    pt: 'Quais dias você vai descansar?'
  },
  REST_DAYS_SUBTITLE: {
    es: 'Días que te vayas de vacaciones. los fines de semana, los juernes... marca los días que no vayas a estudiar.',
    en: 'Days you go on vacation. weekends, Thursdays... mark the days you are not going to study.',
    cat: 'Dies que et vagis de vacances. els caps de setmana, els dijous... marca els dies que no aniràs a estudiar.',
    eus: 'Oporrak joan zaren egunak. asteburua, osteguna... markatu ez duzun egunetan ikasi.',
    pt: 'Dias que você vai descansar. fins finais de semana, quinta-feira... marque os dias que não vai estudar.'
  },
  [EEventWeekdays.MONDAY]: {
    es: 'Lun',
    en: 'Mon',
    cat: 'Dl',
    eus: 'Al',
    pt: 'Seg'
  },
  [EEventWeekdays.TUESDAY]: {
    es: 'Mar',
    en: 'Tue',
    cat: 'Dm',
    eus: 'Ar',
    pt: 'Ter'
  },
  [EEventWeekdays.WEDNESDAY]: {
    es: 'Mié',
    en: 'Wed',
    cat: 'Dc',
    eus: 'Az',
    pt: 'Qua'
  },
  [EEventWeekdays.THURSDAY]: {
    es: 'Jue',
    en: 'Thu',
    cat: 'Dj',
    eus: 'Og',
    pt: 'Qui'
  },
  [EEventWeekdays.FRIDAY]: {
    es: 'Vie',
    en: 'Fri',
    cat: 'Dv',
    eus: 'Or',
    pt: 'Sex'
  },
  [EEventWeekdays.SATURDAY]: {
    es: 'Sáb',
    en: 'Sat',
    cat: 'Ds',
    eus: 'La',
    pt: 'Sáb'
  },
  [EEventWeekdays.SUNDAY]: {
    es: 'Dom',
    en: 'Sun',
    cat: 'Dg',
    eus: 'Ig',
    pt: 'Dom'
  },
  SPECIFIC_DAYS: {
    es: 'Fechas específicas (vacaciones)',
    en: 'Specific dates (holidays)',
    cat: 'Dates específiques (vacances)',
    eus: 'Data zehatzak (oporrak)',
    pt: 'Datas específicas (feriados)'
  },
  IS_THERE_SOMETHING_YOU_ARENT_STUDYING: {
    es: '¿Hay algo que no vayas a estudiar?',
    en: 'Is there something you are not going to study?',
    cat: 'Hi ha alguna cosa que no vagis a estudiar?',
    eus: 'Zerbait ez duzu ikasi nahi?',
    pt: 'Há algo que você não vai estudar?'
  },
  FILTER_SUBSCRIPTIONS: {
    es: 'Quita el contenido que no vayas a estudiar. Lo podrás cambiar en cualquier momento.',
    en: 'Remove the content you are not going to study. You can change it at any time.',
    cat: 'Treu el contingut que no vagis a estudiar. El podràs canviar en qualsevol moment.',
    eus: 'Kendu ez duzun edukiak ikasi. Momentu batean aldatu dezakezu.',
    pt: 'Remova o conteúdo que você não vai estudar. Você pode alterá-lo em qualquer momento.'
  },
  PLANIFICATION_RESULT_TITLE: {
    es: 'Resultado:',
    en: 'Result:',
    cat: 'Resultat:',
    eus: 'Emaitza:',
    pt: 'Resultado:'
  },
  PLANIFICATION_RESULT_UNDER_TIME: {
    es: 'Te lo tomas con mucha calma.',
    en: 'Take it with a lot of calm.',
    cat: 'T`ho agafes amb molta calma.',
    eus: 'Hobetu gurekin.',
    pt: 'Pegue com uma calma.'
  },
  PLANIFICATION_RESULT_OVER_TIME: {
    es: 'Nos vamos un poco de tiempos.',
    en: 'We took a little longer than expected.',
    cat: 'Nos vam un poc de temps.',
    eus: 'Gurekin zituen pixka bat gehiago.',
    pt: 'Fizemos um pouco mais do que o esperado.'
  },
  PLANIFICATION_CORRECT_TIME_END_DATE: {
    es: 'Todo listo. Esto es lo que necesitas para lograr tu objetivo a tiempo:',
    en: 'All set. This is what you need to achieve your goal in time:',
    cat: 'Tot listo. Això és el que necessites per aconseguir el teu objectiu a temps:',
    eus: 'Egina. Zer moduz erabili behar duzu gurekin.',
    pt: 'Tudo pronto. Isso é o que você precisa para atingir seu objetivo no tempo:'
  },
  PLANIFICATION_CORRECT_TIME_HOURS: {
    es: 'Todo listo. Según nuestros cálculos acabarías de estudiar este día:',
    en: 'All set. According to our calculations, you would have studied today:',
    cat: 'Tot listo. Segons els nostres càlculs, avui hauriaies d`estudiar:',
    eus: 'Egina. Kalkulazioekin, egun hau ikastea beharko litzateke.',
    pt: 'Tudo pronto. De acordo com os nossos cálculos, você estudaria hoje:'
  },
  PLANIFICATION_RESULT_CORRECT_TIME_HOURS_INFO: {
    es: 'Cálculos hechos para estudiártelo todo una vez. Te iremos diciendo día a día, semana a semana, lo que tienes que hacer.',
    en: 'Calculations made for you to study everything once. We will tell you day by day, week by week, what you have to do.',
    cat: 'Càlculs fets per a que et estudiïs tot una vegada. Et diriem dia a dia, setmana a setmana, lo que has de fer.',
    eus: 'Kalkulazioak egin ditugu zurekin, behin bakarrik ikasteko.',
    pt: 'Cálculos feitos para você estudar tudo uma vez. Vamos lhe contando dia a dia, semana a semana, o que você tem que fazer.'
  },
  PLANIFICATION_RESULT_CORRECT_TIME_HOURS: {
    es: 'Día de finalización',
    en: 'Completion date',
    cat: 'Data de finalització',
    eus: 'Amaitzaren data',
    pt: 'Data de finalização'
  },
  PLANIFICATION_RESULT_CORRECT_TIME_TOOLTIP: {
    es: 'Cálculo realizado con tus parámetros introducidos teniendo en cuenta la duración total de tu formación',
    en: 'Calculation made with your parameters taken into account the total duration of your training',
    cat: 'Càlcul realitzat amb els teus paràmetres introduïts tenint en compte la durada total de la teva formació',
    eus: 'Kalkulazioa egin duzu zure parametroekin, gurekin kalkulatu duzun ikasteko denbora totalarekin.',
    pt: 'Cálculo feito com os seus parâmetros, levando em consideração o tempo total de sua formação.'
  },
  PLANIFICATION_RESULT_CONTENT: {
    es: 'Según la fecha de finalización que has indicado, días que no vas a estudiar y contenido...',
    en: 'According to the completion date you have indicated, days you are not going to study and content...',
    cat: 'Segons la data de finalització que has indicat, dies que no vagis a estudiar i contingut...',
    eus: 'Egiaztapen data zehatz baten arabera, ez duzun egunetan ikasi eta edukiak...',
    pt: 'De acordo com a data de finalização que você indicou, dias que você não vai estudar e conteúdo...'
  },
  PLANIFICATION_RESULT_CONTENT_UNDER_TIME_EXPLANATION_FIRST: {
    es: 'Piensa que te calculamos la planificación para estudiarlo y repasarlo todo una sola vez.',
    en: 'Think that we calculated the plan for you to study and review everything at once.',
    cat: 'Pensa que et hem calculat la planificació per estudiar-ho i repassar-ho tot alhora.',
    eus: 'Kontuan izan planifikazioa kalkulatu dizugula dena behin bakarrik ikasteko eta errepasatzeko.',
    pt: 'Pense que calculamos o plano para você estudar e revisar tudo de uma vez.'
  },
  PLANIFICATION_RESULT_CONTENT_UNDER_TIME_EXPLANATION_SECOND: {
    es: 'Prueba a intentar ponerte una fecha para acabar de estudiar un poco antes.',
    en: 'Try to set a date to finish studying a little earlier.',
    cat: 'Prova a intentar posar-te una data per acabar d`estudiar una mica abans.',
    eus: 'Saiatu zaitez ikasketak pixka bat lehenago amaitzeko data bat jartzen.',
    pt: 'Tente definir uma data para terminar de estudar um pouco antes.'
  },
  PLANIFICATION_RESULT_CONTENT_OVER_TIME_EXPLANATION: {
    es: 'Pero que no cunda el pánico. Puedes volver a editar los datos ahora o hacerlo más tarde.',
    en: 'But don’t panic. You can edit the data now or do it later.',
    cat: 'Però que no cunda el pànic. Podes tornar a editar les dades ara o fer-ho més tard.',
    eus: 'Baina ez duzu gogorik. Momentu batean aldatu dezakezu.',
    pt: 'Mas não se apresse. Você pode editar os dados agora ou fazê-lo mais tarde.'
  },
  PLANIFICATION_RESULT_CORRECT_TIME_END_DATE_INFO: {
    es: 'Te iremos diciendo día a día, semana a semana, lo que tienes que hacer.',
    en: 'We will tell you day by day, week by week, what you have to do.',
    cat: 'Et diriem dia a dia, setmana a setmana, lo que has de fer.',
    eus: 'Egunero egingo dizugun, astea astean, zer egin behar duzun.',
    pt: 'Vamos lhe contando dia a dia, semana a semana, o que você tem que fazer.'
  },
  PLANIFICATION_RESULT_CORRECT_TIME_END_DATE: {
    es: 'Tiempo de estudio mínimo al día',
    en: 'Minimum study time per day',
    cat: 'Temps mínim d`estudi al dia',
    eus: 'Eguneko gutxieneko ikasteko denbora',
    pt: 'Tempo mínimo de estudo por dia'
  },
  PLANIFICATION_RESULT_CORRECT_TIME_END_DATE_STUDY_TIME: {
    es: '{{hours}} horas, {{minutes}} minutos',
    en: '{{hours}} hours, {{minutes}} minutes',
    cat: '{{hours}} hores, {{minutes}} minuts',
    eus: '{{hours}} ordu, {{minutes}} minutu',
    pt: '{{hours}} horas, {{minutes}} minutos'
  },
  EMPTY_REST_DAYS_TITLE: {
    es: 'No me lo creo. ¿No vas a descansar NI UN SOLO DÍA?',
    en: 'I don’t believe it. Are you not going to rest NOT EVEN ONE DAY?',
    cat: 'No m`ho crec. No descansaràs NI UN SOL DIA?',
    eus: 'Ez dut sinistu. Ez duzu oporretan ERE BATA ere egongo?',
    pt: 'Não acredito. Você não vai descansar NEM UM ÚNICO DIA?'
  },
  EMPTY_REST_DAYS_SUBTITLE: {
    es: 'Nos apasiona tu entusiasmo, pero seamos personas sanas. Te aconsejamos que te pongas al menos un día para descansar.',
    en: 'We love your enthusiasm, but let’s be healthy people. We advise you to take at least one day to rest.',
    cat: 'Ens apassiona el teu entusiasme, però siguem persones sanes. Et recomanem que et posi almenys un dia per descansar.',
    eus: 'Gure zaletasuna da zure entusiasmoa, baina izan gaizki pertsona. Aholkatzen dizugu gutxienez egun bat oporretan jartzeko.',
    pt: 'Nosso entusiasmo é o seu entusiasmo, mas sejamos pessoas saudáveis. Recomendamos que você se de um dia para descansar.'
  },
  CHOOSE_REST_DAYS: {
    es: 'Elegir días de descanso',
    en: 'Choose rest days',
    cat: 'Triar dies de descans',
    eus: 'Aukeratu opor egunak',
    pt: 'Escolher dias de descanso'
  },
  WEEK_REST_DAYS: {
    es: 'Días de descanso',
    en: 'Rest days',
    cat: 'Dies de descans',
    eus: 'Opor egunak',
    pt: 'Dias de descanso'
  },
  HOLIDAYS: {
    es: 'Vacaciones',
    en: 'Holidays',
    cat: 'Festivos',
    eus: 'Festiboak',
    pt: 'Feriados'
  },
  I_NEVER_REST: {
    es: 'No descanso nunca',
    en: 'I never rest',
    cat: 'No descanso mai',
    eus: 'Inoiz ez dut oporretan',
    pt: 'Nunca descanco'
  },
  PLANIFICATION_RESULT_LEAVE: {
    es: 'Dejarlo así de momento',
    en: 'Leave it as it is for now',
    cat: 'Dejar-ho així per ara',
    eus: 'Ez duzu gogorik. Momentu batean aldatu dezakezu.',
    pt: 'Não descanco nunca'
  },
  PLANIFICATION_RESULT_EDIT: {
    es: 'Editar la planificación',
    en: 'Edit the plan',
    cat: 'Editar la planificació',
    eus: 'Editatu planifikazioa',
    pt: 'Editar o plano'
  },
  PLANIFICATION_RESULT_DONE: {
    es: '¡A estudiar!',
    en: 'Let’s go study!',
    cat: 'Anem-hi a estudiar!',
    eus: 'Ikasten joan!',
    pt: 'Vamos estudar!'
  },
  PLANIFICATION_RESULT_EDIT_HOURS: {
    es: 'Editar horas de estudio',
    en: 'Edit study hours',
    cat: 'Editar hores d`estudi',
    eus: 'Ikasteko denbora aldatu',
    pt: 'Editar horas de estudo'
  },
  PLANIFICATION_RESULT_EDIT_END_DATE: {
    es: 'Editar fecha de finalización',
    en: 'Edit completion date',
    cat: 'Editar data de finalització',
    eus: 'Amaitzaren datara aldatu',
    pt: 'Editar data de finalização'
  },
  GO_TO_STUDY: {
    es: 'No, ir a estudiar',
    en: 'No, go study',
    cat: 'No, anar a estudiar',
    eus: 'Ez, ikasten joan',
    pt: 'Não, vamos estudar'
  },
  PLAN_MY_STUDY: {
    es: 'Planificar mi estudio',
    en: 'Plan my study',
    cat: 'Planificar el meu estudi',
    eus: 'Nire ikasketak planifikatu',
    pt: 'Planificar meu estudo'
  },
  GO_BACK: {
    es: 'Atrás',
    en: 'Back',
    cat: 'Atrás',
    eus: 'Atzera',
    pt: 'Voltar'
  },
  CONTINUE: {
    es: 'Continuar',
    en: 'Continue',
    cat: 'Continuar',
    eus: 'Jarraitu',
    pt: 'Continuar'
  },
  SELECT_TAG: {
    es: 'Selecciona una formación',
    en: 'Select a training',
    cat: 'Selecciona una formació',
    eus: 'Aukeratu ikastaroa',
    pt: 'Selecionar formação'
  },
  PLANIFICATION_RESULT_SUCCESS: {
    es: '¡A estudiar!',
    en: 'Let’s go study!',
    cat: 'Anem-hi a estudiar!',
    eus: 'Ikasten joan!',
    pt: 'Vamos estudar!'
  },
  PLANIFICATION: {
    es: 'Planificación del estudio',
    en: 'Study plan',
    cat: 'Planificació del meu estudi',
    eus: 'Ikasteko planifikazioa',
    pt: 'Plano de estudo'
  },
  PLANIFICATION_HOW_IT_WORKS_TITLE: {
    es: '¿Cómo funciona la planificación?',
    en: 'How does the plan work?',
    cat: 'Nola funtzionatzen du planifikazioa?',
    eus: 'Nola funtzionatzen du planifikazioa?',
    pt: 'Como funciona o plano?'
  },
  PLANIFICATION_HOW_IT_WORKS_CONTENT: {
    es: 'En esta primera versión de la planificación hacemos esto: Cogemos todo el temario y te lo distribuimos en el calendario teniendo en cuenta:',
    en: 'In this first version of the plan, we do this: We take all the syllabus and distribute it in the calendar taking into account:',
    cat: 'En aquesta primera versió de la planificació, fem això: agafem tot el temari i el distribuïm en el calendari tenint en compte:',
    eus: 'Plangintzaren lehen bertsio honetan hau egiten dugu: Agenda osoa hartu eta egutegian banatzen dugu kontuan hartuta:',
    pt: 'Na primeira versão do plano, fazemos isto: pegamos em todo o temário e distribuímos no calendário, levando em consideração:'
  },
  PLANIFICATION_HOW_IT_WORKS_POINTS_1: {
    es: 'El tiempo de cada actividad de tu formación más el tiempo de repaso de cada una.',
    en: 'The time of each activity of your training plus the time of review of each one.',
    cat: 'Den temps de cada activitat de la teva formació més el temps de repàs de cada una.',
    eus: 'Ikastaroko edukiaren denbora eta erreparatzeko denbora bakoitza.',
    pt: 'O tempo de cada atividade da sua formação mais o tempo de revisão de cada uma.'
  },
  PLANIFICATION_HOW_IT_WORKS_POINTS_2: {
    es: 'La fecha en la que quieres acabar de estudiar o el tiempo que quieres estudiar al día.',
    en: 'The date you want to finish studying or the time you want to study per day.',
    cat: 'Data en la que vols acabar d`estudiar o el temps que vols estudiar al dia.',
    eus: 'Amaitzeko data eta egunero ikasteko denbora.',
    pt: 'A data que você quer terminar de estudar ou o tempo que você quer estudar por dia.'
  },
  PLANIFICATION_HOW_IT_WORKS_POINTS_3: {
    es: 'Los días que no quieres o puedes estudiar.',
    en: 'The days you do not want or can study.',
    cat: 'Dies que no vols o pots estudiar.',
    eus: 'Ez duzun egunak eta ikasteko egunak.',
    pt: 'Os dias que você não quer ou pode estudar.'
  },
  PLANIFICATION_HOW_IT_WORKS_POINTS_4: {
    es: 'El temario que quieres descartar.',
    en: 'The syllabus you want to discard.',
    cat: 'El temari que vols descartar.',
    eus: 'Ez duzun temari.',
    pt: 'O temário que você quer descartar.'
  },
  PLANIFICATION_HOW_IT_WORKS_CONCLUSION: {
    es: 'Después calculamos automáticamente las tareas que deberías realizar cada día.',
    en: 'Then we automatically calculate the tasks you should do each day.',
    cat: 'Despres, calculem automàticament les tasques que hauries de fer cada dia.',
    eus: 'Gero, kalkulatu automatikoki egunero egin beharko duzun jarduera.',
    pt: 'Depois, calculamos automaticamente as tarefas que você deveria fazer todos os dias.'
  },
  PLANIFICATION_HOW_IT_WORKS_REMINDER: {
    es: 'Recuerda que además de estudiar también deberías repasar con tests.',
    en: 'Remember that you should also review with tests.',
    cat: 'Recorda que hauries de repassar amb tests.',
    eus: 'Gogoratu erreparatzeko testak egin beharko duzu.',
    pt: 'Lembre-se de que també deveria revisar com testes.'
  },
  PLANIFICATION_HOW_IT_WORKS_FEEDBACK: {
    es: '¿Te gustaría dejarnos feedback para mejorar?',
    en: 'Would you like to leave us feedback to improve?',
    cat: 'Zelatzen duzu gurekin feedback utztea hobetu?',
    eus: 'Feedback utzi nahi duzu hobetu?',
    pt: 'Você gostaria de nos deixar feedback para melhorar?'
  },
  PLANIFICATION_HOW_IT_WORKS_SEND_FEEDBACK: {
    es: 'Enviar feedback',
    en: 'Send feedback',
    cat: 'Enviar feedback',
    eus: 'Feedback bidali',
    pt: 'Enviar feedback'
  },
  PLANIFICATION_HOW_IT_WORKS_SEND_FEEDBACK_SUCCESS: {
    es: '¡Feedback enviado!',
    en: 'Feedback sent!',
    cat: 'Feedback enviat!',
    eus: 'Feedback bidali da!',
    pt: 'Feedback enviado!'
  },
  INCLUDE_ALL_ACTIVITIES_TITLE: {
    es: '¿Quieres planificar las lecciones que ya has completado?',
    en: 'Do you want us to plan the lessons you have already completed?',
    cat: 'Vols que planifiquem les lliçons que ja has completat?',
    eus: 'Zer moduz erabili behar duzu?',
    pt: 'Quer que planeie as aulas que já completou?'
  },
  INCLUDE_ALL_ACTIVITIES_SUBTITLE: {
    es: 'Las que hayas completado seguirán marcadas como completadas, pero las tendremos en cuenta en tu planificación.',
    en: 'The ones you have completed will remain marked as completed, but we will take them into account in your plan.',
    cat: 'Les que has completat seguiran marcades com a completes, però les tindrem en compte en el teu pla.',
    eus: 'Ez duzun jarduera egiten duzula',
    pt: 'As que você completou continuarão marcadas como completadas, mas vamos considerá-las no seu plano.'
  },
  INCLUDE_ALL_ACTIVITIES_YES: {
    es: 'Quiero todo, incluidas las actividades que ya he hecho.',
    en: 'I want everything, including the activities I have already done.',
    cat: 'Vull tot, incloent les activitats que ja he fet.',
    eus: 'Nahi dut jarduera egiten duzula',
    pt: 'Quero tudo, incluindo as atividades que já fiz.'
  },
  INCLUDE_ALL_ACTIVITIES_NO: {
    es: 'Para mi planificación solo quiero las que no he completado',
    en: 'For my plan, I only want the ones I have not completed',
    cat: 'Per al meu pla, només vull les que no he completat',
    eus: 'Nahi dut jarduera egiten duzula',
    pt: 'Para o meu plano, quero apenas as que ainda não completei'
  },
  ACTIVITY_ESTIMATED_STUDY_TIME: {
    es: 'Tiempo de la actividad',
    en: 'Activity study time',
    cat: 'Temps d`estudi de l`activitat',
    eus: 'Jarduera ikasteko denbora',
    pt: 'Tempo de estudo da atividade'
  },
  [`ACTIVITY_ESTIMATED_STUDY_TIME_${EActivityType.VIDEO}_INFO`]: {
    es: 'El tiempo que se toma en cuenta para la planificación. Por defecto asignaremos automáticamente este tiempo: Tiempo del vídeo x 2',
    en: 'The time taken into account for the plan. By default, we will automatically assign this time: Video time x 2',
    cat: 'El temps que es té en compte per a la planificació. Per defecte, assignarem automàticament aquest temps: Temps del vídeo x 2',
    eus: 'Planifikazioan hartzen duen denbora. Lehenetsitako moduan, denbora automatikoki esleitu dugu: Ikusteko denbora x 2',
    pt: 'Tempo de estudo da atividade que considera o plano. Por defeito, atribuiremos automaticamente este tempo: Tempo do vídeo x 2'
  },
  [`ACTIVITY_ESTIMATED_STUDY_TIME_${EActivityType.INTERACTIVE_VIDEO}_INFO`]: {
    es: 'El tiempo que se toma en cuenta para la planificación. Por defecto asignaremos automáticamente este tiempo: Tiempo del vídeo x 2',
    en: 'The time taken into account for the plan. By default, we will automatically assign this time: Video time x 2',
    cat: 'El temps que es té en compte per a la planificació. Per defecte, assignarem automàticament aquest temps: Temps del vídeo x 2',
    eus: 'Planifikazioan hartzen duen denbora. Lehenetsitako moduan, denbora automatikoki esleitu dugu: Ikusteko denbora x 2',
    pt: 'Tempo de estudo da atividade que considera o plano. Por defeito, atribuiremos automaticamente este tempo: Tempo do vídeo x 2'
  },
  [`ACTIVITY_ESTIMATED_STUDY_TIME_${EActivityType.PDF}_INFO`]: {
    es: 'El tiempo que se toma en cuenta para la planificación. Por defecto asignaremos automáticamente este tiempo: Σ Palabras totales en todas las páginas x 4,8 segundos',
    en: 'The time taken into account for the plan. By default, we will automatically assign this time: Σ Total words in all pages x 4.8 seconds',
    cat: 'El temps que es té en compte per a la planificació. Per defecte, assignarem automàticament aquest temps: Σ Total de paraules en totes les pàgines x 4,8 segons',
    eus: 'Planifikazioan hartzen duen denbora. Lehenetsitako moduan, denbora automatikoki esleitu dugu: Σ Orrialde guztietako hitz kopurua x 4,8 segundoa',
    pt: 'Tempo de estudo da atividade que considera o plano. Por defeito, atribuiremos automaticamente este tempo: Σ Palavras totais em todas as páginas x 4,8 segundos'
  },
  [`ACTIVITY_ESTIMATED_STUDY_TIME_${EActivityType.QUIZ}_INFO`]: {
    es: 'El tiempo que se toma en cuenta para la planificación. Por defecto asignaremos automáticamente este tiempo: Σ Preguntas del test x 90 segundos',
    en: 'The time taken into account for the plan. By default, we will automatically assign this time: Σ Questions of the test x 90 seconds',
    cat: 'El temps que es té en compte per a la planificació. Per defecte, assignarem automàticament aquest temps: Σ Preguntes del test x 90 segons',
    eus: 'Planifikazioan hartzen duen denbora. Lehenetsitako moduan, denbora automatikoki esleitu dugu: Σ Testeko galdera kopurua x 90 segundoa',
    pt: 'Tempo de estudo da atividade que considera o plano. Por defeito, atribuiremos automaticamente este tempo: Σ Perguntas do test x 90 segundos'
  },
  [`ACTIVITY_ESTIMATED_STUDY_TIME_${EActivityType.DELIVERABLE}_INFO`]: {
    es: 'El tiempo que se toma en cuenta para la planificación. Por defecto asignaremos automáticamente 10 horas.',
    en: 'The time taken into account for the plan. By default, we will automatically assign this time: 10 hours',
    cat: 'El temps que es té en compte per a la planificació. Per defecte, assignarem automàticament aquest temps: 10 hores',
    eus: 'Planifikazioan hartzen duen denbora. Lehenetsitako moduan, denbora automatikoki esleitu dugu: 10 ordu',
    pt: 'Tempo de estudo da atividade que considera o plano. Por defeito, atribuiremos automaticamente este tempo: 10 horas'
  },
  [`ACTIVITY_ESTIMATED_STUDY_TIME_${EActivityType.TEXT}_INFO`]: {
    es: 'El tiempo que se toma en cuenta para la planificación. Por defecto asignaremos automáticamente 0 minutos.',
    en: 'The time taken into account for the plan. By default, we will automatically assign this time: 0 minutes',
    cat: 'El temps que es té en compte per a la planificació. Per defecte, assignarem automàticament aquest temps: 0 minuts',
    eus: 'Planifikazioan hartzen duen denbora. Lehenetsitako moduan, denbora automatikoki esleitu dugu: 0 minutu',
    pt: 'Tempo de estudo da atividade que considera o plano. Por defeito, atribuiremos automaticamente este tempo: 0 minutos'
  },
  ACTIVITY_ESTIMATED_STUDY_TIME_INFO: {
    es: 'Si no te encaja, puedes modificar el tiempo cuando quieras.',
    en: 'If it doesn’t fit, you can modify the time whenever you want.',
    cat: 'Si no et encaixa, pots modificar el temps quan vulguis.',
    eus: 'Ez badu zuzena, aldatu dezakezu denbora denbora.',
    pt: 'Se não couber, você pode modificar o tempo quando quiser.'
  },
  ACTIVITY_ESTIMATED_STUDY_TIME_HOURS: {
    es: 'Horas',
    en: 'Hours',
    cat: 'Horas',
    eus: 'Orduak',
    pt: 'Horas'
  },
  ACTIVITY_ESTIMATED_STUDY_TIME_MINUTES: {
    es: 'Minutos',
    en: 'Minutes',
    cat: 'Minutos',
    eus: 'Minutuak',
    pt: 'Minutos'
  },
  ACTIVITY_ESTIMATED_STUDY_TIME_DELETE: {
    es: 'Borrar',
    en: 'Delete',
    cat: 'Borrar',
    eus: 'Ezabatu',
    pt: 'Apagar'
  },
  REMOVE_CONTRACT: {
    es: 'Eliminar contrato',
    en: 'Remove contract',
    cat: 'Eliminar contrato',
    eus: 'Ezabatu kontratua',
    pt: 'Remover contrato'
  },
  REMOVE_CONTRACT_CONFIRMATION: {
    es: '¿Estás seguro de que deseas eliminar el contrato? El proceso es irreversible y conlleva un gran coste para la empresa.',
    en: 'Are you sure you want to remove the contract? The process is irreversible and involves a high cost for the company.',
    cat: 'Estàs segur que vols ezabatu kontratua? Procedimenta irreversible i suposa un alt cost per a l`empresa.',
    eus: 'Ziur zaude kontratua ezabatu nahi duzula? Prozesua irreversiboa da eta enpresa handi bati esanahi bat du.',
    pt: 'Tem certeza de que deseja remover o contrato? O processo é irreversível e acarreta um alto custo para a empresa.'
  },
  SELECT_ONE_OPTION: {
    es: 'Selecciona una opción',
    en: 'Select one option',
    cat: 'Alegeix una opció',
    eus: 'Aukeratu bat',
    pt: 'Selecione uma opção'
  },
  RECORDING_TODAY: {
    es: 'Subido hoy',
    en: 'Uploaded today',
    cat: 'Carregat avui',
    eus: 'Gaur egun igortua',
    pt: 'Carregado hoje'
  },
  RECORDING_DAYS_one: {
    es: 'Subido hace 1 día',
    en: 'Uploaded 1 day ago',
    cat: 'Carregat 1 dia atzera',
    eus: 'Gaur egun igortua',
    pt: 'Carregado há um dia'
  },
  RECORDING_DAYS_other: {
    es: 'Subido hace {{count}} días',
    en: 'Uploaded {{count}} days ago',
    cat: 'Carregat {{count}} dies atzera',
    eus: '{{count}} egun igortua',
    pt: 'Carregado há {{count}} dias'
  },
  RECORDING_WEEKS_one: {
    es: 'Subido hace 1 semana',
    en: 'Uploaded 1 week ago',
    cat: 'Carregat 1 setmana atzera',
    eus: '1 aste igortua',
    pt: 'Carregado há uma semana'
  },
  RECORDING_WEEKS_other: {
    es: 'Subido hace {{count}} semanas',
    en: 'Uploaded {{count}} weeks ago',
    cat: 'Carregat {{count}} setmanes atzera',
    eus: '{{count}} aste igortua',
    pt: 'Carregado há {{count}} semanas'
  },
  RECORDING_MONTHS_one: {
    es: 'Subido hace 1 mes',
    en: 'Uploaded 1 month ago',
    cat: 'Carregat 1 mes atzera',
    eus: '1 hilabete igortua',
    pt: 'Carregado há um mês'
  },
  RECORDING_MONTHS_other: {
    es: 'Subido hace {{count}} meses',
    en: 'Uploaded {{count}} months ago',
    cat: 'Carregat {{count}} mesos atzera',
    eus: '{{count}} hilabete igortua',
    pt: 'Carregado há {{count}} meses'
  },
  RECORDING_YEARS_one: {
    es: 'Subido hace 1 año',
    en: 'Uploaded 1 year ago',
    cat: 'Carregat 1 any atzera',
    eus: '1 urte igortua',
    pt: 'Carregado há um ano'
  },
  RECORDING_YEARS_other: {
    es: 'Subido hace {{count}} años',
    en: 'Uploaded {{count}} years ago',
    cat: 'Carregat {{count}} anys atzera',
    eus: '{{count}} urte igortua',
    pt: 'Carregado há {{count}} anos'
  },
  CREATE_INTERNAL_NOTE_SUCCESS: {
    es: 'Nota interna creada correctamente',
    en: 'Internal note created successfully',
    cat: 'Nota interna creada correctament',
    eus: 'Eskuzko nota egitea ongi egin da',
    pt: 'Nota interna criada com sucesso'
  },
  UPDATE_INTERNAL_NOTE_SUCCESS: {
    es: 'Nota interna actualizada correctamente',
    en: 'Internal note updated successfully',
    cat: 'Nota interna actualitzada correctament',
    eus: 'Eskuzko nota egitea ongi egin da',
    pt: 'Nota interna atualizada com sucesso'
  },
  DELETE_INTERNAL_NOTE_SUCCESS: {
    es: 'Nota interna eliminada correctamente',
    en: 'Internal note deleted successfully',
    cat: 'Nota interna eliminada correctament',
    eus: 'Eskuzko nota ezabatua ongi egin da',
    pt: 'Nota interna eliminada com sucesso'
  },
  ADD_INTERNAL_NOTE_TYPE: {
    es: 'Añadir etiqueta',
    en: 'Add tag',
    cat: 'Afegeix etiqueta',
    eus: 'Etiketa gehitu',
    pt: 'Adicionar etiqueta'
  },
  [EInternalNoteType.PERSONAL]: {
    es: 'Personal',
    en: 'Personal',
    cat: 'Personal',
    eus: 'Pertsonal',
    pt: 'Pessoal'
  },
  [EInternalNoteType.INCIDENT]: {
    es: 'Incidencia',
    en: 'Incident',
    cat: 'Incident',
    eus: 'Errorea',
    pt: 'Incidente'
  },
  [EInternalNoteType.NON_ATTENDANCE]: {
    es: 'Inasistencia',
    en: 'Non-attendance',
    cat: 'Inasistencia',
    eus: 'Inasistenzia',
    pt: 'Inasistência'
  },
  [EInternalNoteType.PROGRESS]: {
    es: 'Progreso',
    en: 'Progress',
    cat: 'Progres',
    eus: 'Progresoa',
    pt: 'Progresso'
  },
  INTERNAL_NOTES: {
    es: 'Notas',
    en: 'Notes',
    cat: 'Notes',
    eus: 'Notak',
    pt: 'Notas'
  },
  ACCOUNT_AND_CONFIGURATION: {
    es: 'Configuración',
    en: 'Configuration',
    cat: 'Configuració',
    eus: 'Konfigurazioa',
    pt: 'Configuração'
  },
  SECTIONS_COUNT_one: {
    es: '1 tema',
    en: '1 section',
    cat: '1 tema',
    eus: '1 ikastar',
    pt: '1 tema'
  },
  SECTIONS_COUNT_other: {
    es: '{{count}} temas',
    en: '{{count}} sections',
    cat: '{{count}} temes',
    eus: '{{count}} ikastarak',
    pt: '{{count}} temas'
  },
  SECTIONS_PROGRESS_UNDER_20_one: {
    es: 'Completa el tema restante y demuestra que puedes con todo.',
    en: 'Complete the remaining section and prove that you can handle everything.',
    cat: 'Completa el tema restant i demostra que pots fer tot.',
    eus: 'Egin geroago ikastaroa eta erakustatu zituzke zuk egin duzula.',
    pt: 'Complete o tema restante e demonstre que pode lidar com tudo.'
  },
  SECTIONS_PROGRESS_UNDER_20_other: {
    es: 'Completa los {{count}} temas restantes y demuestra que puedes con todo.',
    en: 'Complete the remaining {{count}} sections and prove that you can handle everything.',
    cat: 'Completa els {{count}} temes restants i demostra que pots fer tot.',
    eus: 'Egin geroago {{count}} ikastarok eta erakustatu zituzke zuk egin duzula.',
    pt: 'Complete os {{count}} temas restantes e demonstre que pode lidar com tudo.'
  },
  SECTIONS_PROGRESS_UNDER_60_one: {
    es: 'Te queda 1 tema. ¡Vas por buen camino!',
    en: 'You have 1 section left. You are on the right track!',
    cat: 'Te queda 1 tema. ¡Vas per un bon camí!',
    eus: '1 ikastar geroago dagozu. Zuk zuzentzen zara!',
    pt: 'Você tem 1 tema restante. Você está no caminho certo!'
  },
  SECTIONS_PROGRESS_UNDER_60_other: {
    es: 'Te quedan {{count}} temas. ¡Vas por buen camino!',
    en: 'You have {{count}} sections left. You are on the right track!',
    cat: 'Te queden {{count}} temes. ¡Vas per un bon camí!',
    eus: '{{count}} ikastar geroago dagozu. Zuk zuzentzen zara!',
    pt: 'Você tem {{count}} temas restantes. Você está no caminho certo!'
  },
  SECTIONS_PROGRESS_UNDER_100_one: {
    es: '¡Ánimo! Solo te queda 1 tema para saberlo todo.',
    en: 'Cheer up! You have 1 section left to know everything.',
    cat: 'Ànim! Només et queda un tema per saber-ho tot.',
    eus: 'Anima zaitez! Gai bakarra geratzen zaizu guztia ezagutzeko.',
    pt: 'Cheer up! You have 1 section left to know everything.'
  },
  SECTIONS_PROGRESS_UNDER_100_other: {
    es: '¡Ánimo! Solo te quedan {{count}} temas para saberlo todo.',
    en: 'Cheer up! You have {{count}} sections left to know everything.',
    cat: 'Ànim! Només et queden {{count}} temes per saber-ho tot.',
    eus: 'Anima zaitez! Gai bakarra geratzen zaizu guztia ezagutzeko.',
    pt: 'Cheer up! You have {{count}} sections left to know everything.'
  },
  SECTIONS_PROGRESS_COMPLETED: {
    es: '¡Ya te sabes todos los temas!',
    en: '¡You know all the sections!',
    cat: '¡Ja saps tots els temes!',
    eus: '¡Egin duzun ikastarok egin duzu!',
    pt: '¡Você conhece todos os temas!'
  },
  ACTIVITY_NOTES_TOOLTIP_one: {
    es: 'Has tomado 1 nota en esta lección',
    en: 'You have taken 1 note in this lesson',
    cat: 'Has agafat 1 nota en aquesta lliçó',
    eus: '1 nota egin duzu ikastarok',
    pt: 'Você tem 1 nota nesta lição'
  },
  ACTIVITY_NOTES_TOOLTIP_other: {
    es: 'Has tomado {{count}} notas en esta lección',
    en: 'You have taken {{count}} notes in this lesson',
    cat: 'Has agafat {{count}} notes en aquesta lliçó',
    eus: '{{count}} nota egin duzu ikastarok',
    pt: 'Você tem {{count}} notas nesta lição'
  },
  THANKS_FOR_REVIEWING: {
    es: '¡Gracias por tu valoración!',
    en: 'Thank you for your review!',
    cat: '¡Gràcies per la teva valoració!',
    eus: 'Eskuzko nota egitea ongi egin da',
    pt: 'Obrigado pela sua revisão!'
  },
  TEACHER_VOTE_THANK_YOU: {
    es: '¡Gracias por valorar a {{name}}!',
    en: 'Thank you for voting for {{name}}!',
    cat: '¡Gràcies per valorar a {{name}}!',
    eus: 'Eskuzko votazioa {{name}}!',
    pt: 'Obrigado por votar por {{name}}!'
  },
  TUTOR_VOTE_THANK_YOU: {
    es: '¡Gracias por valorar a tu tutor!',
    en: 'Thank you for voting for your tutor!',
    cat: '¡Gràcies per valorar a tu tutor!',
    eus: 'Eskuzko votazioa tutor zure!',
    pt: 'Obrigado por votar por seu tutor!'
  },
  LIVE_CLASS_VOTE_SUCCESS: {
    es: '¡Gracias por tu valoración!',
    en: 'Thank you for your rating!',
    cat: '¡Gràcies per la teva valoració!',
    eus: 'Eskerrik asko zure iritziagatik!',
    pt: 'Obrigado por sua avaliação!'
  },
  RANKING: {
    es: 'Ranking',
    en: 'Ranking',
    cat: 'Ranking',
    eus: 'Ranking',
    pt: 'Ranking'
  },
  RATE_YOUR_EXPERIENCE: {
    es: 'Valorar tu experiencia',
    en: 'Rate your experience',
    cat: 'Valorar la teva experiència',
    eus: 'Baloratu zure esperientzia',
    pt: 'Avaliar sua experiência'
  },
  CLEAR_SELECTION: {
    es: 'Borrar selección',
    en: 'Clear selection',
    cat: 'Borrar selecció',
    eus: 'Ezabatu aukera',
    pt: 'Limpar seleção'
  },
  STATUS: {
    es: 'Estado',
    en: 'Status',
    cat: 'Estat',
    eus: 'Egoera',
    pt: 'Estado'
  },
  QUIZZES_COUNT_one: {
    es: 'En {{count}} test',
    en: 'In {{count}} quiz',
    cat: 'En {{count}} test',
    eus: 'Erantzun {{count}} testuan',
    pt: 'Em {{count}} teste'
  },
  QUIZZES_COUNT_other: {
    es: 'En {{count}} tests',
    en: 'In {{count}} quizzes',
    cat: 'En {{count}} tests',
    eus: 'Erantzun {{count}} testuetan',
    pt: 'Em {{count}} testes'
  },
  AI_QUESTION_TOOLTIP: {
    es: 'Creada con IA',
    en: 'Created with AI',
    cat: 'Creada amb IA',
    eus: 'AI batez eratu du',
    pt: 'Criado com IA'
  },
  MONTH_FILTER: {
    es: 'Mes',
    en: 'Month',
    cat: 'Mes',
    eus: 'Hilabete',
    pt: 'Mês'
  },
  TEACHER_STATUS_FILTER: {
    es: 'Estado',
    en: 'Status',
    cat: 'Estat',
    eus: 'Egoera',
    pt: 'Estado'
  },

  CLEAR_FILTERS: {
    es: 'Limpiar filtros',
    en: 'Clear filters',
    cat: 'Netejar filtres',
    eus: 'Ezabatu filtrotz',
    pt: 'Limpar filtros'
  },
  QUIZ_MODES: {
    es: 'Tipos',
    en: 'Modes',
    cat: 'Tipus',
    eus: 'Erantzun',
    pt: 'Modos'
  },
  BEGINNING: {
    es: 'Inicio',
    en: 'Beginning',
    cat: 'Inici',
    eus: 'Hasiera',
    pt: 'Início'
  },
  END: {
    es: 'Fin',
    en: 'End',
    cat: 'Fi',
    eus: 'Eskubidea',
    pt: 'Fim'
  },
  [ETeacherStatus.ONBOARDING]: {
    es: 'Onboarding',
    en: 'Onboarding',
    cat: 'Onboarding',
    eus: 'Onboarding',
    pt: 'Onboarding'
  },
  [ETeacherStatus.OFFBOARDING]: {
    es: 'Offboarding',
    en: 'Offboarding',
    cat: 'Offboarding',
    eus: 'Offboarding',
    pt: 'Offboarding'
  },
  [ETeacherStatus.TEMPORARY_LEAVE]: {
    es: 'Baja temporal',
    en: 'Temporary leave',
    cat: 'Baixa temporal',
    eus: 'Eskuzko baxketa',
    pt: 'Baixa temporária'
  },
  ABOUT_ME: {
    es: 'Sobre mí',
    en: 'About me',
    cat: 'Sobre mi',
    eus: 'Niri buruz',
    pt: 'Sobre mim'
  },
  WRITE_HERE: {
    es: 'Escribe aquí',
    en: 'Write here',
    cat: 'Escriu aquí',
    eus: 'Idatzi hemen',
    pt: 'Escreva aqui'
  },
  RESULT: {
    es: 'Resultado',
    en: 'Result',
    cat: 'Resultat',
    eus: 'Emaitza',
    pt: 'Resultado'
  },
  PLANIFICATION_RESULT_ALERT_MESSAGE_TITLE_WARNING: {
    es: 'Parece que nos vamos un poco de tiempos',
    en: 'It seems we’re running a bit off schedule',
    cat: 'Sembla que ens estem desviant una mica del temps previst',
    eus: 'Dirudienez, denboraz pixka bat ari gara desbideratzen',
    pt: 'Parece que estamos um pouco fora do cronograma'
  },
  PLANIFICATION_RESULT_ALERT_MESSAGE_CONTENT_WARNING: {
    es: 'Te recomendamos modificar la fecha de fin, los días de descanso o la cantidad de temas de estudio.',
    en: 'We recommend adjusting the end date, the rest days, or the number of study topics.',
    cat: 'Et recomanem modificar la data de finalització, els dies de descans o la quantitat de temes d’estudi.',
    eus: 'Amaiera data, atseden egunak edo ikasketa gaien kopurua aldatzea gomendatzen dizugu.',
    pt: 'Recomendamos modificar a data de término, os dias de descanso ou a quantidade de temas de estudo.'
  },
  PLANIFICATION_RESULT_ALERT_MESSAGE_TITLE_SUCCESS: {
    es: '¡Plan de estudio listo!',
    en: 'Study plan ready!',
    cat: 'Pla d’estudi llest!',
    eus: 'Ikasketa plano zaude!',
    pt: 'Plano de estudo pronto!'
  },
  PLANIFICATION_RESULT_ALERT_MESSAGE_CONTENT_SUCCESS: {
    es: 'Te guiaremos para que llegues a tu objetivo sin problemas.',
    en: 'We will guide you to reach your goal without problems.',
    cat: 'Et guiarem per arribar al teu objectiu sense problemes.',
    eus: 'Zure helburura iritsi ahal izango dizugu.',
    pt: 'Vamos te guiar para que você alcance seu objetivo sem problemas.'
  },
  FINISH_DATE_PLANIFICATION_QUESTION: {
    es: '¿En qué fecha te gustaría terminar de estudiar el temario?',
    en: 'On what date would you like to finish studying the syllabus?',
    cat: 'En quina data t’agradaria acabar d’estudiar el temari?',
    eus: 'Zein datatan amaitu nahiko zenuke temarioa ikastea?',
    pt: 'Em que data você gostaria de terminar de estudar o conteúdo?'
  },
  WHAT_ARE_YOUR_REST_DAYS: {
    es: '¿Cuáles serán tus días de descanso?',
    en: 'What will your rest days be?',
    cat: 'Quins seran els teus dies de descans?',
    eus: 'Zein izango dira zure atseden-egunak?',
    pt: 'Quais serão os seus dias de descanso?'
  },
  WHAT_ARE_YOUR_REST_DATES: {
    es: 'Indica tus vacaciones o días en los que no estudiarás',
    en: 'Indicate your vacations or days you will not study',
    cat: 'Indica les teves vacances o dies en que no estudiaràs',
    eus: 'Indicate zure atseden-egunak edo ikasten ez duzun egunak',
    pt: 'Indique seus feriados ou dias que não estudará'
  },
  CHOOSE_THE_COURSES_YOU_WILL_STUDY: {
    es: 'Elige los cursos que vas a estudiar',
    en: 'Choose the courses you will study',
    cat: 'Escull els cursos que estudiaràs',
    eus: 'Aukeratu ikasten duzun ikastarok',
    pt: 'Escolha os cursos que você vai estudar'
  },
  SELECT_AT_LEAST_ONE_COURSE: {
    es: 'Selecciona al menos un curso',
    en: 'Select at least one course',
    cat: 'Selecciona almenys un curs',
    eus: 'Aukeratu gutxienez ikastar bat',
    pt: 'Selecione pelo menos um curso'
  },
  CALCULATE_TIMES: {
    es: 'Calcular tiempos',
    en: 'Calculate times',
    cat: 'Calcular temps',
    eus: 'Kalkulatu denbora',
    pt: 'Calcular tempo'
  },
  CANT_LOAD_VIDEO_FILE: {
    es: 'No se puede cargar el archivo de video',
    en: 'Cannot load video file',
    cat: 'No es pot carregar el fitxer de vídeo',
    eus: 'Ezin da bideo fitxategia kargatu',
    pt: 'Não é possível carregar o arquivo de vídeo'
  },
  ALL_FIRST_STEPS_COMPLETED: {
    es: '¡Has completado tus primeros pasos!',
    en: 'You have completed your first steps!',
    cat: 'Has completat els teus primers passos!',
    eus: 'Zuk zure lehenengo pausoak egin duzu!',
    pt: 'Você completou seus primeiros passos!'
  },
  [EExamGroupStatus.PENDING_DATE]: {
    es: 'Fecha pendiente',
    en: 'Pending date',
    cat: 'Data pendent',
    eus: 'Data pendiente',
    pt: 'Data pendente'
  },
  [EExamGroupStatus.OPEN_PERIOD]: {
    es: 'Plazo abierto',
    en: 'Open period',
    cat: 'Plazo obert',
    eus: 'Plazo ireki',
    pt: 'Prazo aberto'
  },
  [EExamGroupStatus.CLOSED_PERIOD]: {
    es: 'Plazo cerrado',
    en: 'Closed period',
    cat: 'Plazo tancat',
    eus: 'Plazo ireki',
    pt: 'Prazo fechado'
  },
  [EExamGroupStatus.PROVISIONAL_LIST]: {
    es: 'Lista provisional',
    en: 'Provisional list',
    cat: 'Llista provisional',
    eus: 'Lista provisional',
    pt: 'Lista provisória'
  },
  [EExamGroupStatus.DEFINITIVE_LIST]: {
    es: 'Lista definitiva',
    en: 'Definitive list',
    cat: 'Llista definitiva',
    eus: 'Lista definitiva',
    pt: 'Lista definitiva'
  },
  [EExamGroupStatus.ANNOUNCED_DATE]: {
    es: 'Fecha anunciada',
    en: 'Announced date',
    cat: 'Data anunciada',
    eus: 'Data anunciada',
    pt: 'Data anunciada'
  },
  [EExamGroupStatus.EXAM_IN_PROGRESS]: {
    es: 'Examen en progreso',
    en: 'Exam in progress',
    cat: 'Examen en progres',
    eus: 'Examenen progresoa',
    pt: 'Exame em progresso'
  },
  [EExamGroupStatus.COMPETITION_PHASE]: {
    es: 'Fase de concurso',
    en: 'Competition phase',
    cat: 'Fase de concurs',
    eus: 'Konkurrentzia fasea',
    pt: 'Fase de concurso'
  },
  [EExamGroupStatus.COMPLETED_PHASE]: {
    es: 'Finalizada',
    en: 'Completed',
    cat: 'Finalitzada',
    eus: 'Amaituta',
    pt: 'Finalizada'
  },
  [EExamGroupStatus.NOTES_PUBLISHED]: {
    es: 'Notas publicadas',
    en: 'Notes published',
    cat: 'Notes publicades',
    eus: 'Notak argitaratuak',
    pt: 'Notas publicadas'
  },
  [EExamGroupLinkType.OFFICIAL_BULLETIN_LINK]: {
    es: 'Boletín oficial',
    en: 'Official bulletin',
    cat: 'Boletí oficial',
    eus: 'Boletí oficial',
    pt: 'Boletim oficial'
  },
  [EExamGroupLinkType.REGISTRATION_GUIDE_LINK]: {
    es: 'Guía de inscripción',
    en: 'Registration guide',
    cat: 'Guia de inscripció',
    eus: 'Inskripzioaren gida',
    pt: 'Guia de inscrição'
  },
  [EExamGroupLinkType.REGISTRATION_LINK]: {
    es: 'Enlace de inscripción',
    en: 'Registration link',
    cat: "Enllaç d'inscripció",
    eus: 'Inskripzioaren lotura',
    pt: 'Link de inscrição'
  },
  [EExamGroupLinkType.APPLICATION_TRACKING_LINK]: {
    es: 'Seguimiento de convocatoria',
    en: 'Application tracking',
    cat: 'Seguiment de convocatòria',
    eus: 'Konkurrentziaren ikuspegia',
    pt: 'Rastreamento de convocação'
  },
  [EExamGroupLinkType.PROVISIONAL_LIST_LINK]: {
    es: 'Lista provisional',
    en: 'Provisional list',
    cat: 'Llista provisional',
    eus: 'Lista provisional',
    pt: 'Lista provisória'
  },
  [EExamGroupLinkType.DEFINITIVE_LIST_LINK]: {
    es: 'Lista definitiva',
    en: 'Definitive list',
    cat: 'Llista definitiva',
    eus: 'Lista definitiva',
    pt: 'Lista definitiva'
  },
  [EExamGroupLinkType.OTHER_LINK]: {
    es: 'Otro',
    en: 'Other',
    cat: 'Altres',
    eus: 'Besteak',
    pt: 'Outro'
  },
  SELECT_TYPE: {
    es: 'Tipo de enlace',
    en: 'Link type',
    cat: "Tipus d'enllaç",
    eus: 'Lotura mota',
    pt: 'Tipo de link'
  },
  TYPES: {
    es: 'Tipos',
    en: 'Types',
    cat: 'Tipus',
    eus: 'Mota',
    pt: 'Tipos'
  },
  SELECT_STATUS: {
    es: 'Seleccionar estado',
    en: 'Select status',
    cat: 'Seleccionar estat',
    eus: 'Egoera hautatu',
    pt: 'Selecionar estado'
  },
  WARNING_CHANGING_STUDENT_TAGS: {
    es: 'Atención: se perderá información',
    en: 'Attention: information will be lost',
    cat: 'Atenció: perdereu informació',
    eus: 'Abisua: informazioa galduko duzu',
    pt: 'Atenção: você perderá informações'
  },
  WARNING_CHANGING_STUDENT_TAGS_TEXT: {
    es: 'Si cambias las formaciones, el alumno perderá información clave (planificación, notificaciones y ajustes). Hazlo solo si es estrictamente necesario.',
    en: 'If you change the formations, the student will lose important information (study plan, notification settings, etc.). Do it only if strictly necessary.',
    cat: "Si canvieu les formacions, l'estudiant perdrà informació important (planificació d'estudis, configuració de notificacions, etc.). Feu-ho només si és estrictament necessari.",
    eus: 'Formazioak aldatzean, ikasleak garrantzitsuen informazioa galduko du (ikasketa planoa, jakinarazpen ezarpenak, etab.). Egin bakarrik soilik beharrezkoa bada.',
    pt: 'Se você alterar as formacões, o aluno perderá informações importantes (plano de estudos, configurações de notificações, etc.). Faça isso apenas se for estritamente necessário.'
  },
  INFORMATION: {
    es: 'Información',
    en: 'Information',
    cat: 'Informació',
    eus: 'Informazioa',
    pt: 'Informação'
  },
  BORN_COUNTRY: {
    es: 'País de nacimiento',
    en: 'Country of birth',
    cat: 'País de naixement',
    eus: 'Jaiotze-herrialdea',
    pt: 'País de nascimento'
  },
  RESIDENCE_COUNTRY: {
    es: 'País de residencia',
    en: 'Residence country',
    cat: 'País de residència',
    eus: 'Bizileku-herrialdea',
    pt: 'País de residência'
  },
  BORN_DATE: {
    es: 'Fecha de nacimiento',
    en: 'Date of birth',
    cat: 'Data de naixement',
    eus: 'Jaiotze-data',
    pt: 'Data de nascimento'
  },
  LEGAL_ID: {
    es: 'DNI/NIE/Pasaporte',
    en: 'DNI/NIE/Passport',
    cat: 'DNI/NIE/Passaport',
    eus: 'DNI/NIE/Pasaporte',
    pt: 'DNI/NIE/Passaporte'
  },
  IDENTIFICATION_DOCUMENT: {
    es: 'Documento de identificación',
    en: 'Identification document',
    cat: "Document d'identificació",
    eus: 'Identifikazio dokumentua',
    pt: 'Documento de identificação'
  },
  DOCUMENT_NUMBER_PLACEHOLDER: {
    es: 'Número de documento',
    en: 'Document number',
    cat: 'Número de document',
    eus: 'Dokumentu zenbakia',
    pt: 'Número do documento'
  },
  NATIONALITY: {
    es: 'Nacionalidad',
    en: 'Nationality',
    cat: 'Nacionalitat',
    eus: 'Nazionalitatea',
    pt: 'Nacionalidade'
  },
  SEX: {
    es: 'Sexo',
    en: 'Sex',
    cat: 'Sexe',
    eus: 'Sexua',
    pt: 'Sexo'
  },
  BIRTH_DATA: {
    es: 'Datos de nacimiento',
    en: 'Birth data',
    cat: 'Dades de naixement',
    eus: 'Jaiotze datuak',
    pt: 'Dados de nascimento'
  },
  MUNICIPALITY: {
    es: 'Municipio',
    en: 'Municipality',
    cat: 'Municipi',
    eus: 'Udalerria',
    pt: 'Município'
  },
  LOCALITY: {
    es: 'Localidad',
    en: 'Locality',
    cat: 'Localitat',
    eus: 'Herria',
    pt: 'Localidade'
  },
  FOREIGN_BIRTH_LOCALITY: {
    es: 'Localidad de nacimiento extranjera',
    en: 'Foreign birth locality',
    cat: 'Localitat de naixement estrangera',
    eus: 'Atzerriko jaiotze herria',
    pt: 'Localidade de nascimento estrangeira'
  },
  FOREIGN_BIRTH_LOCALITY_PLACEHOLDER: {
    es: 'Completa la localidad de nacimiento',
    en: 'Enter birth locality',
    cat: 'Completa la localitat de naixement',
    eus: 'Sartu jaiotze herria',
    pt: 'Complete a localidade de nascimento'
  },
  ADDRESS_DATA: {
    es: 'Datos de domicilio',
    en: 'Address data',
    cat: 'Dades de domicili',
    eus: 'Helbide datuak',
    pt: 'Dados de domicílio'
  },
  STREET_TYPE: {
    es: 'Tipo de vía',
    en: 'Street type',
    cat: 'Tipus de via',
    eus: 'Kale mota',
    pt: 'Tipo de via'
  },
  PROMOTION: {
    es: 'Promoción',
    en: 'Promotion',
    cat: 'Promoció',
    eus: 'Promozioa',
    pt: 'Promoção'
  },
  SOCIAL_SECURITY_NUMBER: {
    es: 'Número de seguridad social',
    en: 'Social security number',
    cat: 'Número de seguretat social',
    eus: 'Gizarte segurantzaren zenbakia',
    pt: 'Número de segurança social'
  },
  GENDER: {
    es: 'Género',
    en: 'Gender',
    cat: 'Gènere',
    eus: 'Generoa',
    pt: 'Gênero'
  },
  STUDY_PLAN_INFO: {
    es: 'Plan de estudio',
    en: 'Study plan',
    cat: 'Pla d’estudis',
    eus: 'Ikasketa planoa',
    pt: 'Plano de estudo'
  },
  STUDY_PLAN_DAILY_STUDY_TIME: {
    es: 'Horas de estudio al día',
    en: 'Study hours per day',
    cat: 'Temps d’estudi per dia',
    eus: 'Ikasketa orduak egunero',
    pt: 'Horas de estudo por dia'
  },
  EDIT: {
    es: 'Editar',
    en: 'Edit',
    cat: 'Editar',
    eus: 'Editatu',
    pt: 'Editar'
  },
  GOAL: {
    es: 'Meta',
    en: 'Goal',
    cat: 'Meta',
    eus: 'Helburua',
    pt: 'Meta'
  },
  EXTRAS: {
    es: 'Extras',
    en: 'Extras',
    cat: 'Extras',
    eus: 'Extras',
    pt: 'Extras'
  },
  HOW_HEARD_ABOUT_US: {
    es: '¿Cómo nos conociste?',
    en: 'How did you hear about us?',
    cat: 'Com us vau conèixer?',
    eus: 'Nola ezagutu gaituzu?',
    pt: 'Como você nos conheceu?'
  },
  WHY_CHOOSE_US: {
    es: '¿Por qué nos eligiste?',
    en: 'Why did you choose us?',
    cat: 'Per què vostè va triar-nos?',
    eus: 'Zergatik aukeratu gaituzu?',
    pt: 'Por que você nos escolheu?'
  },
  ARE_YOU_WORKING_CURRENTLY: {
    es: '¿Estás trabajando actualmente?',
    en: 'Are you currently working?',
    cat: 'Esteu treballant actualment?',
    eus: 'Une honetan lanean ari zara?',
    pt: 'Você está trabalhando atualmente?'
  },
  WHAT_IS_YOUR_CURRENT_JOB: {
    es: '¿De qué trabajas?',
    en: 'What is your current job?',
    cat: 'Quin és el vostre treball actual?',
    eus: 'Zein da zure egungo lana?',
    pt: 'Qual é o seu trabalho atual?'
  },
  SALARY_RANGE: {
    es: 'Rango salarial',
    en: 'Salary range',
    cat: 'Rang salarial',
    eus: 'Soldata tartea',
    pt: 'Faixa salarial'
  },
  [EOnboardingDiscoverySource.GOOGLE]: {
    es: 'Google',
    en: 'Google',
    cat: 'Google',
    eus: 'Google',
    pt: 'Google'
  },
  [EOnboardingDiscoverySource.SOCIAL_MEDIA]: {
    es: 'Redes sociales',
    en: 'Social media',
    cat: 'Redes socials',
    eus: 'Sare sozialak',
    pt: 'Redes sociais'
  },
  [EOnboardingDiscoverySource.ADVERTISEMENT]: {
    es: 'Publicidad',
    en: 'Advertisement',
    cat: 'Publicitat',
    eus: 'Publicitatea',
    pt: 'Publicidade'
  },
  [EOnboardingDiscoverySource.FRIEND]: {
    es: 'Amigo',
    en: 'Friend',
    cat: 'Amic',
    eus: 'Amaia',
    pt: 'Amigo'
  },
  [EOnboardingDiscoverySource.FLYER]: {
    es: 'Flyer',
    en: 'Flyer',
    cat: 'Flyer',
    eus: 'Flyer',
    pt: 'Flyer'
  },
  [EOnboardingChosenReason.COMPATIBILITY_WITH_WORK_AND_FAMILY]: {
    es: 'Compatibilidad con mi trabajo y/o vida familiar',
    en: 'Compatibility with my work and/or family life',
    cat: 'Compatibilitat amb el meu treball i/o la meva vida familiar',
    eus: 'Lana eta/edo bizitza familiariari dagokion',
    pt: 'Compatibilidade com o meu trabalho e/ou vida familiar'
  },
  [EOnboardingChosenReason.AFFORDABLE_PRICE]: {
    es: 'Precio accesible',
    en: 'Affordable price',
    cat: 'Accessible preu',
    eus: 'Prezio erabilgarria',
    pt: 'Preço acessível'
  },
  [EOnboardingChosenReason.QUALITY_PLATFORM_AND_CONTENT]: {
    es: 'Plataforma y contenido de calidad',
    en: 'Quality platform and content',
    cat: 'Plataforma i contingut de qualitat',
    eus: 'Plataforma eta edukia kualitatea',
    pt: 'Plataforma e conteúdo de qualidade'
  },
  [EOnboardingChosenReason.PERSONALIZED_SUPPORT_AND_ATTENTION]: {
    es: 'Acompañamiento y atención personalizada',
    en: 'Personalized support and attention',
    cat: 'Acompañament i atenció personalitzada',
    eus: 'Laguntza eta arreta pertsonalizatuak',
    pt: 'Acompanhamento e atenção personalizada'
  },
  [EOnboardingChosenReason.FLEXIBILITY_TO_STUDY_AT_MY_RHYTHM]: {
    es: 'Flexibilidad para estudiar a mi ritmo',
    en: 'Flexibility to study at my rhythm',
    cat: 'Flexibilitat per estudiar a mi ritme',
    eus: 'Arreta per ikastarazketa nire ritmora',
    pt: 'Flexibilidade para estudar a meu ritmo'
  },
  [EOnboardingChosenReason.EASY_VISA_PROCESS]: {
    es: 'Facilidad para obtener visado en España',
    en: 'Easy visa process in Spain',
    cat: 'Facilitat per obtenir visat a Espanya',
    eus: 'Espainiako visa lortzeko arreta erraza',
    pt: 'Facilidade para obter visado em Espanha'
  },
  [EOnboardingChosenReason.FINANCIAL_OPTIONS]: {
    es: 'Opciones de financiación',
    en: 'Financial options',
    cat: 'Opcions de finançament',
    eus: 'Finantzaketa aukerak',
    pt: 'Opções de financiamento'
  },
  [ELegacyOnboardingChosenReason.MICROLESSON]: {
    es: 'Microlección',
    en: 'Microlesson',
    cat: 'Microlecció',
    eus: 'Microleccióa',
    pt: 'Microlição'
  },
  [ELegacyOnboardingChosenReason.TEACHER_FOLLOW_UP]: {
    es: 'Seguimiento de profesor',
    en: 'Teacher follow up',
    cat: 'Seguiment de professor',
    eus: 'Ikaskidearen ikuspegia',
    pt: 'Seguimento de professor'
  },
  [ELegacyOnboardingChosenReason.SUCCESS_GUARANTEE]: {
    es: 'Garantía de éxito',
    en: 'Success guarantee',
    cat: 'Garantia de èxit',
    eus: 'Errepikapen ziurtagiria',
    pt: 'Garantia de sucesso'
  },
  [ELegacyOnboardingChosenReason.ATTENTION]: {
    es: 'Atención',
    en: 'Attention',
    cat: 'Atenció',
    eus: 'Arreta',
    pt: 'Atenção'
  },
  [ELegacyOnboardingChosenReason.HELP_IN_EVERYTHING]: {
    es: 'Ayuda en todo',
    en: 'Help in everything',
    cat: 'Ajuda en tot',
    eus: 'Laguntza guztian',
    pt: 'Ajuda em tudo'
  },
  PHONE: {
    es: 'Teléfono',
    en: 'Phone',
    cat: 'Telèfon',
    eus: 'Telefonoa',
    pt: 'Telefone'
  },
  SATISFACTION_STATUS: {
    es: 'Estado de satisfacción',
    en: 'Satisfaction status',
    cat: 'Estat de satisfacció',
    eus: 'Satisfazioaren egoera',
    pt: 'Estado de satisfação'
  },
  CONNECTION_STATUS: {
    es: 'Estado de conexión',
    en: 'Connection status',
    cat: 'Estat de connexió',
    eus: 'Konexioaren egoera',
    pt: 'Estado de conexão'
  },
  PAYMENT_STATUS: {
    es: 'Estado de pago',
    en: 'Payment status',
    cat: 'Estat de pagament',
    eus: 'Ordezkoaren egoera',
    pt: 'Estado de pagamento'
  },
  ACTIVATION_STATUS: {
    es: 'Estado de activación',
    en: 'Activation status',
    cat: "Estat d'activació",
    eus: 'Aktibazioaren egoera',
    pt: 'Estado de activação'
  },
  THREE_DAYS_REMAINING_TO_CLOSE_REGISTRATION_PERIOD: {
    es: 'Quedan 3 días para inscribirte en {{examGroup}}',
    en: 'There are 3 days left to register in {{examGroup}}',
    cat: 'Queden 3 dies per inscriure en {{examGroup}}',
    eus: '{{examGroup}}-en izena emateko 3 egun geratzen dira',
    pt: 'Restam 3 dias para se inscrever em {{examGroup}}'
  },
  EXAM_GROUP_PROVISIONAL_LIST_PUBLISHED_TITLE: {
    es: 'Lista provisional publicada de {{examGroup}}',
    en: 'Provisional list published of {{examGroup}}',
    cat: 'Llista provisional publicada de {{examGroup}}',
    eus: 'Lista provisional argitaratua {{examGroup}}',
    pt: 'Lista provisória publicada de {{examGroup}}'
  },
  EXAM_GROUP_FINAL_LIST_PUBLISHED_TITLE: {
    es: 'Lista definitiva publicada de {{examGroup}}',
    en: 'Definitive list published of {{examGroup}}',
    cat: 'Llista definitiva publicada de {{examGroup}}',
    eus: 'Lista definitiva argitaratua {{examGroup}}',
    pt: 'Lista definitiva publicada de {{examGroup}}'
  },
  EXAM_GROUP_EXAM_DATE_PUBLISHED_TITLE: {
    es: 'Fecha de examen anunciada para {{examGroup}}',
    en: 'Exam date announced for {{examGroup}}',
    cat: 'Data d´examen anunciada per {{examGroup}}',
    eus: 'Ezaldiaren data argitaratua {{examGroup}}',
    pt: 'Data de exame anunciada para {{examGroup}}'
  },
  EXAM_GROUP_PUBLISH_NOTES_TITLE: {
    es: 'Notas publicadas de {{examGroup}}',
    en: 'Notes published of {{examGroup}}',
    cat: 'Notes publicades de {{examGroup}}',
    eus: 'Notak argitaratuak {{examGroup}}',
    pt: 'Notas publicadas de {{examGroup}}'
  },
  EXAM_GROUP_IN_COMPETITION_PHASE_TITLE: {
    es: 'Ha empezado la fase de baremación de {{examGroup}}',
    en: 'Competition phase of {{examGroup}}',
    cat: 'Fase de concurs de {{examGroup}}',
    eus: 'Konkurrentzia fasea {{examGroup}}',
    pt: 'Fase de concurso de {{examGroup}}'
  },
  PARTED_TASK_DATE_FORMAT: {
    es: 'Día {{partIndex}}/{{partsTotal}}',
    en: 'Day {{partIndex}}/{{partsTotal}}',
    cat: 'Dia {{partIndex}}/{{partsTotal}}',
    eus: 'Egun {{partIndex}}/{{partsTotal}}',
    pt: 'Dia {{partIndex}}/{{partsTotal}}'
  },
  PARTED_TASK_DATE_TOOLTIP: {
    es: 'Esta actividad está dividida en {{partsTotal}} días según tu ritmo de estudio',
    en: 'This activity is divided into {{partsTotal}} days according to your study pace',
    cat: "Aquesta activitat està dividida en {{partsTotal}} dies segons el teu ritme d'estudi",
    eus: 'Ikastaroa {{partsTotal}} egunetan banatuta dago zure ikastararen abiaduran',
    pt: 'Esta atividade está dividida em {{partsTotal}} dias de acordo com seu ritmo de estudo'
  },
  [ESalaryRange.FROM_500_TO_1000]: {
    es: '500-1000',
    en: '500-1000',
    cat: '500-1000',
    eus: '500-1000',
    pt: '500-1000'
  },
  [ESalaryRange.FROM_1000_TO_2000]: {
    es: '1000-2000',
    en: '1000-2000',
    cat: '1000-2000',
    eus: '1000-2000',
    pt: '1000-2000'
  },
  [ESalaryRange.FROM_2000_TO_3000]: {
    es: '2000-3000',
    en: '2000-3000',
    cat: '2000-3000',
    eus: '2000-3000',
    pt: '2000-3000'
  },
  [ESalaryRange.FROM_3000_TO_4000]: {
    es: '3000-4000',
    en: '3000-4000',
    cat: '3000-4000',
    eus: '3000-4000',
    pt: '3000-4000'
  },
  [ESalaryRange.FROM_4000_TO_6000]: {
    es: '4000-6000',
    en: '4000-6000',
    cat: '4000-6000',
    eus: '4000-6000',
    pt: '4000-6000'
  },
  [ESalaryRange.FROM_6000_TO_8000]: {
    es: '6000-8000',
    en: '6000-8000',
    cat: '6000-8000',
    eus: '6000-8000',
    pt: '6000-8000'
  },
  [ESalaryRange.FROM_8000_TO_10000]: {
    es: '8000-10000',
    en: '8000-10000',
    cat: '8000-10000',
    eus: '8000-10000',
    pt: '8000-10000'
  },
  [ESalaryRange.MORE_THAN_10000]: {
    es: '10000+',
    en: '10000+',
    cat: '10000+',
    eus: '10000+',
    pt: '10000+'
  },
  [EGender.MALE]: {
    es: 'Hombre',
    en: 'Male',
    cat: 'Masculí',
    eus: 'Gizon',
    pt: 'Homem'
  },
  [EGender.FEMALE]: {
    es: 'Mujer',
    en: 'Female',
    cat: 'Femení',
    eus: 'Emakume',
    pt: 'Mulher'
  },
  EXTRA_DATA: {
    es: 'Datos extra',
    en: 'Extra data',
    cat: 'Datos extra',
    eus: 'Datu extra',
    pt: 'Dados extra'
  },
  SELECT_GENDER: {
    es: 'Selecciona el género',
    en: 'Select gender',
    cat: 'Selecciona el gènere',
    eus: 'Hautatu generoa',
    pt: 'Selecione o gênero'
  },
  SELECT_DOCUMENT_TYPE: {
    es: 'Selecciona el tipo de documento',
    en: 'Select document type',
    cat: 'Selecciona el tipus de document',
    eus: 'Hautatu dokumentu mota',
    pt: 'Selecione o tipo de documento'
  },
  SELECT_STREET_TYPE: {
    es: 'Selecciona el tipo de vía',
    en: 'Select street type',
    cat: 'Selecciona el tipus de via',
    eus: 'Hautatu kale mota',
    pt: 'Selecione o tipo de via'
  },
  SEARCH_COUNTRY: {
    es: 'Buscar país...',
    en: 'Search country...',
    cat: 'Cercar país...',
    eus: 'Herrialdea bilatu...',
    pt: 'Pesquisar país...'
  },
  NO_RESULTS_FOUND: {
    es: 'No se encontraron resultados',
    en: 'No results found',
    cat: "No s'han trobat resultats",
    eus: 'Ez da emaitzarik aurkitu',
    pt: 'Nenhum resultado encontrado'
  },
  NO_DATA: {
    es: 'Sin datos',
    en: 'No data',
    cat: 'Sense dades',
    eus: 'Daturik gabe',
    pt: 'Sem dados'
  },
  DRAG_FILES_HERE: {
    es: '<span>Seleccionar archivo</span> o arrastra y suelta el {{fileTypes}} aquí',
    en: '<span>Select file</span> or drag and drop the {{fileTypes}} here',
    cat: '<span>Seleccionar fitxer</span> o arrossegar i deixar anar el {{fileTypes}} aquí',
    eus: '<span>Fitxategia hautatu</span> edo arrastatu eta utzi {{fileTypes}} hemen',
    pt: '<span>Selecionar ficheiro</span> ou arrastar e soltar o {{fileTypes}} aqui'
  },
  UPLOAD_FAILED: {
    es: 'Error al subir el archivo',
    en: 'Failed to upload file',
    cat: 'Error en pujar el fitxer',
    eus: 'Errorea fitxategia igotzean',
    pt: 'Erro ao enviar arquivo'
  },
  INVALID_FILE_TYPE: {
    es: 'Tipo de archivo no válido',
    en: 'Invalid file type',
    cat: 'Tipus de fitxer no vàlid',
    eus: 'Fitxategi mota baliogabea',
    pt: 'Tipo de arquivo inválido'
  },
  FILE_TOO_LARGE: {
    es: 'El archivo es demasiado grande (máximo {{max}}MB)',
    en: 'File is too large (max {{max}}MB)',
    cat: 'El fitxer és massa gran (màxim {{max}}MB)',
    eus: 'Fitxategia handiegia da (gehienez {{max}}MB)',
    pt: 'O arquivo é muito grande (máximo {{max}}MB)'
  },
  FILE_TOO_LARGE_TITLE: {
    es: 'El archivo supera el tamaño máximo permitido de {{max}}MB.',
    en: 'The file exceeds the maximum allowed size of {{max}}MB.',
    cat: 'El fitxer supera la mida màxima permesa de {{max}}MB.',
    eus: 'Fitxategiak baimendutako gehienezko tamaina gainditzen du: {{max}}MB.',
    pt: 'O arquivo excede o tamanho máximo permitido de {{max}}MB.'
  },
  INVALID_FILE_TYPE_TITLE: {
    es: 'El formato no es válido. Por favor, sube un archivo en formato: {{formats}}',
    en: 'Invalid format. Please upload a file in the following formats: {{formats}}',
    cat: 'Format no vàlid. Si us plau, carrega un fitxer en format: {{formats}}',
    eus: 'Formatu baliogabea. Mesedez, kargatu fitxategi formatu honetan: {{formats}}',
    pt: 'Formato inválido. Por favor, envie um arquivo no formato: {{formats}}'
  },
  MULTIPLE_FILES_TITLE: {
    es: 'Ups, solo puedes subir uno. Combina todos tus archivos en uno solo y vuelve a intentarlo.',
    en: 'Oops, you can only upload one. Combine all your files into one and try again.',
    cat: 'Ups, només pots pujar un. Combina tots els fitxers en un sol i intenta-ho de nou.',
    eus: 'Ups, bakarra igo dezakezu. Batu fitxa-guztiak bat eta saiatu berriro.',
    pt: 'Oops, você só pode enviar um. Combine todos os seus arquivos em um e tente novamente.'
  },
  SENDING: {
    es: 'Enviando...',
    en: 'Sending...',
    cat: 'Enviando...',
    eus: 'Enviando...',
    pt: 'Enviando...'
  },
  [ELegalIdType.DNI_NIF_NIE]: {
    es: 'DNI/NIF/NIE',
    en: 'DNI/NIF/NIE',
    cat: 'DNI/NIF/NIE',
    eus: 'DNI/NIF/NIE',
    pt: 'DNI/NIF/NIE'
  },
  [ELegalIdType.PASSPORT_OTHER]: {
    es: 'Pasaporte/Otro',
    en: 'Passport/Other',
    cat: 'Passaport/Altres',
    eus: 'Pasaportea/Beste',
    pt: 'Passaporte/Outro'
  },
  DISCARD_CHANGES_QUESTION: {
    es: '¿Descartar cambios?',
    en: 'Discard changes?',
    cat: 'Descartar canvis?',
    eus: 'Aldaketak baztertu?',
    pt: 'Descartar alterações?'
  },
  DISCARD_CHANGES_DESCRIPTION: {
    es: 'Si cierras esta ventana, se cancelarán todos los cambios no guardados.',
    en: 'If you close this window, all unsaved changes will be cancelled.',
    cat: 'Si tanques aquesta finestra, es cancel·laran tots els canvis no desats.',
    eus: 'Leiho hau ixten baduzu, gorde gabeko aldaketa guztiak ezeztatuko dira.',
    pt: 'Se fechar esta janela, todas as alterações não guardadas serão canceladas.'
  },
  CLOSE_AND_DISCARD: {
    es: 'Cerrar y Descartar',
    en: 'Close and Discard',
    cat: 'Tancar i Descartar',
    eus: 'Itxi eta Baztertu',
    pt: 'Fechar e Descartar'
  },
  KEEP_EDITING: {
    es: 'Seguir editando',
    en: 'Keep editing',
    cat: 'Continuar editant',
    eus: 'Editatzen jarraitu',
    pt: 'Continuar editando'
  },
  REPLACE_FILE: {
    es: 'Reemplazar archivo',
    en: 'Replace file',
    cat: 'Reemplazar fitxer',
    eus: 'Fitxategia ordeztu',
    pt: 'Substituir arquivo'
  },
  DELETE_FILE: {
    es: 'Eliminar archivo',
    en: 'Delete file',
    cat: 'Eliminar fitxer',
    eus: 'Fitxategia ezabatu',
    pt: 'Excluir arquivo'
  },
  DELETE_FILE_CONFIRM_MESSAGE: {
    es: '¿Estás seguro de que quieres eliminar el archivo "{{fileName}}"? No podrás revertir esta acción.',
    en: 'Are you sure you want to delete the file "{{fileName}}"? You cannot revert this action.',
    cat: 'Estàs segur que vols eliminar el fitxer "{{fileName}}"? No podràs revertir aquesta acció.',
    eus: '"{{fileName}}" fitxategia ezabatu nahi duzula ziur zaude? Ezin izango duzu ekintza hau atzera egin.',
    pt: 'Tem certeza de que deseja excluir o arquivo "{{fileName}}"? Não poderá reverter esta ação.'
  },
  YES_DELETE: {
    es: 'Sí, eliminar',
    en: 'Yes, delete',
    cat: 'Sí, eliminar',
    eus: 'Bai, ezabatu',
    pt: 'Sim, excluir'
  },
  VIEW_FILE: {
    es: 'Ver archivo',
    en: 'View file',
    cat: 'Veure fitxer',
    eus: 'Fitxategia ikusi',
    pt: 'Ver arquivo'
  },
  [EStreetType.AQUEDUCT]: {
    es: 'Acueducto',
    en: 'Aqueduct',
    cat: 'Aqüeducte',
    eus: 'Akueduktu',
    pt: 'Aqueduto'
  },
  [EStreetType.AERODROME]: {
    es: 'Aeródromo',
    en: 'Aerodrome',
    cat: 'Aeròdrom',
    eus: 'Aerodromo',
    pt: 'Aeródromo'
  },
  [EStreetType.AIRPORT]: {
    es: 'Aeropuerto',
    en: 'Airport',
    cat: 'Aeroport',
    eus: 'Aireportu',
    pt: 'Aeroporto'
  },
  [EStreetType.PROMENADE]: {
    es: 'Alameda',
    en: 'Promenade',
    cat: 'Alameda',
    eus: 'Zumardi',
    pt: 'Alameda'
  },
  [EStreetType.WAREHOUSE]: {
    es: 'Almacén',
    en: 'Warehouse',
    cat: 'Magatzem',
    eus: 'Biltegi',
    pt: 'Armazém'
  },
  [EStreetType.HEIGHT]: {
    es: 'Alto',
    en: 'High point',
    cat: 'Alt',
    eus: 'Gain',
    pt: 'Alto'
  },
  [EStreetType.PO_BOX]: {
    es: 'Apartado Postal',
    en: 'PO Box',
    cat: 'Apartat de Correus',
    eus: 'Posta-kutxatila',
    pt: 'Apartado'
  },
  [EStreetType.APARTMENT]: {
    es: 'Apartamento',
    en: 'Apartment',
    cat: 'Apartament',
    eus: 'Apartamentu',
    pt: 'Apartamento'
  },
  [EStreetType.STREAM]: {
    es: 'Arroyo',
    en: 'Stream',
    cat: 'Rierol',
    eus: 'Erreka',
    pt: 'Córrego'
  },
  [EStreetType.HIGHWAY]: {
    es: 'Autovía',
    en: 'Highway',
    cat: 'Autovia',
    eus: 'Autobia',
    pt: 'Autoestrada'
  },
  [EStreetType.AVENUE]: {
    es: 'Avenida',
    en: 'Avenue',
    cat: 'Avinguda',
    eus: 'Hiribide',
    pt: 'Avenida'
  },
  [EStreetType.DESCENT]: {
    es: 'Bajada',
    en: 'Descent',
    cat: 'Baixada',
    eus: 'Jaitsiera',
    pt: 'Descida'
  },
  [EStreetType.RAVINE]: {
    es: 'Barranco',
    en: 'Ravine',
    cat: 'Barranc',
    eus: 'Sakan',
    pt: 'Barranco'
  },
  [EStreetType.DISTRICT]: {
    es: 'Barriada',
    en: 'District',
    cat: 'Barriada',
    eus: 'Auzune',
    pt: 'Bairro'
  },
  [EStreetType.NEIGHBORHOOD]: {
    es: 'Barrio',
    en: 'Neighborhood',
    cat: 'Barri',
    eus: 'Auzo',
    pt: 'Bairro'
  },
  [EStreetType.BASILICA]: {
    es: 'Basílica',
    en: 'Basilica',
    cat: 'Basílica',
    eus: 'Basilika',
    pt: 'Basílica'
  },
  [EStreetType.BLOCK]: {
    es: 'Bloque',
    en: 'Block',
    cat: 'Bloc',
    eus: 'Bloke',
    pt: 'Bloco'
  },
  [EStreetType.BOULEVARD]: {
    es: 'Bulevar',
    en: 'Boulevard',
    cat: 'Bulevard',
    eus: 'Bulebar',
    pt: 'Bulevar'
  },
  [EStreetType.ST_ABBREV]: {
    es: 'Calle',
    en: 'Street',
    cat: 'Carrer',
    eus: 'Kale',
    pt: 'Rua'
  },
  [EStreetType.STREET]: {
    es: 'Calle',
    en: 'Street',
    cat: 'Carrer',
    eus: 'Kale',
    pt: 'Rua'
  },
  [EStreetType.NARROW_ALLEY]: {
    es: 'Calleja',
    en: 'Narrow alley',
    cat: 'Carreró',
    eus: 'Kalexka',
    pt: 'Viela'
  },
  [EStreetType.ALLEY]: {
    es: 'Callejón',
    en: 'Alley',
    cat: 'Carreró',
    eus: 'Kale-zulo',
    pt: 'Beco'
  },
  [EStreetType.PATH]: {
    es: 'Camino',
    en: 'Path',
    cat: 'Camí',
    eus: 'Bide',
    pt: 'Caminho'
  },
  [EStreetType.CAMP]: {
    es: 'Campamento',
    en: 'Camp',
    cat: 'Campament',
    eus: 'Kanpamentu',
    pt: 'Acampamento'
  },
  [EStreetType.CANAL]: {
    es: 'Canal',
    en: 'Canal',
    cat: 'Canal',
    eus: 'Ubide',
    pt: 'Canal'
  },
  [EStreetType.CORNER_STREET]: {
    es: 'Cantón',
    en: 'Corner',
    cat: 'Cantó',
    eus: 'Kantoia',
    pt: 'Esquina'
  },
  [EStreetType.CATTLE_TRACK]: {
    es: 'Cañada',
    en: 'Cattle track',
    cat: 'Canyada',
    eus: 'Abelbide',
    pt: 'Canada'
  },
  [EStreetType.WAY]: {
    es: 'Carrera',
    en: 'Way',
    cat: 'Carrera',
    eus: 'Kale',
    pt: 'Carreira'
  },
  [EStreetType.ROAD]: {
    es: 'Carretera',
    en: 'Road',
    cat: 'Carretera',
    eus: 'Errepide',
    pt: 'Estrada'
  },
  [EStreetType.LANE]: {
    es: 'Carril',
    en: 'Lane',
    cat: 'Carril',
    eus: 'Errei',
    pt: 'Faixa'
  },
  [EStreetType.HOUSE]: {
    es: 'Casa',
    en: 'House',
    cat: 'Casa',
    eus: 'Etxe',
    pt: 'Casa'
  },
  [EStreetType.HAMLET]: {
    es: 'Caserío',
    en: 'Hamlet',
    cat: 'Caseriu',
    eus: 'Baserri',
    pt: 'Casario'
  },
  [EStreetType.SHEDS]: {
    es: 'Casetas',
    en: 'Sheds',
    cat: 'Casetes',
    eus: 'Etxolak',
    pt: 'Cabanas'
  },
  [EStreetType.BOOTH]: {
    es: 'Casilla',
    en: 'Booth',
    cat: 'Casella',
    eus: 'Etxola',
    pt: 'Guarita'
  },
  [EStreetType.CASTLE]: {
    es: 'Castillo',
    en: 'Castle',
    cat: 'Castell',
    eus: 'Gaztelu',
    pt: 'Castelo'
  },
  [EStreetType.CEMETERY]: {
    es: 'Cementerio',
    en: 'Cemetery',
    cat: 'Cementiri',
    eus: 'Hilerri',
    pt: 'Cemitério'
  },
  [EStreetType.CENTER]: {
    es: 'Centro',
    en: 'Center',
    cat: 'Centre',
    eus: 'Zentro',
    pt: 'Centro'
  },
  [EStreetType.SHOPPING_CENTER]: {
    es: 'Centro Comercial',
    en: 'Shopping Center',
    cat: 'Centre Comercial',
    eus: 'Merkataritza-gune',
    pt: 'Centro Comercial'
  },
  [EStreetType.CULTURAL_CENTER]: {
    es: 'Centro Cultural',
    en: 'Cultural Center',
    cat: 'Centre Cultural',
    eus: 'Kultur Etxe',
    pt: 'Centro Cultural'
  },
  [EStreetType.PUBLIC_CENTER]: {
    es: 'Centro Público',
    en: 'Public Center',
    cat: 'Centre Públic',
    eus: 'Zentro Publiko',
    pt: 'Centro Público'
  },
  [EStreetType.HEALTH_CENTER]: {
    es: 'Centro Sanitario',
    en: 'Health Center',
    cat: 'Centre Sanitari',
    eus: 'Osasun Zentro',
    pt: 'Centro de Saúde'
  },
  [EStreetType.HILL]: {
    es: 'Cerro',
    en: 'Hill',
    cat: 'Turó',
    eus: 'Muino',
    pt: 'Morro'
  },
  [EStreetType.CHALET]: {
    es: 'Chalet',
    en: 'Chalet',
    cat: 'Xalet',
    eus: 'Txalet',
    pt: 'Chalé'
  },
  [EStreetType.CITY]: {
    es: 'Ciudad',
    en: 'City',
    cat: 'Ciutat',
    eus: 'Hiri',
    pt: 'Cidade'
  },
  [EStreetType.TRACKWAY]: {
    es: 'Colada',
    en: 'Trackway',
    cat: 'Colada',
    eus: 'Bide',
    pt: 'Caminho'
  },
  [EStreetType.SCHOOL_INSTITUTION]: {
    es: 'Colegio',
    en: 'School',
    cat: 'Col·legi',
    eus: 'Ikastetxe',
    pt: 'Colégio'
  },
  [EStreetType.COLONY]: {
    es: 'Colonia',
    en: 'Colony',
    cat: 'Colònia',
    eus: 'Kolonia',
    pt: 'Colônia'
  },
  [EStreetType.COMPLEX]: {
    es: 'Complejo',
    en: 'Complex',
    cat: 'Complex',
    eus: 'Gune',
    pt: 'Complexo'
  },
  [EStreetType.GROUPING]: {
    es: 'Conjunto',
    en: 'Set',
    cat: 'Conjunt',
    eus: 'Multzo',
    pt: 'Conjunto'
  },
  [EStreetType.STEEP_STREET]: {
    es: 'Costanilla',
    en: 'Short steep street',
    cat: 'Costanilla',
    eus: 'Kale-malda',
    pt: 'Ladeira'
  },
  [EStreetType.SLOPE]: {
    es: 'Cuesta',
    en: 'Slope',
    cat: 'Costa',
    eus: 'Aldapa',
    pt: 'Ladeira'
  },
  [EStreetType.PASTURE]: {
    es: 'Dehesa',
    en: 'Pasture',
    cat: 'Devesa',
    eus: 'Larre',
    pt: 'Devesa'
  },
  [EStreetType.UNKNOWN]: {
    es: 'Desconocido',
    en: 'Unknown',
    cat: 'Desconegut',
    eus: 'Ezezaguna',
    pt: 'Desconhecido'
  },
  [EStreetType.SCATTERED]: {
    es: 'Diseminado',
    en: 'Scattered',
    cat: 'Disseminat',
    eus: 'Sakabanatu',
    pt: 'Disperso'
  },
  [EStreetType.DISPENSARY]: {
    es: 'Dispensario',
    en: 'Dispensary',
    cat: 'Dispensari',
    eus: 'Dispentxario',
    pt: 'Dispensário'
  },
  [EStreetType.BUILDING]: {
    es: 'Edificio',
    en: 'Building',
    cat: 'Edifici',
    eus: 'Eraikin',
    pt: 'Edifício'
  },
  [EStreetType.JUNCTION]: {
    es: 'Enlace',
    en: 'Junction',
    cat: 'Enllaç',
    eus: 'Lotura',
    pt: 'Ligação'
  },
  [EStreetType.STAIRWAY]: {
    es: 'Escalinata',
    en: 'Stairway',
    cat: 'Escalinata',
    eus: 'Eskailerak',
    pt: 'Escadaria'
  },
  [EStreetType.SCHOOL]: {
    es: 'Escuela',
    en: 'School',
    cat: 'Escola',
    eus: 'Eskola',
    pt: 'Escola'
  },
  [EStreetType.OFFICIAL_SCHOOL]: {
    es: 'Escuela Oficial',
    en: 'Official School',
    cat: 'Escola Oficial',
    eus: 'Eskola Ofizial',
    pt: 'Escola Oficial'
  },
  [EStreetType.VOCATIONAL_SCHOOL]: {
    es: 'Escuela Profesional',
    en: 'Vocational School',
    cat: 'Escola Professional',
    eus: 'Lanbide Eskola',
    pt: 'Escola Profissional'
  },
  [EStreetType.STATION]: {
    es: 'Estación',
    en: 'Station',
    cat: 'Estació',
    eus: 'Geltoki',
    pt: 'Estação'
  },
  [EStreetType.METRO_STATION]: {
    es: 'Estación de Metro',
    en: 'Metro Station',
    cat: 'Estació de Metro',
    eus: 'Metro Geltoki',
    pt: 'Estação de Metrô'
  },
  [EStreetType.STADIUM]: {
    es: 'Estadio',
    en: 'Stadium',
    cat: 'Estadi',
    eus: 'Estadio',
    pt: 'Estádio'
  },
  [EStreetType.ESPLANADE]: {
    es: 'Explanación',
    en: 'Esplanade',
    cat: 'Esplanada',
    eus: 'Zabaltegi',
    pt: 'Esplanada'
  },
  [EStreetType.OUTSKIRTS]: {
    es: 'Extrarradio',
    en: 'Outskirts',
    cat: 'Extraradi',
    eus: 'Hiri-inguru',
    pt: 'Arredores'
  },
  [EStreetType.FACTORY]: {
    es: 'Fábrica',
    en: 'Factory',
    cat: 'Fàbrica',
    eus: 'Lantegi',
    pt: 'Fábrica'
  },
  [EStreetType.FACULTY]: {
    es: 'Facultad',
    en: 'Faculty',
    cat: 'Facultat',
    eus: 'Fakultate',
    pt: 'Faculdade'
  },
  [EStreetType.DISMANTLED_RAILWAY]: {
    es: 'Ferrocarril Desmantelado',
    en: 'Dismantled Railway',
    cat: 'Ferrocarril Desmantellat',
    eus: 'Trenbide Eraitsi',
    pt: 'Ferrovia Desativada'
  },
  [EStreetType.ESTATE]: {
    es: 'Finca',
    en: 'Estate',
    cat: 'Finca',
    eus: 'Finka',
    pt: 'Quinta'
  },
  [EStreetType.FOUNTAIN]: {
    es: 'Fuente',
    en: 'Fountain',
    cat: 'Font',
    eus: 'Iturri',
    pt: 'Fonte'
  },
  [EStreetType.CHARITABLE_TEACHING_FOUNDATION]: {
    es: 'Fundación Benéfico Docente',
    en: 'Charitable Teaching Foundation',
    cat: 'Fundació Benèfico-Docent',
    eus: 'Irakaskuntza Ongintza Fundazioa',
    pt: 'Fundação Beneficente de Ensino'
  },
  [EStreetType.FOUNDATION]: {
    es: 'Fundación',
    en: 'Foundation',
    cat: 'Fundació',
    eus: 'Fundazio',
    pt: 'Fundação'
  },
  [EStreetType.GALLERY]: {
    es: 'Galería',
    en: 'Gallery',
    cat: 'Galeria',
    eus: 'Galeria',
    pt: 'Galeria'
  },
  [EStreetType.ROUNDABOUT]: {
    es: 'Glorieta',
    en: 'Roundabout',
    cat: 'Glorieta',
    eus: 'Biribilgune',
    pt: 'Rotunda'
  },
  [EStreetType.MAIN_AVENUE]: {
    es: 'Gran Vía',
    en: 'Main Street',
    cat: 'Gran Via',
    eus: 'Kale Nagusi',
    pt: 'Gran Via'
  },
  [EStreetType.GROUP]: {
    es: 'Grupo',
    en: 'Group',
    cat: 'Grup',
    eus: 'Talde',
    pt: 'Grupo'
  },
  [EStreetType.HIPPODROME]: {
    es: 'Hipódromo',
    en: 'Hippodrome',
    cat: 'Hipòdrom',
    eus: 'Hipodromo',
    pt: 'Hipódromo'
  },
  [EStreetType.HOSPITAL]: {
    es: 'Hospital',
    en: 'Hospital',
    cat: 'Hospital',
    eus: 'Ospitale',
    pt: 'Hospital'
  },
  [EStreetType.HOTEL]: {
    es: 'Hotel',
    en: 'Hotel',
    cat: 'Hotel',
    eus: 'Hotel',
    pt: 'Hotel'
  },
  [EStreetType.VOCATIONAL_TRAINING_INSTITUTE]: {
    es: 'Instituto Formación Profesional',
    en: 'Vocational Training Institute',
    cat: 'Institut Formació Professional',
    eus: 'Lanbide Heziketako Institutua',
    pt: 'Instituto de Formação Profissional'
  },
  [EStreetType.CHURCH]: {
    es: 'Iglesia',
    en: 'Church',
    cat: 'Església',
    eus: 'Eliza',
    pt: 'Igreja'
  },
  [EStreetType.POLYTECHNIC_INSTITUTE]: {
    es: 'Instituto Politécnico',
    en: 'Polytechnic Institute',
    cat: 'Institut Politècnic',
    eus: 'Institutu Politekniko',
    pt: 'Instituto Politécnico'
  },
  [EStreetType.INSTITUTE]: {
    es: 'Instituto',
    en: 'Institute',
    cat: 'Institut',
    eus: 'Institutu',
    pt: 'Instituto'
  },
  [EStreetType.GARDEN]: {
    es: 'Jardín',
    en: 'Garden',
    cat: 'Jardí',
    eus: 'Lorategi',
    pt: 'Jardim'
  },
  [EStreetType.LYCEUM]: {
    es: 'Liceo',
    en: 'Lyceum',
    cat: 'Liceu',
    eus: 'Lizeo',
    pt: 'Liceu'
  },
  [EStreetType.PLACE]: {
    es: 'Lugar',
    en: 'Place',
    cat: 'Lloc',
    eus: 'Leku',
    pt: 'Lugar'
  },
  [EStreetType.CITY_BLOCK]: {
    es: 'Manzana',
    en: 'City Block',
    cat: 'Illa',
    eus: 'Etxadi',
    pt: 'Quarteirão'
  },
  [EStreetType.SLAUGHTERHOUSE]: {
    es: 'Matadero',
    en: 'Slaughterhouse',
    cat: 'Escorxador',
    eus: 'Hiltegi',
    pt: 'Matadouro'
  },
  [EStreetType.MARKET]: {
    es: 'Mercado',
    en: 'Market',
    cat: 'Mercat',
    eus: 'Merkatu',
    pt: 'Mercado'
  },
  [EStreetType.MINISTRY]: {
    es: 'Ministerio',
    en: 'Ministry',
    cat: 'Ministeri',
    eus: 'Ministerio',
    pt: 'Ministério'
  },
  [EStreetType.MOUNT]: {
    es: 'Monte',
    en: 'Mount',
    cat: 'Mont',
    eus: 'Mendi',
    pt: 'Monte'
  },
  [EStreetType.NUCLEUS]: {
    es: 'Núcleo',
    en: 'Nucleus',
    cat: 'Nucli',
    eus: 'Gune',
    pt: 'Núcleo'
  },
  [EStreetType.PAVILION]: {
    es: 'Pabellón',
    en: 'Pavilion',
    cat: 'Pavelló',
    eus: 'Pabiloi',
    pt: 'Pavilhão'
  },
  [EStreetType.PALACE]: {
    es: 'Palacio',
    en: 'Palace',
    cat: 'Palau',
    eus: 'Jauregi',
    pt: 'Palácio'
  },
  [EStreetType.SITE]: {
    es: 'Paraje',
    en: 'Place',
    cat: 'Paratge',
    eus: 'Paraje',
    pt: 'Paragem'
  },
  [EStreetType.PLOT]: {
    es: 'Parcela',
    en: 'Plot',
    cat: 'Parcel·la',
    eus: 'Lursail',
    pt: 'Parcela'
  },
  [EStreetType.PARK]: {
    es: 'Parque',
    en: 'Park',
    cat: 'Parc',
    eus: 'Parke',
    pt: 'Parque'
  },
  [EStreetType.PRIVATE_STREET]: {
    es: 'Particular',
    en: 'Private',
    cat: 'Particular',
    eus: 'Pribatu',
    pt: 'Particular'
  },
  [EStreetType.PASSAGEWAY]: {
    es: 'Pasadizo',
    en: 'Passageway',
    cat: 'Passadís',
    eus: 'Pasabide',
    pt: 'Passagem'
  },
  [EStreetType.PASSAGE]: {
    es: 'Pasaje',
    en: 'Passage',
    cat: 'Passatge',
    eus: 'Pasabide',
    pt: 'Passagem'
  },
  [EStreetType.WALKWAY]: {
    es: 'Paseo',
    en: 'Promenade',
    cat: 'Passeig',
    eus: 'Pasealeku',
    pt: 'Passeio'
  },
  [EStreetType.OVERPASS]: {
    es: 'Paso Elevado',
    en: 'Overpass',
    cat: 'Pas Elevat',
    eus: 'Gaineko Pasabide',
    pt: 'Viaduto'
  },
  [EStreetType.COURTYARD]: {
    es: 'Patio',
    en: 'Courtyard',
    cat: 'Pati',
    eus: 'Patio',
    pt: 'Pátio'
  },
  [EStreetType.TRUST]: {
    es: 'Patronato',
    en: 'Trust',
    cat: 'Patronat',
    eus: 'Patronatu',
    pt: 'Patronato'
  },
  [EStreetType.TRACK]: {
    es: 'Pista',
    en: 'Track',
    cat: 'Pista',
    eus: 'Pista',
    pt: 'Pista'
  },
  [EStreetType.SQUARE]: {
    es: 'Plaza',
    en: 'Square',
    cat: 'Plaça',
    eus: 'Plaza',
    pt: 'Praça'
  },
  [EStreetType.SMALL_SQUARE]: {
    es: 'Plazuela',
    en: 'Small square',
    cat: 'Placeta',
    eus: 'Plazatxo',
    pt: 'Praceta'
  },
  [EStreetType.SETTLEMENT]: {
    es: 'Poblado',
    en: 'Settlement',
    cat: 'Poblat',
    eus: 'Herri',
    pt: 'Povoado'
  },
  [EStreetType.SPORTS_CENTER]: {
    es: 'Polideportivo',
    en: 'Sports Center',
    cat: 'Poliesportiu',
    eus: 'Kiroldegi',
    pt: 'Polidesportivo'
  },
  [EStreetType.INDUSTRIAL_ESTATE]: {
    es: 'Polígono',
    en: 'Industrial Estate',
    cat: 'Polígon',
    eus: 'Poligono',
    pt: 'Polígono'
  },
  [EStreetType.EXTENSION]: {
    es: 'Prolongación',
    en: 'Extension',
    cat: 'Prolongació',
    eus: 'Luzapen',
    pt: 'Prolongamento'
  },
  [EStreetType.TOWN]: {
    es: 'Pueblo',
    en: 'Town',
    cat: 'Poble',
    eus: 'Herri',
    pt: 'Povo'
  },
  [EStreetType.BRIDGE]: {
    es: 'Puente',
    en: 'Bridge',
    cat: 'Pont',
    eus: 'Zubi',
    pt: 'Ponte'
  },
  [EStreetType.GATE]: {
    es: 'Puerta',
    en: 'Gate',
    cat: 'Porta',
    eus: 'Ate',
    pt: 'Porta'
  },
  [EStreetType.PORT]: {
    es: 'Puerto',
    en: 'Port',
    cat: 'Port',
    eus: 'Portu',
    pt: 'Porto'
  },
  [EStreetType.RAMBLA]: {
    es: 'Rambla',
    en: 'Boulevard',
    cat: 'Rambla',
    eus: 'Rambla',
    pt: 'Rambla'
  },
  [EStreetType.RAMP]: {
    es: 'Rampa',
    en: 'Ramp',
    cat: 'Rampa',
    eus: 'Arrapala',
    pt: 'Rampa'
  },
  [EStreetType.RESIDENTIAL]: {
    es: 'Residencial',
    en: 'Residential',
    cat: 'Residencial',
    eus: 'Egoitza-gune',
    pt: 'Residencial'
  },
  [EStreetType.NOOK]: {
    es: 'Rincón',
    en: 'Corner',
    cat: 'Racó',
    eus: 'Txoko',
    pt: 'Canto'
  },
  [EStreetType.CORNER_AREA]: {
    es: 'Rinconada',
    en: 'Corner',
    cat: 'Raconada',
    eus: 'Txoko',
    pt: 'Recanto'
  },
  [EStreetType.RIVER]: {
    es: 'Río',
    en: 'River',
    cat: 'Riu',
    eus: 'Ibai',
    pt: 'Rio'
  },
  [EStreetType.RING_ROAD]: {
    es: 'Ronda',
    en: 'Ring road',
    cat: 'Ronda',
    eus: 'Erronda',
    pt: 'Circular'
  },
  [EStreetType.TRAFFIC_CIRCLE]: {
    es: 'Rotonda',
    en: 'Roundabout',
    cat: 'Rotonda',
    eus: 'Biribilgune',
    pt: 'Rotunda'
  },
  [EStreetType.SACRAMENTAL]: {
    es: 'Sacramental',
    en: 'Sacramental',
    cat: 'Sacramental',
    eus: 'Sakramental',
    pt: 'Sacramental'
  },
  [EStreetType.EXIT]: {
    es: 'Salida',
    en: 'Exit',
    cat: 'Sortida',
    eus: 'Irteera',
    pt: 'Saída'
  },
  [EStreetType.SECTOR]: {
    es: 'Sector',
    en: 'Sector',
    cat: 'Sector',
    eus: 'Sektore',
    pt: 'Setor'
  },
  [EStreetType.TRAIL]: {
    es: 'Senda',
    en: 'Path',
    cat: 'Senda',
    eus: 'Bidezidor',
    pt: 'Senda'
  },
  [EStreetType.HEALTH_SERVICE]: {
    es: 'Servicio de Salud',
    en: 'Health Service',
    cat: 'Servei de Salut',
    eus: 'Osasun Zerbitzu',
    pt: 'Serviço de Saúde'
  },
  [EStreetType.LOCATION]: {
    es: 'Sitio',
    en: 'Site',
    cat: 'Siti',
    eus: 'Leku',
    pt: 'Sítio'
  },
  [EStreetType.SUBSTATION]: {
    es: 'Subestación',
    en: 'Substation',
    cat: 'Subestació',
    eus: 'Azpiestazio',
    pt: 'Subestação'
  },
  [EStreetType.ASCENT]: {
    es: 'Subida',
    en: 'Ascent',
    cat: 'Pujada',
    eus: 'Igoera',
    pt: 'Subida'
  },
  [EStreetType.FUNERAL_HOME]: {
    es: 'Tanatorio',
    en: 'Funeral Home',
    cat: 'Tanatori',
    eus: 'Beilatoki',
    pt: 'Tanatório'
  },
  [EStreetType.CROSS_STREET]: {
    es: 'Transversal',
    en: 'Cross street',
    cat: 'Transversal',
    eus: 'Zeharkale',
    pt: 'Transversal'
  },
  [EStreetType.REAR]: {
    es: 'Trasera',
    en: 'Rear',
    cat: 'Rere',
    eus: 'Atzealde',
    pt: 'Traseira'
  },
  [EStreetType.CROSSING]: {
    es: 'Travesía',
    en: 'Crossing',
    cat: 'Travessia',
    eus: 'Zeharkale',
    pt: 'Travessa'
  },
  [EStreetType.HOUSING_ESTATE]: {
    es: 'Urbanización',
    en: 'Housing Estate',
    cat: 'Urbanització',
    eus: 'Urbanizazio',
    pt: 'Urbanização'
  },
  [EStreetType.NEIGHBORHOOD_UNIT]: {
    es: 'UVA (Unidad Vecinal)',
    en: 'UVA (Neighborhood Unit)',
    cat: 'UVA (Unitat Veïnal)',
    eus: 'Auzo Unitatea',
    pt: 'UVA (Unidade Vicinal)'
  },
  [EStreetType.SIDEWALK]: {
    es: 'Vereda',
    en: 'Path',
    cat: 'Vereda',
    eus: 'Bidezidor',
    pt: 'Vereda'
  },
  [EStreetType.THOROUGHFARE]: {
    es: 'Vía',
    en: 'Way',
    cat: 'Via',
    eus: 'Bide',
    pt: 'Via'
  },
  [EStreetType.TRACKS]: {
    es: 'Vías',
    en: 'Tracks',
    cat: 'Vies',
    eus: 'Bideak',
    pt: 'Vias'
  },
  [EStreetType.ZONE]: {
    es: 'Zona',
    en: 'Zone',
    cat: 'Zona',
    eus: 'Eremu',
    pt: 'Zona'
  },
  [EStreetType.ZOO]: {
    es: 'Zoológico',
    en: 'Zoo',
    cat: 'Zoològic',
    eus: 'Zoologiko',
    pt: 'Zoológico'
  },
  [ENationality.AFGHAN]: {
    es: 'Afgana',
    en: 'Afghan',
    cat: 'Afganesa',
    eus: 'Afgandarra',
    pt: 'Afegã'
  },
  [ENationality.ALBANIAN]: {
    es: 'Albanesa',
    en: 'Albanian',
    cat: 'Albanesa',
    eus: 'Albaniarra',
    pt: 'Albanesa'
  },
  [ENationality.GERMAN]: {
    es: 'Alemana',
    en: 'German',
    cat: 'Alemanya',
    eus: 'Alemaniarra',
    pt: 'Alemã'
  },
  [ENationality.ANDORRAN]: {
    es: 'Andorrana',
    en: 'Andorran',
    cat: 'Andorrana',
    eus: 'Andorrarra',
    pt: 'Andorrana'
  },
  [ENationality.ANGOLAN]: {
    es: 'Angoleña',
    en: 'Angolan',
    cat: 'Angolesa',
    eus: 'Angolarra',
    pt: 'Angolana'
  },
  [ENationality.ANTIGUAN]: {
    es: 'Antiguana',
    en: 'Antiguan',
    cat: 'Antiguana',
    eus: 'Antiguarra',
    pt: 'Antiguana'
  },
  [ENationality.ALGERIAN]: {
    es: 'Argelina',
    en: 'Algerian',
    cat: 'Algeriana',
    eus: 'Aljeriarra',
    pt: 'Argelina'
  },
  [ENationality.ARGENTINIAN]: {
    es: 'Argentina',
    en: 'Argentinian',
    cat: 'Argentina',
    eus: 'Argentinarra',
    pt: 'Argentina'
  },
  [ENationality.ARMENIAN]: {
    es: 'Armenia',
    en: 'Armenian',
    cat: 'Armènia',
    eus: 'Armeniarra',
    pt: 'Armênia'
  },
  [ENationality.ARUBAN]: {
    es: 'Arubeña',
    en: 'Aruban',
    cat: 'Arubana',
    eus: 'Arubarra',
    pt: 'Arubana'
  },
  [ENationality.AUSTRALIAN]: {
    es: 'Australiana',
    en: 'Australian',
    cat: 'Australiana',
    eus: 'Australiarra',
    pt: 'Australiana'
  },
  [ENationality.AUSTRIAN]: {
    es: 'Austriaca',
    en: 'Austrian',
    cat: 'Austríaca',
    eus: 'Austriarra',
    pt: 'Austríaca'
  },
  [ENationality.AZERBAIJANI]: {
    es: 'Azerbaiyana',
    en: 'Azerbaijani',
    cat: 'Azerbaidjanesa',
    eus: 'Azerbaijandarra',
    pt: 'Azerbaijana'
  },
  [ENationality.BAHAMIAN]: {
    es: 'Bahameña',
    en: 'Bahamian',
    cat: 'Bahamiana',
    eus: 'Bahamarra',
    pt: 'Bahamense'
  },
  [ENationality.BAHRAINI]: {
    es: 'Bahreiní',
    en: 'Bahraini',
    cat: 'Bahrainiana',
    eus: 'Bahraindarra',
    pt: 'Bareinita'
  },
  [ENationality.BANGLADESHI]: {
    es: 'Bangladesí',
    en: 'Bangladeshi',
    cat: 'Bangla Desiana',
    eus: 'Bangladeshtarra',
    pt: 'Bangladechiana'
  },
  [ENationality.BARBADIAN]: {
    es: 'Barbadense',
    en: 'Barbadian',
    cat: 'Barbadiana',
    eus: 'Barbadostarra',
    pt: 'Barbadiana'
  },
  [ENationality.BELGIAN]: {
    es: 'Belga',
    en: 'Belgian',
    cat: 'Belga',
    eus: 'Belgikarra',
    pt: 'Belga'
  },
  [ENationality.BELIZEAN]: {
    es: 'Beliceña',
    en: 'Belizean',
    cat: 'Belizeana',
    eus: 'Belizetarra',
    pt: 'Belizenha'
  },
  [ENationality.BENINESE]: {
    es: 'Beninesa',
    en: 'Beninese',
    cat: 'Beninesa',
    eus: 'Benindarra',
    pt: 'Beninense'
  },
  [ENationality.BELARUSIAN]: {
    es: 'Bielorrusa',
    en: 'Belarusian',
    cat: 'Bielorussa',
    eus: 'Bielorrusiarra',
    pt: 'Bielorrussa'
  },
  [ENationality.BURMESE]: {
    es: 'Birmana',
    en: 'Burmese',
    cat: 'Birmana',
    eus: 'Birmaniarra',
    pt: 'Birmanesa'
  },
  [ENationality.BOLIVIAN]: {
    es: 'Boliviana',
    en: 'Bolivian',
    cat: 'Boliviana',
    eus: 'Boliviarra',
    pt: 'Boliviana'
  },
  [ENationality.BOSNIAN_HERZEGOVINIAN]: {
    es: 'Bosnioherzegovina',
    en: 'Bosnian-Herzegovinian',
    cat: 'Bosniana',
    eus: 'Bosniarra',
    pt: 'Bósnia-Herzegovina'
  },
  [ENationality.BOTSWANAN]: {
    es: 'Botsuana',
    en: 'Botswanan',
    cat: 'Botswanesa',
    eus: 'Botswanarra',
    pt: 'Botsuana'
  },
  [ENationality.BRAZILIAN]: {
    es: 'Brasileña',
    en: 'Brazilian',
    cat: 'Brasilera',
    eus: 'Brasildarra',
    pt: 'Brasileira'
  },
  [ENationality.BRITISH]: {
    es: 'Británica',
    en: 'British',
    cat: 'Britànica',
    eus: 'Britainiarra',
    pt: 'Britânica'
  },
  [ENationality.BRUNEIAN]: {
    es: 'Bruneana',
    en: 'Bruneian',
    cat: 'Bruneiana',
    eus: 'Bruneiarra',
    pt: 'Bruneana'
  },
  [ENationality.BULGARIAN]: {
    es: 'Búlgara',
    en: 'Bulgarian',
    cat: 'Búlgara',
    eus: 'Bulgariarra',
    pt: 'Búlgara'
  },
  [ENationality.BURKINABE]: {
    es: 'Burkinabesa',
    en: 'Burkinabe',
    cat: 'Burkinesa',
    eus: 'Burkinafasoarra',
    pt: 'Burquinense'
  },
  [ENationality.BURUNDIAN]: {
    es: 'Burundesa',
    en: 'Burundian',
    cat: 'Burundesa',
    eus: 'Burundiarra',
    pt: 'Burundiana'
  },
  [ENationality.BHUTANESE]: {
    es: 'Butanesa',
    en: 'Bhutanese',
    cat: 'Butanesa',
    eus: 'Bhutandarra',
    pt: 'Butanesa'
  },
  [ENationality.CAPE_VERDEAN]: {
    es: 'Caboverdiana',
    en: 'Cape Verdean',
    cat: 'Capverdiana',
    eus: 'Cabo-verdetarra',
    pt: 'Cabo-verdiana'
  },
  [ENationality.CAMBODIAN]: {
    es: 'Camboyana',
    en: 'Cambodian',
    cat: 'Cambodjana',
    eus: 'Kanbodiarra',
    pt: 'Cambojana'
  },
  [ENationality.CAMEROONIAN]: {
    es: 'Camerunesa',
    en: 'Cameroonian',
    cat: 'Camerunesa',
    eus: 'Kamerundarra',
    pt: 'Camaronesa'
  },
  [ENationality.CANADIAN]: {
    es: 'Canadiense',
    en: 'Canadian',
    cat: 'Canadenca',
    eus: 'Kanadarra',
    pt: 'Canadense'
  },
  [ENationality.CENTRAL_AFRICAN]: {
    es: 'Centroafricana',
    en: 'Central African',
    cat: 'Centrafricana',
    eus: 'Afrikaerditarra',
    pt: 'Centro-africana'
  },
  [ENationality.CHADIAN]: {
    es: 'Chadiana',
    en: 'Chadian',
    cat: 'Txadiana',
    eus: 'Txadarra',
    pt: 'Chadiana'
  },
  [ENationality.CZECH]: {
    es: 'Checa',
    en: 'Czech',
    cat: 'Txeca',
    eus: 'Txekiarra',
    pt: 'Tcheca'
  },
  [ENationality.CHILEAN]: {
    es: 'Chilena',
    en: 'Chilean',
    cat: 'Xilena',
    eus: 'Txiletarra',
    pt: 'Chilena'
  },
  [ENationality.CHINESE]: {
    es: 'China',
    en: 'Chinese',
    cat: 'Xinesa',
    eus: 'Txinatarra',
    pt: 'Chinesa'
  },
  [ENationality.CYPRIOT]: {
    es: 'Chipriota',
    en: 'Cypriot',
    cat: 'Xipriota',
    eus: 'Zipretarra',
    pt: 'Cipriota'
  },
  [ENationality.COLOMBIAN]: {
    es: 'Colombiana',
    en: 'Colombian',
    cat: 'Colombiana',
    eus: 'Kolonbiarra',
    pt: 'Colombiana'
  },
  [ENationality.COMORAN]: {
    es: 'Comorense',
    en: 'Comoran',
    cat: 'Comoriana',
    eus: 'Komorearra',
    pt: 'Comorense'
  },
  [ENationality.CONGOLESE_CONGO]: {
    es: 'Congoleña (Congo)',
    en: 'Congolese (Congo)',
    cat: 'Congolesa (Congo)',
    eus: 'Kongotarra (Kongo)',
    pt: 'Congolesa (Congo)'
  },
  [ENationality.CONGOLESE_DRCONGO]: {
    es: 'Congoleña (RD Congo)',
    en: 'Congolese (DR Congo)',
    cat: 'Congolesa (RD Congo)',
    eus: 'Kongotarra (Kongoko ED)',
    pt: 'Congolesa (RD Congo)'
  },
  [ENationality.COSTA_RICAN]: {
    es: 'Costarricense',
    en: 'Costa Rican',
    cat: 'Costa-riquenya',
    eus: 'Costa-ricarra',
    pt: 'Costarriquenha'
  },
  [ENationality.CROATIAN]: {
    es: 'Croata',
    en: 'Croatian',
    cat: 'Croata',
    eus: 'Kroaziarra',
    pt: 'Croata'
  },
  [ENationality.CUBAN]: {
    es: 'Cubana',
    en: 'Cuban',
    cat: 'Cubana',
    eus: 'Kubatarra',
    pt: 'Cubana'
  },
  [ENationality.CURACAOAN]: {
    es: 'Curazoleña',
    en: 'Curacaoan',
    cat: 'Curaçaolenya',
    eus: 'Curaçaotarra',
    pt: 'Curauense'
  },
  [ENationality.DANISH]: {
    es: 'Danesa',
    en: 'Danish',
    cat: 'Danesa',
    eus: 'Daniarra',
    pt: 'Dinamarquesa'
  },
  [ENationality.COOK_ISLANDS]: {
    es: 'Islas Cook',
    en: 'Cook Islands',
    cat: 'Illes Cook',
    eus: 'Cook Uharteak',
    pt: 'Ilhas Cook'
  },
  [ENationality.NORFOLK_ISLANDS]: {
    es: 'Islas Norfolk',
    en: 'Norfolk Islands',
    cat: 'Illes Norfolk',
    eus: 'Norfolk Uhartea',
    pt: 'Ilha Norfolk'
  },
  [ENationality.TOKELAUAN]: {
    es: 'Tokelau',
    en: 'Tokelauan',
    cat: 'Tokelau',
    eus: 'Tokelau',
    pt: 'Tokelau'
  },
  [ENationality.UNKNOWN_NATIONALITY]: {
    es: 'Desconocido',
    en: 'Unknown',
    cat: 'Desconegut',
    eus: 'Ezezaguna',
    pt: 'Desconhecido'
  },
  [ENationality.DOMINICAN]: {
    es: 'Dominicana',
    en: 'Dominican',
    cat: 'Dominicana',
    eus: 'Dominikarra',
    pt: 'Dominicana'
  },
  [ENationality.DOMINICAN_COMMONWEALTH]: {
    es: 'Dominiquesa',
    en: 'Dominican (Commonwealth)',
    cat: 'Dominiquesa',
    eus: 'Dominikarra (Commonwealth)',
    pt: 'Dominiquesa'
  },
  [ENationality.EQUATORIAL_GUINEAN]: {
    es: 'Ecuatoguineana',
    en: 'Equatorial Guinean',
    cat: 'Equatoguineana',
    eus: 'Ekuatoreginearra',
    pt: 'Equato-guineense'
  },
  [ENationality.ECUADORIAN]: {
    es: 'Ecuatoriana',
    en: 'Ecuadorian',
    cat: 'Equatoriana',
    eus: 'Ekuadortarra',
    pt: 'Equatoriana'
  },
  [ENationality.EGYPTIAN]: {
    es: 'Egipcia',
    en: 'Egyptian',
    cat: 'Egípcia',
    eus: 'Egiptoarra',
    pt: 'Egípcia'
  },
  [ENationality.EMIRATI]: {
    es: 'Emiratense',
    en: 'Emirati',
    cat: 'Emiriana',
    eus: 'Emirerritarra',
    pt: 'Emirati'
  },
  [ENationality.ERITREAN]: {
    es: 'Eritrea',
    en: 'Eritrean',
    cat: 'Eritrea',
    eus: 'Eritrearra',
    pt: 'Eritreia'
  },
  [ENationality.SLOVAK]: {
    es: 'Eslovaca',
    en: 'Slovak',
    cat: 'Eslovaca',
    eus: 'Eslovakiarra',
    pt: 'Eslovaca'
  },
  [ENationality.SLOVENIAN]: {
    es: 'Eslovena',
    en: 'Slovenian',
    cat: 'Eslovena',
    eus: 'Esloveniarra',
    pt: 'Eslovena'
  },
  [ENationality.SPANISH_NATIONALITY]: {
    es: 'Española',
    en: 'Spanish',
    cat: 'Espanyola',
    eus: 'Espainiarra',
    pt: 'Espanhola'
  },
  [ENationality.SRI_LANKAN]: {
    es: 'Esrilanquesa',
    en: 'Sri Lankan',
    cat: 'Sri Lankesa',
    eus: 'Sri Lankarra',
    pt: 'Sri Lanka'
  },
  [ENationality.AMERICAN]: {
    es: 'Estadounidense',
    en: 'American',
    cat: 'Estatunidenca',
    eus: 'Estatubatuarra',
    pt: 'Americana'
  },
  [ENationality.ESTONIAN]: {
    es: 'Estonia',
    en: 'Estonian',
    cat: 'Estoniana',
    eus: 'Estoniarra',
    pt: 'Estoniana'
  },
  [ENationality.ETHIOPIAN]: {
    es: 'Etíope',
    en: 'Ethiopian',
    cat: 'Etíop',
    eus: 'Etiopiarra',
    pt: 'Etíope'
  },
  [ENationality.FILIPINO]: {
    es: 'Filipina',
    en: 'Filipino',
    cat: 'Filipina',
    eus: 'Filipinarra',
    pt: 'Filipina'
  },
  [ENationality.FINNISH]: {
    es: 'Finlandesa',
    en: 'Finnish',
    cat: 'Finlandesa',
    eus: 'Finlandiarra',
    pt: 'Finlandesa'
  },
  [ENationality.FIJIAN]: {
    es: 'Fiyiana',
    en: 'Fijian',
    cat: 'Fidjiana',
    eus: 'Fijiarra',
    pt: 'Fijiana'
  },
  [ENationality.FRENCH]: {
    es: 'Francesa',
    en: 'French',
    cat: 'Francesa',
    eus: 'Frantziarra',
    pt: 'Francesa'
  },
  [ENationality.GABONESE]: {
    es: 'Gabonesa',
    en: 'Gabonese',
    cat: 'Gabonesa',
    eus: 'Gabondarra',
    pt: 'Gabonesa'
  },
  [ENationality.GAMBIAN]: {
    es: 'Gambiana',
    en: 'Gambian',
    cat: 'Gambiana',
    eus: 'Gambiarra',
    pt: 'Gambiana'
  },
  [ENationality.GEORGIAN]: {
    es: 'Georgiana',
    en: 'Georgian',
    cat: 'Georgiana',
    eus: 'Georgiarra',
    pt: 'Georgiana'
  },
  [ENationality.GHANAIAN]: {
    es: 'Ghanesa',
    en: 'Ghanaian',
    cat: 'Ghanesa',
    eus: 'Ghanatarra',
    pt: 'Ganesa'
  },
  [ENationality.GRENADIAN]: {
    es: 'Granadina',
    en: 'Grenadian',
    cat: 'Granadina',
    eus: 'Grenadarra',
    pt: 'Granadina'
  },
  [ENationality.GREEK]: {
    es: 'Griega',
    en: 'Greek',
    cat: 'Grega',
    eus: 'Greziarra',
    pt: 'Grega'
  },
  [ENationality.GUAMANIAN]: {
    es: 'Guamesa',
    en: 'Guamanian',
    cat: 'Guamesa',
    eus: 'Guamdarrra',
    pt: 'Guamesa'
  },
  [ENationality.GUATEMALAN]: {
    es: 'Guatemalteca',
    en: 'Guatemalan',
    cat: 'Guatemalenca',
    eus: 'Guatemalarra',
    pt: 'Guatemalteca'
  },
  [ENationality.BISSAU_GUINEAN]: {
    es: 'Guineana (Bissau)',
    en: 'Bissau-Guinean',
    cat: 'Guineana (Bissau)',
    eus: 'Ginearra (Bissau)',
    pt: 'Guineense (Bissau)'
  },
  [ENationality.GUINEAN]: {
    es: 'Guineana',
    en: 'Guinean',
    cat: 'Guineana',
    eus: 'Ginearra',
    pt: 'Guineense'
  },
  [ENationality.GUYANESE]: {
    es: 'Guyanesa',
    en: 'Guyanese',
    cat: 'Guaianesa',
    eus: 'Guyanarra',
    pt: 'Guianesa'
  },
  [ENationality.HAITIAN]: {
    es: 'Haitiana',
    en: 'Haitian',
    cat: 'Haitiana',
    eus: 'Haitiarra',
    pt: 'Haitiana'
  },
  [ENationality.HONDURAN]: {
    es: 'Hondureña',
    en: 'Honduran',
    cat: 'Hondurenya',
    eus: 'Hondurastarra',
    pt: 'Hondurenha'
  },
  [ENationality.HUNGARIAN]: {
    es: 'Húngara',
    en: 'Hungarian',
    cat: 'Hongaresa',
    eus: 'Hungariarra',
    pt: 'Húngara'
  },
  [ENationality.INDIAN]: {
    es: 'India',
    en: 'Indian',
    cat: 'Índia',
    eus: 'Indiarra',
    pt: 'Indiana'
  },
  [ENationality.INDONESIAN]: {
    es: 'Indonesia',
    en: 'Indonesian',
    cat: 'Indonèsia',
    eus: 'Indonesiarra',
    pt: 'Indonésia'
  },
  [ENationality.IRANIAN]: {
    es: 'Iraní',
    en: 'Iranian',
    cat: 'Iraniana',
    eus: 'Irandarra',
    pt: 'Iraniana'
  },
  [ENationality.IRAQI]: {
    es: 'Iraqí',
    en: 'Iraqi',
    cat: 'Iraqiana',
    eus: 'Irakarra',
    pt: 'Iraquiana'
  },
  [ENationality.IRISH]: {
    es: 'Irlandesa',
    en: 'Irish',
    cat: 'Irlandesa',
    eus: 'Irlandarra',
    pt: 'Irlandesa'
  },
  [ENationality.ICELANDIC]: {
    es: 'Islandesa',
    en: 'Icelandic',
    cat: 'Islandesa',
    eus: 'Islandiarra',
    pt: 'Islandesa'
  },
  [ENationality.ISRAELI]: {
    es: 'Israelí',
    en: 'Israeli',
    cat: 'Israeliana',
    eus: 'Israeldarra',
    pt: 'Israelense'
  },
  [ENationality.ITALIAN]: {
    es: 'Italiana',
    en: 'Italian',
    cat: 'Italiana',
    eus: 'Italiarra',
    pt: 'Italiana'
  },
  [ENationality.JAMAICAN]: {
    es: 'Jamaicana',
    en: 'Jamaican',
    cat: 'Jamaicana',
    eus: 'Jamaikarra',
    pt: 'Jamaicana'
  },
  [ENationality.JAPANESE]: {
    es: 'Japonesa',
    en: 'Japanese',
    cat: 'Japonesa',
    eus: 'Japoniarra',
    pt: 'Japonesa'
  },
  [ENationality.JORDANIAN]: {
    es: 'Jordana',
    en: 'Jordanian',
    cat: 'Jordana',
    eus: 'Jordaniarra',
    pt: 'Jordaniana'
  },
  [ENationality.KAZAKH]: {
    es: 'Kazaja',
    en: 'Kazakh',
    cat: 'Kazakh',
    eus: 'Kazakhstandarra',
    pt: 'Cazaque'
  },
  [ENationality.KENYAN]: {
    es: 'Keniata',
    en: 'Kenyan',
    cat: 'Keniana',
    eus: 'Kenyarra',
    pt: 'Queniana'
  },
  [ENationality.KYRGYZ]: {
    es: 'Kirguís',
    en: 'Kyrgyz',
    cat: 'Kirguís',
    eus: 'Kirgizistandarra',
    pt: 'Quirguiz'
  },
  [ENationality.KIRIBATIAN]: {
    es: 'Kiribatiana',
    en: 'Kiribatian',
    cat: 'Kiribatiana',
    eus: 'Kiribatiarra',
    pt: 'Kiribatiana'
  },
  [ENationality.KUWAITI]: {
    es: 'Kuwaití',
    en: 'Kuwaiti',
    cat: 'Kuwaitiana',
    eus: 'Kuwaittarra',
    pt: 'Kuwaitiana'
  },
  [ENationality.LAOTIAN]: {
    es: 'Laosiana',
    en: 'Laotian',
    cat: 'Laosiana',
    eus: 'Laostarra',
    pt: 'Laosiana'
  },
  [ENationality.LESOTHOAN]: {
    es: 'Lesotense',
    en: 'Lesothoan',
    cat: 'Lesothiana',
    eus: 'Lesothoarra',
    pt: 'Lesotense'
  },
  [ENationality.LATVIAN]: {
    es: 'Letona',
    en: 'Latvian',
    cat: 'Letona',
    eus: 'Letoniarra',
    pt: 'Letã'
  },
  [ENationality.LEBANESE]: {
    es: 'Libanesa',
    en: 'Lebanese',
    cat: 'Libanesa',
    eus: 'Libanoarra',
    pt: 'Libanesa'
  },
  [ENationality.LIBERIAN]: {
    es: 'Liberiana',
    en: 'Liberian',
    cat: 'Liberiana',
    eus: 'Liberiarra',
    pt: 'Liberiana'
  },
  [ENationality.LIBYAN]: {
    es: 'Libia',
    en: 'Libyan',
    cat: 'Líbia',
    eus: 'Libiarra',
    pt: 'Líbia'
  },
  [ENationality.LIECHTENSTEINER]: {
    es: 'Liechtensteiniana',
    en: 'Liechtensteiner',
    cat: 'Liechtensteiniana',
    eus: 'Liechtensteindarra',
    pt: 'Liechtensteinense'
  },
  [ENationality.LITHUANIAN]: {
    es: 'Lituana',
    en: 'Lithuanian',
    cat: 'Lituana',
    eus: 'Lituaniarra',
    pt: 'Lituana'
  },
  [ENationality.LUXEMBOURGER]: {
    es: 'Luxemburguesa',
    en: 'Luxembourger',
    cat: 'Luxemburguesa',
    eus: 'Luxenburgotarra',
    pt: 'Luxemburguesa'
  },
  [ENationality.MACANESE]: {
    es: 'Macaense',
    en: 'Macanese',
    cat: 'Macaista',
    eus: 'Makaotarra',
    pt: 'Macaense'
  },
  [ENationality.MACEDONIAN]: {
    es: 'Macedonia',
    en: 'Macedonian',
    cat: 'Macedònia',
    eus: 'Mazedoniarra',
    pt: 'Macedônia'
  },
  [ENationality.MALAYSIAN]: {
    es: 'Malasia',
    en: 'Malaysian',
    cat: 'Malàisia',
    eus: 'Malaysiarra',
    pt: 'Malaia'
  },
  [ENationality.MALAWIAN]: {
    es: 'Malauí',
    en: 'Malawian',
    cat: 'Malawiana',
    eus: 'Malawiarra',
    pt: 'Malauiana'
  },
  [ENationality.MALDIVIAN]: {
    es: 'Maldiva',
    en: 'Maldivian',
    cat: 'Maldiva',
    eus: 'Maldivarra',
    pt: 'Maldiva'
  },
  [ENationality.MALAGASY]: {
    es: 'Malgache',
    en: 'Malagasy',
    cat: 'Malgatxa',
    eus: 'Madagaskartarra',
    pt: 'Malgaxe'
  },
  [ENationality.MALIAN]: {
    es: 'Malí',
    en: 'Malian',
    cat: 'Maliana',
    eus: 'Maliarra',
    pt: 'Maliana'
  },
  [ENationality.MALTESE]: {
    es: 'Maltesa',
    en: 'Maltese',
    cat: 'Maltesa',
    eus: 'Maltarra',
    pt: 'Maltesa'
  },
  [ENationality.MANX]: {
    es: 'Manesa',
    en: 'Manx',
    cat: 'Manx',
    eus: 'Mandar',
    pt: 'Manesa'
  },
  [ENationality.IVORIAN]: {
    es: 'Marfileña',
    en: 'Ivorian',
    cat: 'Ivorià',
    eus: 'Boli Kostaarra',
    pt: 'Marfinense'
  },
  [ENationality.MOROCCAN]: {
    es: 'Marroquí',
    en: 'Moroccan',
    cat: 'Marroquina',
    eus: 'Marokoarra',
    pt: 'Marroquina'
  },
  [ENationality.MARSHALLESE]: {
    es: 'Marshalesa',
    en: 'Marshallese',
    cat: 'Marshallesa',
    eus: 'Marshall Uharteetakoa',
    pt: 'Marshallina'
  },
  [ENationality.MAURITIAN]: {
    es: 'Mauriciana',
    en: 'Mauritian',
    cat: 'Mauriciana',
    eus: 'Mauriziarra',
    pt: 'Mauriciana'
  },
  [ENationality.MAURITANIAN]: {
    es: 'Mauritana',
    en: 'Mauritanian',
    cat: 'Mauritana',
    eus: 'Mauritaniarra',
    pt: 'Mauritana'
  },
  [ENationality.MEXICAN]: {
    es: 'Mexicana',
    en: 'Mexican',
    cat: 'Mexicana',
    eus: 'Mexikarra',
    pt: 'Mexicana'
  },
  [ENationality.MICRONESIAN]: {
    es: 'Micronesia',
    en: 'Micronesian',
    cat: 'Micronèsia',
    eus: 'Mikronesiarra',
    pt: 'Micronésia'
  },
  [ENationality.MOLDOVAN]: {
    es: 'Moldava',
    en: 'Moldovan',
    cat: 'Moldava',
    eus: 'Moldaviarra',
    pt: 'Moldava'
  },
  [ENationality.MONEGASQUE]: {
    es: 'Monegasca',
    en: 'Monegasque',
    cat: 'Monegasca',
    eus: 'Monegasbarra',
    pt: 'Monegasca'
  },
  [ENationality.MONGOLIAN]: {
    es: 'Mongola',
    en: 'Mongolian',
    cat: 'Mongola',
    eus: 'Mongoliarra',
    pt: 'Mongol'
  },
  [ENationality.MONTENEGRIN]: {
    es: 'Montenegrina',
    en: 'Montenegrin',
    cat: 'Montenegrina',
    eus: 'Montenegroarra',
    pt: 'Montenegrina'
  },
  [ENationality.MOZAMBICAN]: {
    es: 'Mozambiqueña',
    en: 'Mozambican',
    cat: 'Moçambiquesa',
    eus: 'Mozambiketarra',
    pt: 'Moçambicana'
  },
  [ENationality.NAMIBIAN]: {
    es: 'Namibia',
    en: 'Namibian',
    cat: 'Namíbia',
    eus: 'Namibiarra',
    pt: 'Namibiana'
  },
  [ENationality.NAURUAN]: {
    es: 'Nauruana',
    en: 'Nauruan',
    cat: 'Nauruana',
    eus: 'Nauruarra',
    pt: 'Nauruana'
  },
  [ENationality.DUTCH]: {
    es: 'Neerlandesa',
    en: 'Dutch',
    cat: 'Neerlandesa',
    eus: 'Herbeheretarra',
    pt: 'Neerlandesa'
  },
  [ENationality.NEW_ZEALANDER]: {
    es: 'Neozelandesa',
    en: 'New Zealander',
    cat: 'Neozelandesa',
    eus: 'Zeelandaberritarra',
    pt: 'Neozelandesa'
  },
  [ENationality.NEPALESE]: {
    es: 'Nepalí',
    en: 'Nepalese',
    cat: 'Nepalesa',
    eus: 'Nepaldarra',
    pt: 'Nepalesa'
  },
  [ENationality.NICARAGUAN]: {
    es: 'Nicaragüense',
    en: 'Nicaraguan',
    cat: 'Nicaragüenca',
    eus: 'Nikaraguarra',
    pt: 'Nicaraguense'
  },
  [ENationality.NIGERIAN]: {
    es: 'Nigeriana',
    en: 'Nigerian',
    cat: 'Nigeriana',
    eus: 'Nigeriarra',
    pt: 'Nigeriana'
  },
  [ENationality.NIGERIEN]: {
    es: 'Nigerina',
    en: 'Nigerien',
    cat: 'Nigerina',
    eus: 'Nigerra',
    pt: 'Nigerina'
  },
  [ENationality.NIUEAN]: {
    es: 'Niuana',
    en: 'Niuean',
    cat: 'Niuana',
    eus: 'Niuetarra',
    pt: 'Niuana'
  },
  [ENationality.NOT_SPECIFIED_NATIONALITY]: {
    es: 'No Consta',
    en: 'Not Specified',
    cat: 'No Consta',
    eus: 'Ez Dago Jasota',
    pt: 'Não Consta'
  },
  [ENationality.NORTH_KOREAN]: {
    es: 'Norcoreana',
    en: 'North Korean',
    cat: 'Nord-coreana',
    eus: 'Ipar Korearra',
    pt: 'Norte-coreana'
  },
  [ENationality.NORWEGIAN]: {
    es: 'Noruega',
    en: 'Norwegian',
    cat: 'Noruega',
    eus: 'Norvegiarra',
    pt: 'Norueguesa'
  },
  [ENationality.OMANI]: {
    es: 'Omaní',
    en: 'Omani',
    cat: 'Omanita',
    eus: 'Omandarra',
    pt: 'Omanense'
  },
  [ENationality.PAKISTANI]: {
    es: 'Pakistaní',
    en: 'Pakistani',
    cat: 'Pakistanesa',
    eus: 'Pakistandarra',
    pt: 'Paquistanesa'
  },
  [ENationality.PALAUAN]: {
    es: 'Palauana',
    en: 'Palauan',
    cat: 'Palauana',
    eus: 'Palauarra',
    pt: 'Palauana'
  },
  [ENationality.PALESTINIAN]: {
    es: 'Palestina',
    en: 'Palestinian',
    cat: 'Palestina',
    eus: 'Palestinarra',
    pt: 'Palestina'
  },
  [ENationality.PANAMANIAN]: {
    es: 'Panameña',
    en: 'Panamanian',
    cat: 'Panamenya',
    eus: 'Panamarra',
    pt: 'Panamenha'
  },
  [ENationality.PAPUA_NEW_GUINEAN]: {
    es: 'Papú',
    en: 'Papua New Guinean',
    cat: 'Papú',
    eus: 'Papuarra',
    pt: 'Papua'
  },
  [ENationality.PARAGUAYAN]: {
    es: 'Paraguaya',
    en: 'Paraguayan',
    cat: 'Paraguaiana',
    eus: 'Paraguaitarra',
    pt: 'Paraguaia'
  },
  [ENationality.PERUVIAN]: {
    es: 'Peruana',
    en: 'Peruvian',
    cat: 'Peruana',
    eus: 'Perutarra',
    pt: 'Peruana'
  },
  [ENationality.POLISH]: {
    es: 'Polaca',
    en: 'Polish',
    cat: 'Polonesa',
    eus: 'Poloniarra',
    pt: 'Polonesa'
  },
  [ENationality.PORTUGUESE]: {
    es: 'Portuguesa',
    en: 'Portuguese',
    cat: 'Portuguesa',
    eus: 'Portugaldarra',
    pt: 'Portuguesa'
  },
  [ENationality.PUERTO_RICAN]: {
    es: 'Puertorriqueña',
    en: 'Puerto Rican',
    cat: 'Porto-riquenya',
    eus: 'Puerto Ricoarra',
    pt: 'Porto-riquenha'
  },
  [ENationality.QATARI]: {
    es: 'Qatarí',
    en: 'Qatari',
    cat: 'Qatariana',
    eus: 'Qatartarra',
    pt: 'Catariana'
  },
  [ENationality.RWANDAN]: {
    es: 'Ruandesa',
    en: 'Rwandan',
    cat: 'Ruandesa',
    eus: 'Ruandarra',
    pt: 'Ruandesa'
  },
  [ENationality.ROMANIAN]: {
    es: 'Rumana',
    en: 'Romanian',
    cat: 'Romanesa',
    eus: 'Errumaniarra',
    pt: 'Romena'
  },
  [ENationality.RUSSIAN]: {
    es: 'Rusa',
    en: 'Russian',
    cat: 'Russa',
    eus: 'Errusiarra',
    pt: 'Russa'
  },
  [ENationality.SAHRAWI]: {
    es: 'Saharaui',
    en: 'Sahrawi',
    cat: 'Sahrauí',
    eus: 'Saharrarra',
    pt: 'Saariana'
  },
  [ENationality.SOLOMON_ISLANDER]: {
    es: 'Salomonense',
    en: 'Solomon Islander',
    cat: 'Salomonenca',
    eus: 'Salomondarra',
    pt: 'Salomônica'
  },
  [ENationality.SALVADORAN]: {
    es: 'Salvadoreña',
    en: 'Salvadoran',
    cat: 'Salvadorenca',
    eus: 'Elsalvadorarra',
    pt: 'Salvadorenha'
  },
  [ENationality.SAMOAN]: {
    es: 'Samoana',
    en: 'Samoan',
    cat: 'Samoana',
    eus: 'Samoarra',
    pt: 'Samoana'
  },
  [ENationality.KITTITIAN_NEVISIAN]: {
    es: 'Sancristobaleña',
    en: 'Kittitian/Nevisian',
    cat: 'Cristobalenca',
    eus: 'Saintkittstarra',
    pt: 'São-cristovense'
  },
  [ENationality.SAMMARINESE]: {
    es: 'Sanmarinense',
    en: 'Sammarinese',
    cat: 'San-marinenca',
    eus: 'Sanmarinoarra',
    pt: 'Samarinense'
  },
  [ENationality.SAINT_MARTINER]: {
    es: 'Sanmartinense',
    en: 'Saint Martiner',
    cat: 'Santmartinenca',
    eus: 'Sanmartindarra',
    pt: 'São-martinhense'
  },
  [ENationality.SAINT_LUCIAN]: {
    es: 'Santalucense',
    en: 'Saint Lucian',
    cat: 'Santaluciana',
    eus: 'Santa Luziarra',
    pt: 'Santalucense'
  },
  [ENationality.SAO_TOMEAN]: {
    es: 'Santotomense',
    en: 'Sao Tomean',
    cat: 'Sãotomenca',
    eus: 'Saotometarra',
    pt: 'Santomense'
  },
  [ENationality.SAINT_VINCENTIAN]: {
    es: 'Sanvicentina',
    en: 'Saint Vincentian',
    cat: 'Sanvicentina',
    eus: 'Saintvincenttarra',
    pt: 'São-vicentina'
  },
  [ENationality.SAUDI]: {
    es: 'Saudí',
    en: 'Saudi',
    cat: 'Saudita',
    eus: 'Saudiarabiarra',
    pt: 'Saudita'
  },
  [ENationality.SENEGALESE]: {
    es: 'Senegalesa',
    en: 'Senegalese',
    cat: 'Senegalesa',
    eus: 'Senegaldarra',
    pt: 'Senegalesa'
  },
  [ENationality.SERBIAN]: {
    es: 'Serbia',
    en: 'Serbian',
    cat: 'Sèrbia',
    eus: 'Serbiarra',
    pt: 'Sérvia'
  },
  [ENationality.SEYCHELLOIS]: {
    es: 'Seychellense',
    en: 'Seychellois',
    cat: 'Seychellesa',
    eus: 'Seychelletarra',
    pt: 'Seichelense'
  },
  [ENationality.SIERRA_LEONEAN]: {
    es: 'Sierraleonesa',
    en: 'Sierra Leonean',
    cat: 'Sierraleonesa',
    eus: 'Sierra Leonarra',
    pt: 'Serra-leonesa'
  },
  [ENationality.SINGAPOREAN]: {
    es: 'Singapurense',
    en: 'Singaporean',
    cat: 'Singapuresa',
    eus: 'Singapurtarra',
    pt: 'Singapurense'
  },
  [ENationality.SYRIAN]: {
    es: 'Siria',
    en: 'Syrian',
    cat: 'Siriana',
    eus: 'Siriarra',
    pt: 'Síria'
  },
  [ENationality.SOMALI]: {
    es: 'Somalí',
    en: 'Somali',
    cat: 'Somali',
    eus: 'Somaliarra',
    pt: 'Somali'
  },
  [ENationality.SWAZI]: {
    es: 'Suazi',
    en: 'Swazi',
    cat: 'Swazi',
    eus: 'Swazilandiarra',
    pt: 'Suazi'
  },
  [ENationality.SOUTH_AFRICAN]: {
    es: 'Sudafricana',
    en: 'South African',
    cat: 'Sud-africana',
    eus: 'Hegoafrikarra',
    pt: 'Sul-africana'
  },
  [ENationality.SUDANESE]: {
    es: 'Sudanesa',
    en: 'Sudanese',
    cat: 'Sudanesa',
    eus: 'Sudandarra',
    pt: 'Sudanesa'
  },
  [ENationality.SWEDISH]: {
    es: 'Sueca',
    en: 'Swedish',
    cat: 'Sueca',
    eus: 'Suediarra',
    pt: 'Sueca'
  },
  [ENationality.SWISS]: {
    es: 'Suiza',
    en: 'Swiss',
    cat: 'Suïssa',
    eus: 'Suitzarra',
    pt: 'Suíça'
  },
  [ENationality.SOUTH_KOREAN]: {
    es: 'Surcoreana',
    en: 'South Korean',
    cat: 'Sud-coreana',
    eus: 'Hego Korearra',
    pt: 'Sul-coreana'
  },
  [ENationality.SURINAMESE]: {
    es: 'Surinamesa',
    en: 'Surinamese',
    cat: 'Surinamesa',
    eus: 'Surinamdarra',
    pt: 'Surinamesa'
  },
  [ENationality.SOUTH_SUDANESE]: {
    es: 'Sursudanesa',
    en: 'South Sudanese',
    cat: 'Sud-sudanesa',
    eus: 'Hego Sudandarra',
    pt: 'Sul-sudanesa'
  },
  [ENationality.THAI]: {
    es: 'Tailandesa',
    en: 'Thai',
    cat: 'Tailandesa',
    eus: 'Tailandiarra',
    pt: 'Tailandesa'
  },
  [ENationality.TAIWANESE]: {
    es: 'Taiwanesa',
    en: 'Taiwanese',
    cat: 'Taiwanesa',
    eus: 'Taiwandarra',
    pt: 'Taiwanesa'
  },
  [ENationality.TANZANIAN]: {
    es: 'Tanzana',
    en: 'Tanzanian',
    cat: 'Tanzana',
    eus: 'Tanzaniarra',
    pt: 'Tanzaniana'
  },
  [ENationality.TAJIK]: {
    es: 'Tayika',
    en: 'Tajik',
    cat: 'Tadjik',
    eus: 'Tajikistandarra',
    pt: 'Tadjique'
  },
  [ENationality.TIMORESE]: {
    es: 'Timorense',
    en: 'Timorese',
    cat: 'Timoresa',
    eus: 'Timortarra',
    pt: 'Timorense'
  },
  [ENationality.TOGOLESE]: {
    es: 'Togolesa',
    en: 'Togolese',
    cat: 'Togolesa',
    eus: 'Togoarra',
    pt: 'Togolesa'
  },
  [ENationality.TONGAN]: {
    es: 'Tongana',
    en: 'Tongan',
    cat: 'Tongana',
    eus: 'Tongatarra',
    pt: 'Tonganesa'
  },
  [ENationality.TRINIDADIAN_TOBAGONIAN]: {
    es: 'Trinitense',
    en: 'Trinidadian/Tobagonian',
    cat: 'Trinitenca',
    eus: 'Trinitatearra',
    pt: 'Trinitária'
  },
  [ENationality.TUNISIAN]: {
    es: 'Tunecina',
    en: 'Tunisian',
    cat: 'Tunisiana',
    eus: 'Tunisiarra',
    pt: 'Tunisiana'
  },
  [ENationality.TURKISH]: {
    es: 'Turca',
    en: 'Turkish',
    cat: 'Turca',
    eus: 'Turkiarra',
    pt: 'Turca'
  },
  [ENationality.TURKMEN]: {
    es: 'Turcomana',
    en: 'Turkmen',
    cat: 'Turcmana',
    eus: 'Turkmenistandarra',
    pt: 'Turcomena'
  },
  [ENationality.TUVALUAN]: {
    es: 'Tuvaluana',
    en: 'Tuvaluan',
    cat: 'Tuvaluana',
    eus: 'Tuvaluarra',
    pt: 'Tuvaluana'
  },
  [ENationality.UKRAINIAN]: {
    es: 'Ucraniana',
    en: 'Ukrainian',
    cat: 'Ucraïnesa',
    eus: 'Ukrainarra',
    pt: 'Ucraniana'
  },
  [ENationality.UGANDAN]: {
    es: 'Ugandesa',
    en: 'Ugandan',
    cat: 'Ugandesa',
    eus: 'Ugandarra',
    pt: 'Ugandense'
  },
  [ENationality.URUGUAYAN]: {
    es: 'Uruguaya',
    en: 'Uruguayan',
    cat: 'Uruguaiana',
    eus: 'Uruguaitarra',
    pt: 'Uruguaia'
  },
  [ENationality.UZBEK]: {
    es: 'Uzbeka',
    en: 'Uzbek',
    cat: 'Uzbeka',
    eus: 'Uzbekistandarra',
    pt: 'Uzbeque'
  },
  [ENationality.VANUATUAN]: {
    es: 'Vanuatuense',
    en: 'Vanuatuan',
    cat: 'Vanuatuana',
    eus: 'Vanuatuarra',
    pt: 'Vanuatuense'
  },
  [ENationality.VATICAN]: {
    es: 'Vaticana',
    en: 'Vatican',
    cat: 'Vaticana',
    eus: 'Vatikanoarra',
    pt: 'Vaticana'
  },
  [ENationality.VENEZUELAN]: {
    es: 'Venezolana',
    en: 'Venezuelan',
    cat: 'Veneçolana',
    eus: 'Venezuelarra',
    pt: 'Venezuelana'
  },
  [ENationality.VIETNAMESE]: {
    es: 'Vietnamita',
    en: 'Vietnamese',
    cat: 'Vietnamita',
    eus: 'Vietnamdarra',
    pt: 'Vietnamita'
  },
  [ENationality.YEMENI]: {
    es: 'Yemení',
    en: 'Yemeni',
    cat: 'Iemenita',
    eus: 'Yemendarra',
    pt: 'Iemenita'
  },
  [ENationality.DJIBOUTIAN]: {
    es: 'Yibutiana',
    en: 'Djiboutian',
    cat: 'Djiboutiana',
    eus: 'Djibutiarra',
    pt: 'Djibutiana'
  },
  [ENationality.ZAMBIAN]: {
    es: 'Zambiana',
    en: 'Zambian',
    cat: 'Zambiana',
    eus: 'Zambiarra',
    pt: 'Zambiana'
  },
  [ENationality.ZIMBABWEAN]: {
    es: 'Zimbabuense',
    en: 'Zimbabwean',
    cat: 'Zimbabuesa',
    eus: 'Zimbabweko',
    pt: 'Zimbabuense'
  },
  [EProvinceExtension.OTHER_COUNTRIES]: {
    es: 'Otro país',
    en: 'Other country',
    cat: 'Altres país',
    eus: 'Beste herrialdea',
    pt: 'Outro país'
  },
  STUDENT_DISABLED_TOOLTIP: {
    es: 'Solo se puede desactivar si el estado de pago del usuario es Pagado o Antiguo alumno',
    en: 'Only can be deactivated if the payment status of the user is Paid or Former student',
    cat: "Només es pot desactivar si l'estat de pagament de l'usuari és Pagat o Antigu alumne",
    eus: 'Ordainketa egoera Pagat edo Ohiko ikaslea bada, desaktibatu daiteke',
    pt: 'Só pode ser desativado se o status de pagamento do usuário for Pagado ou Antigo aluno'
  },
  SCHEDULED_DATE_FORMAT: {
    es: '{{dayName}}, {{dayNumber}} de {{month}} a las {{time}}',
    en: '{{dayName}}, {{dayNumber}} {{month}} at {{time}}',
    cat: '{{dayName}}, {{dayNumber}} de {{month}} a les {{time}}',
    eus: '{{dayName}}, {{dayNumber}} {{month}} {{time}}etan',
    pt: '{{dayName}}, {{dayNumber}} de {{month}} às {{time}}'
  }
};
